export default [
  {
    question: '"ชื่อของสารเคมี" อยู่ในส่วนไหนของฉลาก',
    intentname: 'Chapter 1-1_Q1',
    keyword: 'สารเคมี,ฉลากเคมี',
    max_score: 1
  },
  {
    question: '"คำเตือนและข้อควรระวัง" อยู่ส่วนไหนของฉลาก',
    intentname: 'Chapter 1-1_Q2',
    keyword: 'ฉลากเคมี',
    max_score: 1
  },
  {
    question: 'รูปสัญลักษณ์ในส่วนที่ 2 แสดงถึงอะไร',
    intentname: 'Chapter 1-1_Q3',
    keyword: 'ฉลากเคมี,สัญลักษณ์',
    max_score: 1
  },
  {
    question: 'สัญลักษณ์นี้มีความหมายว่าอะไร',
    intentname: 'Chapter 1-1_Q4',
    keyword: 'ฉลากเคมี,สัญลักษณ์',
    max_score: 1
  },
  {
    question: 'สารไวไฟ มีสัญลักษณ์ยังไง',
    intentname: 'Chapter 1-1_Q5',
    keyword: 'ฉลากเคมี',
    max_score: 1
  },
  {
    question: 'สารเคมีที่เป็นอันตรายต่อชีวิต ควรมีสัญลักษณ์ไหนบนขวด',
    intentname: 'Chapter 1-1_Q6',
    keyword: 'ฉลากเคมี\nสัญลักษณ์',
    max_score: 1
  },
  {
    question: 'จากฉลากนี้\nกรดไฮโดรคลอริกมีอันตรายตามระบบ GHS ยังไง',
    intentname: 'Chapter 1-1_Q7',
    keyword: 'ฉลากเคมี',
    max_score: 1
  },
  {
    question: 'สารในข้อไหนเกิดการลุกไหม้ได้ง่าย เมื่อวางใกล้เชื้อเพลิง',
    intentname: 'Chapter 1-1_Q8',
    keyword: 'สารเคมี\nฉลากเคมี',
    max_score: 1
  },
  {
    question:
      'นอกจาก GHS แล้ว ยังมี National Fire Protection Association Hazard Identification System (NFPA)\nเป็นสัญลักษณ์สี่สี มีตัวเลขสื่อความหมาย\n\nรู้มั้ยคะว่า ตัวเลขในช่องสีน้ำเงิน แสดงค่าอะไร',
    intentname: 'Chapter 1-1_Q9',
    keyword: 'สัญลักษณ์',
    max_score: 1
  },
  {
    question: 'สารไหนมี "ความว่องไวในการเกิดปฏิกิริยาเคมี" มากกว่ากัน',
    intentname: 'Chapter 1-1_Q10',
    keyword: 'สารเคมี',
    max_score: 1
  },
  {
    question: 'ระหว่างโพแทสเซียมไฮดรอกไซด์กับแอมโมเนีย สารชนิดใดมี "ความไวไฟ" มากกว่ากัน',
    intentname: 'Chapter 1-1_Q11',
    keyword: 'สารเคมี',
    max_score: 1
  },
  {
    question: 'สีขาวในรูปฉลากนี้หมายความว่ายังไง',
    intentname: 'Chapter 1-1_Q12',
    keyword: 'สัญลักษณ์,สารเคมี',
    max_score: 1
  },
  {
    question:
      'ข้อสุดท้ายก่อนลาจาก\nสัญลักษณ์ NFPA กับ GHS นั้นมีความเกี่ยวข้องกัน\n\nคำถามคือ...\nสัญลักษณ์ในรูปด้านบนเกี่ยวข้องกับฉลากไหน',
    intentname: 'Chapter 1-1_Q13',
    keyword: 'สัญลักษณ์,ฉลากเคมี',
    max_score: 1
  },
  {
    question: 'ข้อมูลใดไม่จำเป็นต้องศึกษาก่อนทำปฏิบัติการ',
    intentname: 'Chapter 1-2_Q1',
    keyword: 'ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'ใครแต่งตัวเหมาะสมในการทำปฏิบัติการ',
    intentname: 'Chapter 1-2_Q2',
    keyword: 'ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นการทำปฏิบัติที่ถูกต้อง',
    intentname: 'Chapter 1-2_Q3',
    keyword: 'ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นการทำปฏิบัติการที่ไม่ถูกต้อง',
    intentname: 'Chapter 1-2_Q4',
    keyword: 'ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'เมื่อเกิดอุบัติเหตุในห้องปฏิบัติการ ต้องแจ้งใคร',
    intentname: 'Chapter 1-2_Q5',
    keyword: 'ปฏิบัติการเคมี,อุบัติเหตุ',
    max_score: 1
  },
  {
    question: 'หากต้องใช้อุปกรณ์ส่วนกลาง ควรทำอย่างไร',
    intentname: 'Chapter 1-2_Q6',
    keyword: 'ปฏิบัติการเคมี\nอุุปกรณ์',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นการทำปฏิบัติที่ถูกต้อง',
    intentname: 'Chapter 1-2_Q7',
    keyword: 'ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'การแบ่งสารเคมีควรทำอย่างไร',
    intentname: 'Chapter 1-2_Q8',
    keyword: 'ปฏิบัติการเคมี,สารเคมี',
    max_score: 1
  },
  {
    question: 'สารเคมีที่เหลือควรจัดการอย่างไร',
    intentname: 'Chapter 1-2_Q9',
    keyword: 'ปฏิบัติการเคมี,สารเคมี',
    max_score: 1
  },
  {
    question: 'กรดไฮโดรคลอริกเข้มข้น 25 mL ควรกำจัดอย่างไร',
    intentname: 'Chapter 1-2_Q10',
    keyword: 'สารเคมี',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 1-3',
    keyword: '',
    max_score: 160
  },
  {
    question: 'หากสารละลายเบสเข้มข้นกระเด็นโดนแขน ควรทำอย่างไรเป็นอันดับแรก',
    intentname: 'Chapter 1-4_Q1',
    keyword: 'สารเคมี',
    max_score: 1
  },
  {
    question: 'สารเคมีสัมผัสร่างกายกรณีใดที่ไม่จำเป็นต้องนำส่งแพทย์',
    intentname: 'Chapter 1-4_Q2',
    keyword: 'ความปลอดภัย,สารเคมี',
    max_score: 1
  },
  {
    question: 'หากสารเคมีที่ไม่ละลายน้ำสัมผัสร่างกาย ควรปฐมพยาบาลด้วยวิธีใด',
    intentname: 'Chapter 1-4_Q3',
    keyword: 'ปฐมพยาบาล,สารเคมี',
    max_score: 1
  },
  {
    question: 'การล้างตาเมื่อสารเคมีเข้าตา ควรทำอย่างไร',
    intentname: 'Chapter 1-4_Q4',
    keyword: 'ความปลอดภัย,สารเคมี',
    max_score: 1
  },
  {
    question: 'ควรปฐมพยาบาลอย่างไร',
    intentname: 'Chapter 1-4_Q5',
    keyword: 'ปฐมพยาบาล,สารเคมี',
    max_score: 1
  },
  {
    question: 'หากมีแก๊สพิษรั่วไหลในห้องปฏิบัติการ ควรทำสิ่งใดเป็นอย่างแรก',
    intentname: 'Chapter 1-4_Q6',
    keyword: 'ความปลอดภัย,สารเคมี',
    max_score: 1
  },
  {
    question: 'หากมีเพื่อนหมดสติในห้องปฏิบัติการเนื่องจากสูดดมแก๊สพิษ ใครควรเป็นผู้เข้าไปช่วยเหลือ',
    intentname: 'Chapter 1-4_Q7',
    keyword: 'ความปลอดภัย,สารเคมี',
    max_score: 1
  },
  {
    question:
      'หากเพื่อนสูดดมแก๊สพิษ หัวใจหยุดเต้นและหยุดหายใจ ผู้ที่ทำการปฐมพยาบาลควรผ่านการฝึกฝนแล้ว แต่ห้ามปฐมพยาบาลด้วยวิธีใด',
    intentname: 'Chapter 1-4_Q8',
    keyword: 'ปฐมพยาบาล',
    max_score: 1
  },
  {
    question: 'การปฐมพยาบาลเมื่อโดนความร้อน ควรทำอะไรเป็นอันดับแรก',
    intentname: 'Chapter 1-4_Q9',
    keyword: 'ปฐมพยาบาล,สารเคมี',
    max_score: 1
  },
  {
    question: 'หากสารเคมีเข้าปาก ควรปฐมพยาบาลอย่างไร',
    intentname: 'Chapter 1-4_Q10',
    keyword: 'ปฐมพยาบาล,สารเคมี',
    max_score: 1
  },
  {
    question: 'หากสัมผัสโต๊ะในห้องปฏิบัติการ แล้วเกิดอาการแสบร้อน ควรปฐมพยาบาลอย่างไร',
    intentname: 'Chapter 1-4_Q11',
    keyword: 'ปฐมพยาบาล,สารเคมี',
    max_score: 1
  },
  {
    question: 'การวัดปริมาณสาร ความน่าเชื่อถือของข้อมูล พิจารณาจากอะไร',
    intentname: 'Chapter 1-5_Q1',
    keyword: 'การวัดปริมาณสาร',
    max_score: 1
  },
  {
    question: 'ความเที่ยงคืออะไร',
    intentname: 'Chapter 1-5_Q2',
    keyword: 'ความเที่ยง',
    max_score: 1
  },
  {
    question: 'ความแม่นคืออะไร',
    intentname: 'Chapter 1-5_Q3',
    keyword: 'ความแม่น',
    max_score: 1
  },
  {
    question: 'จากรูปสามารถอธิบายได้อย่างไร',
    intentname: 'Chapter 1-5_Q4',
    keyword: 'การวัดปริมาณสาร',
    max_score: 1
  },
  {
    question: 'ความเที่ยงสูง ความแม่นต่ำคือข้อใด',
    intentname: 'Chapter 1-5_Q5',
    keyword: 'ความเที่ยง,ความแม่น',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่อุปกรณ์ที่บรรจุสารเคมีที่เป็นของเหลวในปฏิบัติการเคมี',
    intentname: 'Chapter 1-5_Q6',
    keyword: 'อุปกรณ์,ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่เข้าพวก',
    intentname: 'Chapter 1-5_Q7',
    keyword: 'อุปกรณ์,ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'จากรูปคืออุปกรณ์วัดปริมาตรใด',
    intentname: 'Chapter 1-5_Q8',
    keyword: 'อุปกรณ์,ปฏิบัติการเคมี',
    max_score: 1
  },
  {
    question: 'อุปกรณ์ใดมีความแม่นต่ำที่สุด',
    intentname: 'Chapter 1-5_Q9',
    keyword: 'อุปกรณ์,ความแม่น',
    max_score: 1
  },
  {
    question: 'ข้อใดถูกต้องเกี่ยวกับการอ่านปริมาตรของของเหลวให้ถูกวิธี',
    intentname: 'Chapter 1-5_Q10',
    keyword: 'การวัดปริมาณสาร',
    max_score: 1
  },
  {
    question: 'ปริมาตรของของเหลวในกระบอกตวงมีค่าเท่าใด',
    intentname: 'Chapter 1-5_Q11',
    keyword: 'การวัดปริมาณสาร',
    max_score: 1
  },
  {
    question:
      'ปริมาตรเริ่มต้นและปริมาตรสุดท้ายจากการถ่ายเทของเหลวด้วยบิวเรตต์ เป็นดังรูป\nของเหลวที่ถ่ายเทได้มีปริมาตรเท่าใด',
    intentname: 'Chapter 1-5_Q12',
    keyword: 'การวัดปริมาณสาร',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 1-6',
    keyword: '',
    max_score: 160
  },
  {
    question: 'จุดที่ถูกยิงบนเป้าธนู🎯\nเป้าไหนถูกยิงด้วย "ความเที่ยง" มากที่สุด',
    intentname: 'Chapter 1-7_Q1',
    keyword: 'ความเที่ยง',
    max_score: 1
  },
  {
    question: 'เป้าไหนถูกยิงด้วย "ความแม่น" มากที่สุด',
    intentname: 'Chapter 1-7_Q2',
    keyword: 'ความแม่น',
    max_score: 1
  },
  {
    question:
      'พอเข้าใจเรื่องความเที่ยงกับความแม่นแล้ว มาดูตัวเลขจริงๆ เลยดีกว่า\nไดโนเสาร์สองตัวนี้หนักรวมกันเท่าไหร่',
    intentname: 'Chapter 1-7_Q3',
    keyword: 'ความเที่ยง\nความแม่น',
    max_score: 1
  },
  {
    question: 'เวลาบวกหรือลบเลข คำตอบที่ได้จะมาจากอะไร',
    intentname: 'Chapter 1-7_Q4',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: '13.52 - 2.342 เท่ากับเท่าไหร่',
    intentname: 'Chapter 1-7_Q5',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: 'ปัดเลข "3.341" ให้เหลือเลขหลังจุดทศนิยม "2 ตำแหน่ง" หน่อยสิ',
    intentname: 'Chapter 1-7_Q6',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: 'มาลองปัดเลข “2.5583” ให้เหลือเลขหลังจุดทศนิยม "2 ตำแหน่ง" หน่อย',
    intentname: 'Chapter 1-7_Q7',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: 'เลข "5.3551" ลองปัดให้เหลือเลขหลังจุดทศนิยม "2 ตำแหน่ง" หน่อย',
    intentname: 'Chapter 1-7_Q8',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: 'ปัดเลข "4.385" ให้เหลือเลขหลังจุดทศนิยม "2 ตำแหน่ง" หน่อย',
    intentname: 'Chapter 1-7_Q9',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: '0.23 มีเลขนัยสำคัญกี่ตัว',
    intentname: 'Chapter 1-7_Q10',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: '0.0730 มีเลขนัยสำคัญกี่ตัว',
    intentname: 'Chapter 1-7_Q11',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: '100 มีเลขนัยสำคัญกี่ตัว',
    intentname: 'Chapter 1-7_Q12',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: '6.63 x 10⁻³⁴ มีเลขนัยสำคัญกี่ตัว',
    intentname: 'Chapter 1-7_Q13',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: 'รูปสี่เหลี่ยมนี้มีพื้นที่เท่าไหร่',
    intentname: 'Chapter 1-7_Q14',
    keyword: 'หน่วยวัด',
    max_score: 1
  },
  {
    question: 'การคูณการหารเลข คำตอบจะมาจากอะไรเอ่ย',
    intentname: 'Chapter 1-7_Q15',
    keyword: 'เลขนัยสำคัญ',
    max_score: 1
  },
  {
    question: '1 การวัดน้ำหนัก ระบุหน่วยวัดปริมาณเป็นอะไร',
    intentname: 'Chapter 1-8_Q1',
    keyword: 'หน่วยวัด',
    max_score: 1
  },
  {
    question: '2 หน่วยวัดปริมาณต่าง ๆ ในชีวิตประจำวัน ในแต่ละประเทศเหมือนกันหรือต่างกัน',
    intentname: 'Chapter 1-8_Q2',
    keyword: 'หน่่วยวัด',
    max_score: 1
  },
  {
    question:
      '3 ที่ประชุมนานาชาติว่าด้วยการ\nชั่งและการวัด (The General conference on Weights and Measures) ได้ตกลงให้มีหน่วยวัดสากลขึ้น เรียกว่าอะไร',
    intentname: 'Chapter 1-8_Q3',
    keyword: 'หน่วยวัด',
    max_score: 1
  },
  {
    question: '4 หน่วยเอสไอพื้นฐานสามารถนำไปใช้ในการกำหนดเป็นหน่วยอะไรได้อีก',
    intentname: 'Chapter 1-8_Q4',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: '5 หน่วยเอสไอพื้นฐานมีทั้งหมดกี่หน่วย',
    intentname: 'Chapter 1-8_Q5',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: '6  ถ้าจะระบุหน่วยของอุณหภูมิ ตามระบบ SI ควรจะเป็นหน่วยใด',
    intentname: 'Chapter 1-8_Q6',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: '7  สัญลักษณ์ของหน่วย เคลวิน คือข้อใด',
    intentname: 'Chapter 1-8_Q7',
    keyword: 'หน่วยวัด',
    max_score: 1
  },
  {
    question: '8  เอสไออนุพันธ์ของหน่วยความเข้มข้น คือข้อใด',
    intentname: 'Chapter 1-8_Q8',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: '9 นอกจากหน่วยในระบบเอสไอแล้ว ยังมีหน่วยนอกระบบเอสไอที่ใช้ในทางเคมี เช่นหน่วยใดบ้าง',
    intentname: 'Chapter 1-8_Q9',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: '10 หน่วยความดัน นอกระบบเอสไอ คือข้อใด',
    intentname: 'Chapter 1-8_Q10',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: '11 หน่วยมิลลิเมตรปรอท เทียบกับหน่วยเอสไอพื้นฐานได้เท่าไร',
    intentname: 'Chapter 1-8_Q11',
    keyword: 'หน่วยวัด,หน่วยเอสไอ',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 1-9',
    keyword: '',
    max_score: 160
  },
  {
    question: 'boss',
    intentname: 'Chapter 1-10',
    keyword: '',
    max_score: 165
  },
  {
    question: 'หน่วนที่เล็กที่สุดของอนุภาคต่างๆ คืออะไร',
    intentname: 'Chapter 2-1_Q1',
    keyword: 'อะตอม',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่สาระสำคัญของทฤษฎีอะตอมของดอลตัน',
    intentname: 'Chapter 2-1_Q2',
    keyword: 'อะตอม',
    max_score: 1
  },
  {
    question: 'ข้อใดคือแบบจำลองอะตอมของดอลตัน',
    intentname: 'Chapter 2-1_Q3',
    keyword: 'แบบจำลองอะตอม',
    max_score: 1
  },
  {
    question: 'ข้อใดถูกต้องเกี่ยวกับการทดลองของทอมสัน',
    intentname: 'Chapter 2-1_Q4',
    keyword: 'รังสีแคโทด',
    max_score: 1
  },
  {
    question: 'รังสีแคโทด คือ อนุภาคชนิดใด',
    intentname: 'Chapter 2-1_Q5',
    keyword: 'รังสีแคโทด,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ข้อใดคือแบบจำลองอะตอมของทอมสัน',
    intentname: 'Chapter 2-1_Q6',
    keyword: 'แบบจำลองอะตอม',
    max_score: 1
  },
  {
    question: 'ข้อใดถูกต้องเกี่ยวกับ การทดลองของรัทเทอร์ฟอร์ด',
    intentname: 'Chapter 2-1_Q7',
    keyword: 'แบบจำลองอะตอม',
    max_score: 1
  },
  {
    question: 'การทดลองของรัทเทอร์ฟอร์ดอธิบายลักษณะภายในอะตอมอย่างไร',
    intentname: 'Chapter 2-1_Q8',
    keyword: 'อะตอม,รังสีแอลฟา',
    max_score: 1
  },
  {
    question: 'ข้อใดคือแบบจำลองอะตอม\nของรัทเทอร์ฟอร์ด',
    intentname: 'Chapter 2-1_Q9',
    keyword: 'แบบจำลองอะตอม,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ผลการทดลองของรัทเทอร์ฟอร์ดแสดงเป็นรุปได้อย่างไร',
    intentname: 'Chapter 2-1_Q10',
    keyword: 'แบบจำลองอะตอม,รังสีแอลฟา',
    max_score: 1
  },
  {
    question: 'แบบจำลองอะตอมของรัทเทอร์ฟอร์ด ไม่ได้อธิบายเกี่ยวกับสิ่งใด',
    intentname: 'Chapter 2-1_Q11',
    keyword: 'แบบจำลองอะตอม,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'เมื่อให้แสงขาวส่องผ่านอุปกรณ์ใด แสงขาวจะแยกออกเป็นแถบสีรุ้งต่อเนื่องกัน',
    intentname: 'Chapter 2-2_Q1',
    keyword: 'สเปกตรัม,ปริซึม',
    max_score: 1
  },
  {
    question: 'สเปกตรัมของแสงขาวเป็นแถบสีรุ้งต่อเนื่องกัน  แล้วสเปกตรัมของธาตุจะมีลักษณะยังไง',
    intentname: 'Chapter 2-2_Q2',
    keyword: 'สเปกตรัม',
    max_score: 1
  },
  {
    question: 'การที่ธาตุได้รับพลังงานแล้วเปล่งแสงเป็นสีต่างๆ เกิดจากการคายพลังงานของอนุภาคใด',
    intentname: 'Chapter 2-2_Q3',
    keyword: 'อิเล็กตรอน',
    max_score: 1
  },
  {
    question:
      'อะตอมที่อิเล็กตรอนซึ่งเคลื่อนที่อยู่รอบนิวเคลียสมีพลังงานเฉพาะตัวที่ต่ำ เรียกว่า อยู่ในสถานะอะไร',
    intentname: 'Chapter 2-2_Q4',
    keyword: 'สถานะพื้น',
    max_score: 1
  },
  {
    question: 'อะตอมในสถานะพื้นหรือในสถานะกระตุ้น มีความเสถียรมากกว่ากัน',
    intentname: 'Chapter 2-2_Q5',
    keyword: 'สถากระตุ้น',
    max_score: 1
  },
  {
    question:
      'นักวิทยาศาสตร์ ศึกษาเส้นสเปกตรัมของอะตอมไฮโดรเจน ซึ่งมี 1 อิเล็กตรอน มีเส้นสเปกตรัมในช่วงที่มองเห็นได้กี่เส้น',
    intentname: 'Chapter 2-2_Q6',
    keyword: 'ระดับพลังงาน,สเปกตรัม',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่ข้อสรุปที่ได้จากการศึกษาเส้นสเปกตรัมของอะตอมไฮโดรเจน',
    intentname: 'Chapter 2-2_Q7',
    keyword: 'ระดับพลังงาน,สเปกตรัม',
    max_score: 1
  },
  {
    question: 'ข้อใดคือแบบจำลองอะตอมของโบร์',
    intentname: 'Chapter 2-2_Q8',
    keyword: 'แบบจำลองอะตอม',
    max_score: 1
  },
  {
    question: 'อิเล็กตรอนมีเป็นสมบัติอย่างไร',
    intentname: 'Chapter 2-2_Q9',
    keyword: 'อิเล็กตรอน,อนุภาค',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่ลักษณะการเคลื่อนที่ของอิเล็กตรอน',
    intentname: 'Chapter 2-2_Q10',
    keyword: 'อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'บริเวณกลุ่มหมอกทึบแสดงถึงอะไร',
    intentname: 'Chapter 2-2_Q11',
    keyword: 'อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ข้อใดถูกต้องเกี่ยวกับการทดลองของมิลลิแกน',
    intentname: 'Chapter 2-3_Q1',
    keyword: 'อิเล็กตรอน,สนามไฟฟ้า',
    max_score: 1
  },
  {
    question: 'การทดลองของมิลลิแกนทำให้ได้ข้อมูลใด',
    intentname: 'Chapter 2-3_Q2',
    keyword: 'อิเล็กตรอน,ประจุ',
    max_score: 1
  },
  {
    question: 'ประจุของอิเล็กตรอนมีค่าเท่าไหร่',
    intentname: 'Chapter 2-3_Q3',
    keyword: 'อิเล็กตรอน,ประจุ',
    max_score: 1
  },
  {
    question: 'ออยเกน โกลด์ชไตน์ ค้นพบอะไรจากการทดลองนี้',
    intentname: 'Chapter 2-3_Q4',
    keyword: 'โปรตอน',
    max_score: 1
  },
  {
    question:
      'เจมส์ แชดวิก ทดลองยิงอนุภาคแอลฟาไปยังอะตอมของธาตุต่าง ๆ และทดสอบผลการทดลองด้วยเครื่องมือที่มีความเที่ยงสูง พบว่าในอะตอมมีอนุภาคอีกชนิดหนึ่ง ข้อใดไม่ถูกต้องเกี่ยวกับอนุภาคในอะตอมที่ค้นพบจากการทดลองของแชดวิก',
    intentname: 'Chapter 2-3_Q5',
    keyword: 'นิวตรอน,อนุภาคแอลฟา',
    max_score: 1
  },
  {
    question: 'อะตอมของธาตุแต่ละชนิดจะมีจำนวนอนุภาคใดเป็นค่าเฉพาะตัวที่ไม่ซ้ำกับธาตุอื่น',
    intentname: 'Chapter 2-3_Q6',
    keyword: 'โปรตอน',
    max_score: 1
  },
  {
    question: 'ตัวเลขที่แสดงจำนวนโปรตอนซึ่งเป็นค่าเฉพาะตัวของธาตุแต่ละชนิด เรียกว่าอะไร',
    intentname: 'Chapter 2-3_Q7',
    keyword: 'เลขอะตอม,โปรตอน',
    max_score: 1
  },
  {
    question: 'อาร์กอนมี 18 โปรตอน และมีเลขมวลเท่ากับ 40 อาร์กอนมีนิวตรอนเท่าไร',
    intentname: 'Chapter 2-3_Q8',
    keyword: 'นิวตรอน,เลขมวล',
    max_score: 1
  },
  {
    question:
      'สัญลักษณ์ที่เขียนแสดงรายละเอียดเกี่ยวกับสัญลักษณ์ของธาตุ เลขอะตอม และเลขมวลของอะตอม เรียกว่า  สัญลักษณ์นิวเคลียร์  ข้อใดเป็นสัญลักษณ์นิวเคลียร์ที่ตกลงกันเป็นสากล',
    intentname: 'Chapter 2-3_Q9',
    keyword: 'สัญลักษณ์นิวเคลียส,เลขอะตอม',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นสัญลักษณ์นิวเคลียร์ของแมงกานีส ซึ่งมี 25 อิเล็กตรอน 30 นิวตรอน',
    intentname: 'Chapter 2-3_Q10',
    keyword: 'สัญลักษณ์นิวเคลียส',
    max_score: 1
  },
  {
    question: 'อะตอมของธาตุเดียวกันที่มีเลขมวลต่างกัน เรียกว่าอะไร',
    intentname: 'Chapter 2-3_Q11',
    keyword: 'ไอโซโทป,เลขมวล',
    max_score: 1
  },
  {
    question: 'ธาตุใดไม่ได้เป็นไอโซโทปกับธาตุอีก 2 ชนิด',
    intentname: 'Chapter 2-3_Q12',
    keyword: 'ไอโซโทป',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 2-4',
    keyword: '',
    max_score: 160
  },
  {
    question: 'แบบจำลองอะตอมของโบว์แตกต่างจากแบบจำลองอะตอมของรัทเทอร์ฟอร์ดอย่างไร',
    intentname: 'Chapter 2-5_Q1',
    keyword: 'อิเล็กตรอน,แบบจำลองอะตอม',
    max_score: 1
  },
  {
    question: 'จำนวนอิเล็กตรอนในระดับพลังงานที่ 1 และ ระดับพลังงานที่ 2 มีได้มากที่สุดเท่าใด',
    intentname: 'Chapter 2-5_Q2',
    keyword: 'ระดับพลังงาน',
    max_score: 1
  },
  {
    question:
      'ถ้าในระดับพลังงานที่ 3 มีจำนวนอิเล็กตรอนสุงสุด 18 อิเล็กตรอน ระดับพลังงานกับจำนวนอิเล็กตรอนสูงสุดในแต่ละระดับพลังงานมีความสัมพันธ์กันหรือ ไม่ อย่างไร',
    intentname: 'Chapter 2-5_Q3',
    keyword: 'ระดับพลังงาน,อิเล็กตรอน',
    max_score: 1
  },
  {
    question:
      'ถ้าพิจารณาตามหลัก 2n2 การจัดเรียงอิเล็กตรอนของธาตุ  K  และ Ca  ควรเป็นอย่างไร ตามลำดับ',
    intentname: 'Chapter 2-5_Q4',
    keyword: '2n²,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'โดยความแตกต่างของระดับพลังงานจะเป็นอย่างไร',
    intentname: 'Chapter 2-5_Q5',
    keyword: 'ระดับพลังงาน',
    max_score: 1
  },
  {
    question:
      'จากรูปแผนภาพระดับพลังงานของอะตอมที่มีหลายอิเล็กตรอน ที่ระดับพลังงาน n=1 มีกี่ระดับพลังงานย่อย อะไรบ้าง',
    intentname: 'Chapter 2-5_Q6',
    keyword: 'ระดับพลังงานย่อย,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ระดับพลังงานหลัก n=2 มีกี่ระดับพลังงานย่อย อะไรบ้าง',
    intentname: 'Chapter 2-5_Q7',
    keyword: 'ระดับพลังงานหลัก',
    max_score: 1
  },
  {
    question: 'ระดับพลังงานหลัก n=4 มีพลังงานย่อย อะไรบ้าง',
    intentname: 'Chapter 2-5_Q8',
    keyword: 'ระดับพลังงานหลัก',
    max_score: 1
  },
  {
    question: 'ระดับพลังงานย่อยในระดับพลังงานหลักเดียวกันเช่น n=2 จะมีค่าพลังงานเป็นอย่างไร',
    intentname: 'Chapter 2-5_Q9',
    keyword: 'ระดับพลังงานย่อย',
    max_score: 1
  },
  {
    question: 'ลำดับระดับพลังงานที่บรรจุอิเล็กตรอนต้องเรียงตามพลังงานหลักเสมอ ใช่หรือไม่',
    intentname: 'Chapter 2-5_Q10',
    keyword: 'ระดับพลังงานหลัก,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ถ้าอิเล็กตรอนมีการเคลื่อนที่ตลอดเวลา ความหนาแน่นของกลุ่มหมอกอิเล็กตรอนจะเป็นอย่างไร',
    intentname: 'Chapter 2-6_Q1',
    keyword: 'ออร์บิทัล,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ถ้า ระดับพลังงานหลัก n=1 จะมีระดับพลังงานย่อย คืออะไร',
    intentname: 'Chapter 2-6_Q2',
    keyword: 'ระดับพลังงานย่อย',
    max_score: 1
  },
  {
    question: 'ถ้า ระดับพลังงานหลัก n=1 จำนวนอิเล็กตรอนสูงสุดในระดับพลังงานย่อย มีค่าเท่าใด',
    intentname: 'Chapter 2-6_Q3',
    keyword: 'ระดับพลังงานย่อย,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'จำนวนอิเล็กตรอนสูงสุดที่สามารถบรรจุได้ในแต่ละออร์บิทัลมีจำนวนเท่าใด',
    intentname: 'Chapter 2-6_Q4',
    keyword: 'ออร์บิทัล,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'จากแผนภาพนี้ น้องๆสามารถบรรจุอิเล็กตรอนในออร์บิทัล ตามลำดับ ได้เป็นอย่างไรบ้าง',
    intentname: 'Chapter 2-6_Q5',
    keyword: 'ออร์บิทัล',
    max_score: 1
  },
  {
    question: 'การบรรจุอิเล็กตรอนในออร์บิทัล ต่อจาก 1s 2s 2p คืออะไร',
    intentname: 'Chapter 2-6_Q6',
    keyword: 'ออร์บิทัล,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ธาตุฮีเลียม ซึ่งแทนด้วย [Ne] มีการจัดเรียงอิเล็กตรอนคืออะไร',
    intentname: 'Chapter 2-6_Q7',
    keyword: 'หลักอาฟบาว,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ธาตุ Cu มีเลขอะตอม 29 มีการบรรจุอิเล็กตรอนในออร์บิทัล เป็นอย่างไร',
    intentname: 'Chapter 2-6_Q8',
    keyword: 'ออร์บิทัล,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ถ้าเป็น N- จะเขียนการจัดเรียงอิเล็กตรอนได้อย่างไร',
    intentname: 'Chapter 2-6_Q9',
    keyword: 'หลักอาฟบาว,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'Cl- จะเขียนการจัดเรียงอิเล็กตรอนได้อย่างไร',
    intentname: 'Chapter 2-6_Q10',
    keyword: 'หลักอาฟบาว,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ถ้าเป็น Fe2+  จะเขียนการจัดเรียงอิเล็กตรอนได้อย่างไร',
    intentname: 'Chapter 2-6_Q11',
    keyword: 'หลักอาฟบาว,อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใดจึงต้องจัดธาตุเป็นหมวดหมู่',
    intentname: 'Chapter 2-7_Q1',
    keyword: 'ตารางธาตุ',
    max_score: 1
  },
  {
    question: 'ถ้าใช้เกณฑ์การจัดกลุ่มแตกต่างกัน จะได้ธาตุในกลุ่มเหมือนกันหรือไม่',
    intentname: 'Chapter 2-7_Q2',
    keyword: 'ตารางธาตุ',
    max_score: 1
  },
  {
    question: 'ชุดสาม (triads) คือการจัดธาตุอย่างไร',
    intentname: 'Chapter 2-7_Q3',
    keyword: 'ชุดสาม,ตารางธาตุ',
    max_score: 1
  },
  {
    question: 'นิวแลนด์ ได้เสนอแนวคิดเกี่ยวกับการจัดเรียงธาตุว่าอย่างไร',
    intentname: 'Chapter 2-7_Q4',
    keyword: 'มวลอะตอม,ตารางธาตุ',
    max_score: 1
  },
  {
    question: 'กฎพิริออดิก (periodic law) คืออะไร',
    intentname: 'Chapter 2-7_Q5',
    keyword: 'กฎพิริออดิก',
    max_score: 1
  },
  {
    question:
      'ตารางธาตุใน ปัจจุบันจึงปรับปรุงมาจากตารางธาตุของเมนเดเลเอฟ แต่มีการจัดเรียงเป็นอย่างไร',
    intentname: 'Chapter 2-7_Q6',
    keyword: 'เมนเดเลเอฟ,มวลอะตอม',
    max_score: 1
  },
  {
    question: 'ตารางธาตุมี 2 ระบบคืออะไรบ้าง',
    intentname: 'Chapter 2-7_Q7',
    keyword: 'IUPAC',
    max_score: 1
  },
  {
    question: 'หมู่และคาบ คืออะไร',
    intentname: 'Chapter 2-7_Q8',
    keyword: 'แถว',
    max_score: 1
  },
  {
    question: 'คาบไหนมีจำนวนของธาตุน้อยที่สุด',
    intentname: 'Chapter 2-7_Q9',
    keyword: 'คาบ',
    max_score: 1
  },
  {
    question: 'ธาตุในกรอบสี่เหลี่ยมมีข้อมูลอะไรบ้าง',
    intentname: 'Chapter 2-7_Q10',
    keyword: 'ตารางธาตุ,สัญลักษณ์ธาตุ',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 2-8',
    keyword: '',
    max_score: 160
  },
  {
    question: 'น้องๆคิดว่า ข้อใดไม่ใช่เหตุผลที่ทำให้เราวัดขนาดอะตอมที่เป็นอะตอมเดี่ยวได้ยาก',
    intentname: 'Chapter 2-9_Q1',
    keyword: 'ขนาดอะตอม',
    max_score: 1
  },
  {
    question: 'รัศมีอะตอม มีค่าเท่ากับเท่าไหร่',
    intentname: 'Chapter 2-9_Q2',
    keyword: 'รัศมีอะตอม',
    max_score: 1
  },
  {
    question:
      'ถ้าเปรียบเทียบขนาดอะตอมของธาตุที่อยู่ในคาบเดียวกัน น้องๆคิดว่าขนาดอะตอมมีแนวโน้มยังไงคะ',
    intentname: 'Chapter 2-9_Q3',
    keyword: 'ขนาดอะตอม',
    max_score: 1
  },
  {
    question:
      'ถ้าเปรียบเทียบขนาดอะตอมของธาตุที่อยู่ในหมู่เดียวกัน น้องๆคิดว่าขนาดอะตอมมีแนวโน้มยังไงคะ',
    intentname: 'Chapter 2-9_Q4',
    keyword: 'ขนาดอะตอม',
    max_score: 1
  },
  {
    question:
      'N และ P เป็นธาตุในหมู่เดียวกัน โดย N อยู่คาบ 2 ส่วน P อยู่คาบ 3 ธาตุใดมีขนาดใหญ่กว่า',
    intentname: 'Chapter 2-9_Q5',
    keyword: 'ขนาดอะตอม',
    max_score: 1
  },
  {
    question:
      'ธาตุ B และ C อยู่ในคาบเดียวกัน B มี 5 โปรตอน ส่วน C มี 6 โปรตอน ธาตุใดมีขนาดใหญ่กว่า',
    intentname: 'Chapter 2-9_Q6',
    keyword: 'ขนาดอะตอม,คาบ',
    max_score: 1
  },
  {
    question: 'เมื่ออะตอมเสียอิเล็กตรอนออกไป จะกลายเป็นไอออนใด',
    intentname: 'Chapter 2-9_Q7',
    keyword: 'ขนาดไอออน',
    max_score: 1
  },
  {
    question: 'รัศมีของไอออน มีค่าเท่าไหร่',
    intentname: 'Chapter 2-9_Q8',
    keyword: 'รัศมีไอออน',
    max_score: 1
  },
  {
    question: 'ถ้าเปรียบเทียบรัศมีไอออนบวกกับรัศมีอะตอม น้องๆคิดว่าเป็นยังไงคะ',
    intentname: 'Chapter 2-9_Q9',
    keyword: 'รัศมีอะตอม',
    max_score: 1
  },
  {
    question: 'ถ้าเปรียบเทียบรัศมีไอออนลบกับรัศมีอะตอม น้องๆคิดว่าเป็นยังไงคะ',
    intentname: 'Chapter 2-9_Q10',
    keyword: 'รัศมีอะตอม,รัศมีไอออนลบ',
    max_score: 1
  },
  {
    question: 'Mg²+ กับ Ca²+ ไอออนใดมีขนาดใหญ่กว่า',
    intentname: 'Chapter 2-9_Q11',
    keyword: 'ขนาดไอออน',
    max_score: 1
  },
  {
    question: 'S²- กับ  Cl- ไอออนใดมีขนาดใหญ่กว่า',
    intentname: 'Chapter 2-9_Q12',
    keyword: 'ขนาดไอออน',
    max_score: 1
  },
  {
    question: 'F- กับ  Na+ ไอออนใดมีขนาดใหญ่กว่า',
    intentname: 'Chapter 2-9_Q13',
    keyword: 'ขนาดไอออน',
    max_score: 1
  },
  {
    question: 'พลังงานน้อยที่สุดที่ทำให้อิเล็กตรอนหลุดจากอะตอมในสถานะแก๊ส คือข้อใด',
    intentname: 'Chapter 2-10_Q1',
    keyword: 'พลังงานไอออไนเซชัน,IE',
    max_score: 1
  },
  {
    question: 'พลังงานไอออไนเซชัน (IE) บ่งบอกถึงอะไร',
    intentname: 'Chapter 2-10_Q2',
    keyword: 'พลังงานไอออไนเซชัน,IE',
    max_score: 1
  },
  {
    question: 'ตัวอย่างค่า IE ของธาตุคาร์บอน ค่า IE คู่ใด มีค่าต่างกันมากที่สุด',
    intentname: 'Chapter 2-10_Q3',
    keyword: 'พลังงานไอออไนเซชัน,IE',
    max_score: 1
  },
  {
    question: 'ถ้าเปรียบเทียบ IE1 ของธาตุตามคาบ น้องๆคิดว่า IE1 มีแนวโน้มยังไงคะ',
    intentname: 'Chapter 2-10_Q4',
    keyword: 'พลังงานไอออไนเซชัน,IE',
    max_score: 1
  },
  {
    question: 'น้องๆคิดว่า IE1 มีแนวโน้มของธาตุตามหมู่ยังไงคะ',
    intentname: 'Chapter 2-10_Q5',
    keyword: 'พลังงานไอออไนเซชัน,IE',
    max_score: 1
  },
  {
    question: 'ธาตุ A มีค่า IE1 - IE4 เท่ากับ 500  4,600  6,900  9,500 ธาตุ A เป็นธาตุหมู่ใด',
    intentname: 'Chapter 2-10_Q6',
    keyword: 'พลังงานไอออไนเซชัน,IE',
    max_score: 1
  },
  {
    question: 'ความสามารถในการรับอิเล็กตรอนของอะตอมของธาตุในสถานะแก๊ส คือข้อใด',
    intentname: 'Chapter 2-10_Q7',
    keyword: 'สัมพรรคภาพอิเล็กตรอน,EA',
    max_score: 1
  },
  {
    question: 'ถ้าเปรียบเทียบ EA ของธาตุตามคาบ น้องๆคิดว่า แนวโน้ม EA เป็นยังไงคะ',
    intentname: 'Chapter 2-10_Q8',
    keyword: 'สัมพรรคภาพอิเล็กตรอน,EA',
    max_score: 1
  },
  {
    question: 'ธาตุหมู๋ไหนมีค่า EA สูงที่สุดคะ',
    intentname: 'Chapter 2-10_Q9',
    keyword: 'สัมพรรคภาพอิเล็กตรอน,EA',
    max_score: 1
  },
  {
    question: 'ความสามารถของอะตอมในการดึงดูดอิเล็กตรอนคู่ที่ใช้ร่วมกันในโมเลกุลของสาร คือข้อใด',
    intentname: 'Chapter 2-10_Q10',
    keyword: 'อิเล็กโทรเนกาติวิตี,EN',
    max_score: 1
  },
  {
    question: 'ถ้าเปรียบเทียบ EN ของธาตุตามคาบน้องๆคิดว่า EN มีแนวโน้มยังไงคะ',
    intentname: 'Chapter 2-10_Q11',
    keyword: 'EN',
    max_score: 1
  },
  {
    question: 'ในคาบเดียวกันธาตุหมู่ใดมี EN สูงสุด',
    intentname: 'Chapter 2-10_Q12',
    keyword: 'อิเล็กโทรเนกาติวิตี,EN',
    max_score: 1
  },
  {
    question: 'ถ้าเปรียบเทียบ EN ของธาตุตามหมู่น้องๆคิดว่า EN มีแนวโน้มยังไงคะ',
    intentname: 'Chapter 2-10_Q13',
    keyword: 'อิเล็กโทรเนกาติวิตี,EN',
    max_score: 1
  },
  {
    question: 'แนวโน้มสมบัติต่างๆของธาตุในหมู่หลักที่ได้เรียนไปแล้วนั้น ไม่รวมถึงธาตุในกลุ่มใด',
    intentname: 'Chapter 2-11_Q1',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'ระดับพลังงานย่อยใดที่อิเล็กตรอนของธาตุหมู่หลักและธาตุแทรนซิจันบรรจุไว้เหมือนกัน',
    intentname: 'Chapter 2-11_Q2',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'ธาตุแทรนซิชัน เป็นธาตุที่มีสมบัติเป็นอย่างไร',
    intentname: 'Chapter 2-11_Q3',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่สมบัติของธาตุแทรนซิชันที่คล้ายกับโลหะหมู่หลักในคาบเดียวกัน',
    intentname: 'Chapter 2-11_Q4',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question:
      'ถ้าเปรียบเทียบขนาดอะตอมของธาตุแทรนซิชันที่อยู่ในคาบเดียวกัน น้องๆคิดว่าขนาดอะตอมมีแนวโน้มยังไงคะ',
    intentname: 'Chapter 2-11_Q5',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question:
      'ระดับพลังงานย่อยที่บรรจุไว้อิเล็กตรอนตัวสุดท้ายของธาตุแทรนซิชัน คือระดับพลังงานย่อยใด',
    intentname: 'Chapter 2-11_Q6',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question:
      'ธาตุแทรนซิชันมีอิเล็กตรอนตัวสุดท้ายบรรจุอยู่ในระดับพลังงานย่อย d  ทำให้ขนาดอะตอมลดลงเพียงเล็กน้อยและไม่แตกต่างกันอย่างชัดเจนเหมือนธาตุหมู่หลัก เพราะเหตุใด',
    intentname: 'Chapter 2-11_Q7',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'สมบัติที่แตกต่างกันระหว่างโลหะหมู่หลักและโลหะแทรนซิชัน คือข้อใด',
    intentname: 'Chapter 2-11_Q8',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'Na2CoCl4 ที่มีสีหรือไม่อย่างไร',
    intentname: 'Chapter 2-11_Q9',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'ถ้านำโลหะ Na Mg และ Cu มาทำปฏิกิริยากับน้ำ โลหะใดทำปฏิกิริยากับน้ำรุนแรงที่สุด',
    intentname: 'Chapter 2-11_Q10',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'การทดสอบผลิตภัณฑ์ว่าเป็นแก๊สไฮโดรเจนทำได้อย่างไร',
    intentname: 'Chapter 2-11_Q11',
    keyword: 'แทรนซิชัน',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 2-12',
    keyword: '',
    max_score: 160
  },
  {
    question: 'น้องบอกพี่หน่อยว่า กัมมันตภาพรังสี  (radioactivity) คืออะไร',
    intentname: 'Chapter 2-13_Q1',
    keyword: 'กัมมันตภาพรังสี',
    max_score: 1
  },
  {
    question: 'กัมมันตภาพรังสี มีการเปลี่ยนแปลงอย่างไร',
    intentname: 'Chapter 2-13_Q2',
    keyword: 'กัมมันตภาพรังสี',
    max_score: 1
  },
  {
    question: 'ไอโซโทปกัมมันตรังสี คืออะไร',
    intentname: 'Chapter 2-13_Q3',
    keyword: 'ไอโซโทปกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'ธาตุกัมมันตรังสี คืออะไร',
    intentname: 'Chapter 2-13_Q4',
    keyword: 'ไอโซโทปกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'งั้นตอบพี่หน่อยว่า รังสีแอลฟามีสัญลักษณ์อะไร และมีสมบัติการทะลุทะลวงเป็นอย่างไร',
    intentname: 'Chapter 2-13_Q5',
    keyword: 'รังสีแอลฟา',
    max_score: 1
  },
  {
    question: 'ให้เรียงลำดับอำนาจการทะลุทะลวงของรังสี จากสูงไปต่ำ',
    intentname: 'Chapter 2-13_Q6',
    keyword: 'การแผ่รังสี',
    max_score: 1
  },
  {
    question: 'การแผ่รังสีของธาตุแล้วเกิดเป็นนิวเคลียสของธาตุใหม่ที่เสถียรกว่า เพราะเหตุใด',
    intentname: 'Chapter 2-13_Q7',
    keyword: 'การแผ่รังสี',
    max_score: 1
  },
  {
    question: 'ถ้าเป็นธาตุ               จะเกิดการแผ่รังสีอย่างไร \nแก้ไขตัวเลขบน Ra เป็น 226',
    intentname: 'Chapter 2-13_Q8',
    keyword: 'รังสีแอลฟา',
    max_score: 1
  },
  {
    question: 'ถ้าเป็นธาตุ               จะเกิดการแผ่รังสีอย่างไร',
    intentname: 'Chapter 2-13_Q9',
    keyword: 'รังสีบีตา',
    max_score: 1
  },
  {
    question: 'ถ้าเป็นธาตุ               จะเกิดการแผ่รังสีอย่างไร',
    intentname: 'Chapter 2-13_Q10',
    keyword: 'รังสีแกมมา',
    max_score: 1
  },
  {
    question: 'แถบเสถียรภาพ คืออะไร',
    intentname: 'Chapter 2-13_Q11',
    keyword: 'แถบเสถียรภาพ',
    max_score: 1
  },
  {
    question: '226 88Ra  แผ่รังอะไร เพราะเหตุใด',
    intentname: 'Chapter 2-13_Q12',
    keyword: 'การแผ่รังสี',
    max_score: 1
  },
  {
    question: '28 13Al  และ 99 52Te  ธาตุใดแผ่รังสีแกมมา\nเพราะเหตุใด',
    intentname: 'Chapter 2-13_Q13',
    keyword: 'รังสีบีตา',
    max_score: 1
  },
  {
    question: 'น้องๆ อาจจะได้รับรังสีเข้าสู่ร่างกายมากที่สุดจากแหล่งใด',
    intentname: 'Chapter 2-14_Q1',
    keyword: 'อันตราย',
    max_score: 1
  },
  {
    question: 'สัญลักษณ์รังสี คือรุปไหนนะ',
    intentname: 'Chapter 2-14_Q2',
    keyword: 'สัญลักษณ์รังสี',
    max_score: 1
  },
  {
    question: 'สัญลักษณ์รังสีปัจจุบันคือรูปใด',
    intentname: 'Chapter 2-14_Q3',
    keyword: 'สัญลักษณ์รังสี',
    max_score: 1
  },
  {
    question: 'ถ้าน้องๆไปโรงพยาบาล อาจจะพบเจอ  สัญลักษณ์รังสี ที่ห้องใด',
    intentname: 'Chapter 2-14_Q4',
    keyword: 'สัญลักษณ์รังสี',
    max_score: 1
  },
  {
    question: 'ครึ่งชีวิตหมายถึงอะไร',
    intentname: 'Chapter 2-14_Q5',
    keyword: 'ครึ่งชีวิต',
    max_score: 1
  },
  {
    question: 'สัญลักษณ์ของครึ่งชีวิตคืออะไร',
    intentname: 'Chapter 2-14_Q6',
    keyword: 'ครึ่งชีวิต',
    max_score: 1
  },
  {
    question: 'ถ้าเวลาผ่านไปอีก 15 ชั่วโมง จะมี Na-24 เหลืออยู่กี่กรัม',
    intentname: 'Chapter 2-14_Q7',
    keyword: 'ไอโซโทปกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'เมื่อเวลาผ่านไปปริมาณของ Na-24 และ Mg-24 มีการเปลี่ยนแปลงอย่างไร',
    intentname: 'Chapter 2-14_Q8',
    keyword: 'ไอโซโทปกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'ถ้าผ่านไป 60 ชั่วโมง จากจุดเริ่มต้น จะเหลือ Na-24 อยู่ร้อยละเท่าใด',
    intentname: 'Chapter 2-14_Q9',
    keyword: 'ไอโซโทปกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'หาค่ามวลไอโซโทปเริ่มต้น แทนค่าในสูตร',
    intentname: 'Chapter 2-14_Q10',
    keyword: 'ไอโซโทปกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'น้องๆ คิดว่าปฏิกิริยาเคมีกับปฏิกิริยานิวเคลียร์แตกต่างกันอย่างไร',
    intentname: 'Chapter 2-15_Q1',
    keyword: 'ปฏิกิริยานิวเคลียร์',
    max_score: 1
  },
  {
    question: 'ฟิชชันคืออะไร',
    intentname: 'Chapter 2-15_Q2',
    keyword: 'ฟิชชัน',
    max_score: 1
  },
  {
    question: 'ปฏิกิริยาลูกโซ่ เกิดได้อย่างไร',
    intentname: 'Chapter 2-15_Q3',
    keyword: 'ปฏิกิริยาลูกโซ่',
    max_score: 1
  },
  {
    question: 'ฟิวชันคืออะไร',
    intentname: 'Chapter 2-15_Q4',
    keyword: 'ฟิวชัน',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่ข้อดีของฟิวชัน',
    intentname: 'Chapter 2-15_Q5',
    keyword: 'ฟิวชัน',
    max_score: 1
  },
  {
    question: 'C-14 ใช้หาอายุของวัตถุโบราณ ซึ่งเกิดจากการรวมตัวของนิวตรอนกับธาตุใด',
    intentname: 'Chapter 2-15_Q6',
    keyword: 'ประโยชน์',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่ประโยชน์จากสารกัมมันตรังสี',
    intentname: 'Chapter 2-15_Q7',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    question: 'ธาตุกลุ่มใดนิยมนำมาทำเป็นสารกึ่งตัวนำ (semiconductor)',
    intentname: 'Chapter 2-15_Q8',
    keyword: 'ประโยชน์',
    max_score: 1
  },
  {
    question: 'ธาตุหมู่ใด นิยมนำมาบรรจุในหลอดไฟ',
    intentname: 'Chapter 2-15_Q9',
    keyword: 'ประโยชน์',
    max_score: 1
  },
  {
    question: 'ธาตุใดบ้างเมื่อเข้าไปสะสมในร่างกายแล้วอาจก่อให้เกิดโรคความดันโลหิตสูง',
    intentname: 'Chapter 2-15_Q10',
    keyword: 'สารกัมมันตรังสี',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 2-16',
    keyword: '',
    max_score: 160
  },
  {
    question: 'boss',
    intentname: 'Chapter 2-17',
    keyword: '',
    max_score: 165
  },
  {
    question: 'สารในข้อใดที่อยุ่ในรูปอะตอมเดี่ยว',
    intentname: 'Chapter 3-1_Q1',
    keyword: 'อะตอมเดี่ยว',
    max_score: 1
  },
  {
    question: 'อิเล็กตรอนในข้อใดใช้ในการเกิดพันธะเคมี',
    intentname: 'Chapter 3-1_Q2',
    keyword: 'พันธะเคมี',
    max_score: 1
  },
  {
    question:
      'ธาตุใดที่เป็นข้อยกเว้นในการเขียนสัญลักษณ์แบบจุดของลิวอิส โดยจะเขียนจุดคู่ด้านเดียวกัน',
    intentname: 'Chapter 3-1_Q3',
    keyword: 'ลิวอิส',
    max_score: 1
  },
  {
    question:
      'สัญลักษณ์แบบจุดของลิวอิสของธาตุหรือไอออนในข้อใดมีเวเลนซ์อิเล็กตรอนไม่เป็นไปตามกฎออกเตต',
    intentname: 'Chapter 3-1_Q4',
    keyword: 'กฎออกเตต',
    max_score: 1
  },
  {
    question:
      'ถ้าจะทำให้จำนวนเวเลนซ์อิเล็กตรอนของธาตุที่จะเกิดพันธะเคมีกันเป็นไปตามกฎออกเตตจะทำได้อย่างไร',
    intentname: 'Chapter 3-1_Q5',
    keyword: 'เวเลนซ์อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นชนิดของธาตุองค์ประกอบของ NaCl',
    intentname: 'Chapter 3-1_Q6',
    keyword: 'ธาตุโลหะ,ธาตุอโลหะ',
    max_score: 1
  },
  {
    question: 'พันธะไอออนิกเกิดจากการยึดเหนี่ยวกันของไอออนด้วยแรงดึงดูดชนิดใด',
    intentname: 'Chapter 3-1_Q7',
    keyword: 'พันธะไอออนิก',
    max_score: 1
  },
  {
    question:
      'ธาตุโลหะมี IE ต่ำ จะเกิดเป็นไอออนได้โดยการให้หรือรับอิเล็กตรอน และเกิดเป็นไอออนชนิดใด',
    intentname: 'Chapter 3-1_Q8',
    keyword: 'ธาตุโลหะ,ธาตุอโลหะ',
    max_score: 1
  },
  {
    question:
      'ธาตุอโลหะมี EA สูง จะเกิดเป็นไอออนได้โดยการให้หรือรับอิเล็กตรอน และเกิดเป็นไอออนชนิดใด',
    intentname: 'Chapter 3-1_Q9',
    keyword: 'ธาตุอโลหะ',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นแผนภาพแสดงการให้และรับอิเล็กตรอนของอะตอมธาตุในการเกิด MgF2',
    intentname: 'Chapter 3-1_Q10',
    keyword: 'เวเลนซ์อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'โครงสร้างของสารประกอบไอออนิกในสถานะของแข็งเป็นอย่างไร',
    intentname: 'Chapter 3-1_Q11',
    keyword: 'พันธะไอออนิก',
    max_score: 1
  },
  {
    question: 'สารในข้อใดที่ยึดเหนี่ยวกันด้วยพันธะไอออนิก',
    intentname: 'Chapter 3-1_Q12',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'ประจุของไอออนของธาตุโลหะหมู่หลักจะสัมพันธ์กับข้อใด',
    intentname: 'Chapter 3-2_Q1',
    keyword: 'ไอออน,สารประกอบไออนนิก',
    max_score: 1
  },
  {
    question: 'ประจุของไอออนของธาตุอโลหะหมู่หลักจะสัมพันธ์กับข้อใด',
    intentname: 'Chapter 3-2_Q2',
    keyword: 'ไอออน,สารประกอบไออนนิก',
    max_score: 1
  },
  {
    question: 'Ca เมื่อให้อิเล็กตรอนเกิดเป็นไอออนบวกจะมีประจุเท่าใด',
    intentname: 'Chapter 3-2_Q3',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question: 'Cl เมื่อรับอิเล็กตรอนเกิดเป็นไอออนลบจะมีประจุเท่าใด',
    intentname: 'Chapter 3-2_Q4',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question: 'อัตราส่วนการรวมตัวกันของไอออนบวกและไอออนลบของสารประกอบไอออนิกขึ้นกับข้อใด',
    intentname: 'Chapter 3-2_Q5',
    keyword: 'สารประกอบไออนนิก',
    max_score: 1
  },
  {
    question: 'สูตรเคมีใดที่แสดงอัตราส่วนอย่างต่ำของจำนวนไอออนที่เป็นองค์ประกอบของสารประกอบไอออนิก',
    intentname: 'Chapter 3-2_Q6',
    keyword: 'สูตรเคมี,ไอออน',
    max_score: 1
  },
  {
    question: 'สูตรสารประกอบไอออนิกโดยทั่วไปจะเขียนสัญลักษณ์ของธาตุอย่างไร',
    intentname: 'Chapter 3-2_Q7',
    keyword: 'สูตรสารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'Ca และ Cl เมื่อเกิดเป็นสารประกอบไอออนิกจะมีสูตรเคมีตามข้อใด',
    intentname: 'Chapter 3-2_Q8',
    keyword: 'สารประกอบไออนนิก',
    max_score: 1
  },
  {
    question:
      'ข้อใดเป็นสูตรเอมพิริคัลของสารประกอบไอออนิกที่เกิดจากธาตุ X ซึ่งอยู่หมู่ IIA กับธาตุ Y ซึ่งอยู่หมู่ VA',
    intentname: 'Chapter 3-2_Q9',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question:
      'สารข้อใดมีอัตราส่วนอย่างต่ำของไอออนองค์ประกอบ เหมือนสารประกอบไอออนิกที่เกิดจากธาตุ X ซึ่งอยู่หมู่ IA กับธาตุ Y ซึ่งอยู่หมู่ VIA',
    intentname: 'Chapter 3-2_Q10',
    keyword: 'ไอออน',
    max_score: 1
  },
  {
    question: 'สูตรเคมีของสารประกอบไอออนิกที่เกิดจาก NH₄+ กับ SO₄²- เป็นตามข้อใด',
    intentname: 'Chapter 3-3_Q1',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question: 'สารประกอบในข้อใดมีสูตรเคมีคล้ายสารประกอบไอออนิกที่เกิดจาก Ca²+ กับ CO₃²-',
    intentname: 'Chapter 3-3_Q2',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question: 'ข้อใดเรียกชื่อไอออนบวกได้ถูกต้อง',
    intentname: 'Chapter 3-3_Q3',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'ข้อใดเรียกชื่อไอออนบวกได้ถูกต้อง',
    intentname: 'Chapter 3-3_Q4',
    keyword: 'ไอออน',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นค่าที่แสดงประจุไฟฟ้าหรือประจุไฟฟ้าสมมติของไอออนหรืออะตอมของธาตุ',
    intentname: 'Chapter 3-3_Q5',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    question: 'โลหะใดที่ส่วนใหญ่มีเลขออกซิเดชันมากกว่า 1 ค่า',
    intentname: 'Chapter 3-3_Q6',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    question: 'ข้อใดเรียกชื่อไอออนลบได้ถูกต้อง',
    intentname: 'Chapter 3-3_Q7',
    keyword: 'ไอออน',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นชื่อของไอออน O2-',
    intentname: 'Chapter 3-3_Q8',
    keyword: 'ไอออน',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นชื่อของสารประกอบ CaCl2',
    intentname: 'Chapter 3-3_Q9',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นชื่อของสารประกอบ Fe2O3',
    intentname: 'Chapter 3-3_Q10',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นชื่อของสารประกอบ Ba(NO3)2',
    intentname: 'Chapter 3-3_Q11',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นชื่อของสารประกอบ Al2(SO4)3',
    intentname: 'Chapter 3-3_Q12',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 3-4',
    keyword: '',
    max_score: 160
  },
  {
    question:
      'พลังงานที่เกิดจากการรวมตัวกันของ Na+ และ Cl- มีค่าเหมือนหรือต่างจากพลังงานการเกิด NaCl',
    intentname: 'Chapter 3-5_Q1',
    keyword: 'พลังงาน',
    max_score: 1
  },
  {
    question: 'ข้อใดกล่าวถูกต้องเกี่ยวกับพลังงานโครงผลึก',
    intentname: 'Chapter 3-5_Q2',
    keyword: 'พลังงาน',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นสมมติฐานตามวัฏจักรบอร์น-ฮาเบอร์',
    intentname: 'Chapter 3-5_Q3',
    keyword: 'วัฏจักรบอร์น-ฮาเบอร์',
    max_score: 1
  },
  {
    question: 'เมื่อ Na(g) เกิดไอออไนเซชันจะได้อะไร',
    intentname: 'Chapter 3-5_Q4',
    keyword: 'พลังงานไอออไนเซชัน',
    max_score: 1
  },
  {
    question: 'การสลายพันธะของ Cl2(g) ได้ผลิตภัณฑ์ใด',
    intentname: 'Chapter 3-5_Q5',
    keyword: 'พลังงานไอออไนเซชัน',
    max_score: 1
  },
  {
    question: 'ข้อใดกล่าวถูกต้องเกี่ยวกับสัมพรรคภาพอิเล็กตรอนของการเกิด NaCl',
    intentname: 'Chapter 3-5_Q6',
    keyword: 'สัมพรรคภาพอิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ข้อใดเป็นปฏิกิริยารวมของการเกิด NaCl',
    intentname: 'Chapter 3-5_Q7',
    keyword: 'พลังงานไอออไนเซชัน',
    max_score: 1
  },
  {
    question: 'ปฏิกิริยาการเกิด NaCl ในขั้นตอนใด เป็นการคายพลังงาน',
    intentname: 'Chapter 3-5_Q8',
    keyword: 'คายพลังงาน',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใดพลังงานแลตทิซในเกิด NaCl จึงมีค่าเป็นลบ',
    intentname: 'Chapter 3-5_Q9',
    keyword: 'พลังงานแลตทิซ',
    max_score: 1
  },
  {
    question:
      'เพราะเหตุใดการสลายพันธะระหว่างไอออนบวกและไอออนลบ เรียกว่า พลังงานแลตทิซ ไม่เรียกว่า พลังงานพันธะ',
    intentname: 'Chapter 3-5_Q10',
    keyword: 'พลังงานแลตทิซ',
    max_score: 1
  },
  {
    question: 'ข้อใดกล่าวถูกต้องเมื่อ ทุบผลึกของสารประกอบไอออนิก',
    intentname: 'Chapter 3-6_Q1',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใดสารประกอบไอออนิกสถานะของแข็งจึงไม่นำไฟฟ้า',
    intentname: 'Chapter 3-6_Q2',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่สมบัติของสารไอออนิกที่หลอมเหลวได้',
    intentname: 'Chapter 3-6_Q3',
    keyword: 'สารประกอบไอออนิก,หลอมเหลว',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใด เมื่อสารหลอมเหลวหรือละลายในน้ำจะนำไฟฟ้าได้',
    intentname: 'Chapter 3-6_Q4',
    keyword: 'สารประกอบไอออนิก,หลอมเหลว',
    max_score: 1
  },
  {
    question: 'สภาพละลายได้ คืออะไร',
    intentname: 'Chapter 3-6_Q5',
    keyword: 'สภาพละลายได้',
    max_score: 1
  },
  {
    question: 'ข้อใดไม่ใช่สมบัติของสารประกอบไอออนิก',
    intentname: 'Chapter 3-6_Q6',
    keyword: 'สารประกอบไอออนิก',
    max_score: 1
  },
  {
    question: 'สารละลายอิเล็กโทรไลต์ คืออะไร',
    intentname: 'Chapter 3-6_Q7',
    keyword: 'การละลายน้ำ',
    max_score: 1
  },
  {
    question: 'กระบวนการที่ไอออนบวกและลบ แยกออกจากโครงผลึกเป็นการดูดพลังงาน มีค่าเท่ากับพลังงานใด',
    intentname: 'Chapter 3-6_Q8',
    keyword: 'พลังงานแลตทิซ,ดูดพลังงาน',
    max_score: 1
  },
  {
    question: 'ข้อใดกล่าวถูกต้องเกี่ยวกับพลังงานไฮเดรชันในการละลายน้ำของสารประกอบไอออนิก',
    intentname: 'Chapter 3-6_Q9',
    keyword: 'พลังงานไฮเดรชัน,คายพลังงาน',
    max_score: 1
  },
  {
    question: 'จากแผนภาพ E1 คือพลังงานใด',
    intentname: 'Chapter 3-6_Q10',
    keyword: 'พลังงานแลตทิซ',
    max_score: 1
  },
  {
    question: 'จากแผนภาพ E2 คือพลังงานใด',
    intentname: 'Chapter 3-6_Q11',
    keyword: 'พลังงานไฮเดรชัน',
    max_score: 1
  },
  {
    question: 'แผนภาพใดเป็นกระบวนการดูดพลังงาน',
    intentname: 'Chapter 3-6_Q12',
    keyword: 'ดูดพลังงาน',
    max_score: 1
  },
  {
    question: 'ตัวแปรต้นและตัวแปรตามของการทดลองนี้คืออะไร',
    intentname: 'Chapter 3-7_Q1',
    keyword: 'สมการไอออนิก',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใดจึงมีตะกอนเกิดขึ้นในการทดลอง',
    intentname: 'Chapter 3-7_Q2',
    keyword: 'ตะกอน',
    max_score: 1
  },
  {
    question: 'สารใดที่ผสมกันแล้วไม่เกิดตะกอน',
    intentname: 'Chapter 3-7_Q3',
    keyword: 'ตะกอน',
    max_score: 1
  },
  {
    question: 'CaCl2 ผสมกับ Na2CO3 ได้ตะกอนใด',
    intentname: 'Chapter 3-7_Q4',
    keyword: 'ตะกอน',
    max_score: 1
  },
  {
    question: 'ตะกอน MgCO3 เกิดจากสารใด',
    intentname: 'Chapter 3-7_Q5',
    keyword: 'ตะกอน',
    max_score: 1
  },
  {
    question: 'สมการไอออนิก คืออะไร',
    intentname: 'Chapter 3-7_Q6',
    keyword: 'สมการไอออนิก',
    max_score: 1
  },
  {
    question: 'แล้วสมการไอออนิกสุทธิหล่ะ คืออะไร',
    intentname: 'Chapter 3-7_Q7',
    keyword: 'สมการไอออนิกสุทธิ',
    max_score: 1
  },
  {
    question: 'ให้น้องลองเขียนสมการไอออนิกของสารละลาย CaCl2 กับ Na2CO3',
    intentname: 'Chapter 3-7_Q8',
    keyword: 'สมการไอออนิก',
    max_score: 1
  },
  {
    question: 'สารประกอบใดไม่ละลายน้ำ',
    intentname: 'Chapter 3-7_Q9',
    keyword: 'ละลายน้ำ',
    max_score: 1
  },
  {
    question: 'สารประกอบใดละลายน้ำ',
    intentname: 'Chapter 3-7_Q10',
    keyword: 'ละลายน้ำ',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 3-8',
    keyword: '',
    max_score: 160
  },
  {
    question: 'สารในข้อใดประกอบด้วยธาตุอโลหะกับธาตุอโลหะ',
    intentname: 'Chapter 3-9_Q1',
    keyword: 'พันธะโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'Cl 2 อะตอม ยึดเหนี่ยวกันอย่างไร',
    intentname: 'Chapter 3-9_Q2',
    keyword: 'พันธะโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'Cl2 จะใช้ e- ร่วมกันกี่คู่',
    intentname: 'Chapter 3-9_Q3',
    keyword: 'พันธะเดี่ยว',
    max_score: 1
  },
  {
    question: 'Cl แต่ละอะตอม มี e- ที่ไม่ได้เกิดพันธะกี่คู่',
    intentname: 'Chapter 3-9_Q4',
    keyword: 'อิเล็กตรอนคู่โดดเดี่ยว',
    max_score: 1
  },
  {
    question: 'O2 มีอิเล็กตรอนคู่ร่วมพันธะกี่คู่',
    intentname: 'Chapter 3-9_Q5',
    keyword: 'พันธะโคเวเลนต์\nพันธะคู่',
    max_score: 1
  },
  {
    question: 'N2 มีอิเล็กตรอนคู่ร่วมพันธะกี่คู่',
    intentname: 'Chapter 3-9_Q6',
    keyword: 'พันธะสาม',
    max_score: 1
  },
  {
    question: 'เส้นแสดงพันธะ 1 เส้น (−) แทน อิเล็กตรอนคู่ร่วมพันธะกี่คู่',
    intentname: 'Chapter 3-9_Q7',
    keyword: 'โครงสร้างลิวอิส',
    max_score: 1
  },
  {
    question: 'โมเลกุลโคเวเลนต์ที่ประกอบด้วยอะตอมมากกว่า 2 อะตอม อะตอมกลางจะเป็นยังไง',
    intentname: 'Chapter 3-9_Q8',
    keyword: 'โครงสร้างลิวอิส',
    max_score: 1
  },
  {
    question: 'ถ้าในโมเลกุลโคเวเลนต์มีธาตุที่ต้องการจำนวน อิเล็กตรอนเท่ากัน อะตอมกลางจะเป็นยังไง',
    intentname: 'Chapter 3-9_Q9',
    keyword: 'โมเลกุลโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารในข้อใดมีพันธะต่างจากข้ออื่น',
    intentname: 'Chapter 3-9_Q10',
    keyword: 'พันธะสาม\nพันธะเดี่ยว',
    max_score: 1
  },
  {
    question: 'โมเลกุลใดที่อะตอมกลางมีจำนวน อิเล็กตรอนล้อมรอบไม่เป็นไปตามกฎออกเตต',
    intentname: 'Chapter 3-9_Q11',
    keyword: 'กฎออกเตต',
    max_score: 1
  },
  {
    question: 'สารในข้อใดมีอะตอมที่ไม่เป็นไปตามกฎออกเตต',
    intentname: 'Chapter 3-9_Q12',
    keyword: 'กฎออกเตต',
    max_score: 1
  },
  {
    question: 'โดยทั่วไป สูตรโมเลกุลของสารโคเวเลนต์จะเขียนสัญลักษณ์ของธาตุอย่างไร',
    intentname: 'Chapter 3-10_Q1',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ในข้อใดที่เขียนสูตรโมเลกุล โดยไม่เรียงลำดับจากธาตุที่มี EN น้อยไปมาก',
    intentname: 'Chapter 3-10_Q2',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ที่ประกอบด้วยธาตุชนิดเดียว เรียกชื่ออย่างไร',
    intentname: 'Chapter 3-10_Q3',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ที่ประกอบด้วยธาตุ 2 ชนิด ให้เรียกชื่ออย่างไร',
    intentname: 'Chapter 3-10_Q4',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'คำที่ใช้บอกจำนวนอะตอมในชื่อสารโคเวเลนต์เป็นคำในภาษาอะไร',
    intentname: 'Chapter 3-10_Q5',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'กรณีใดไม่ต้องระบุจำนวนอะตอมในภาษากรีกในชื่อสารโคเวเลนต์',
    intentname: 'Chapter 3-10_Q6',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารกลุ่มใด ที่นิยมเรียกชื่อโดยตัดสระตัวสุดท้ายของคำที่ระบุจำนวนอะตอมออก',
    intentname: 'Chapter 3-10_Q7',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'CCl4 เรียกชื่ออย่างไร',
    intentname: 'Chapter 3-10_Q8',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'N2O เรียกชื่ออย่างไร',
    intentname: 'Chapter 3-10_Q9',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'ไดไฮโดรเจนมอนอกไซด์ มีสูตรโมเลกุลอย่างไร',
    intentname: 'Chapter 3-10_Q10',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: 'ไดไนโตรเจนเพนตอกไซด์ มีสูตรโมเลกุลอย่างไร',
    intentname: 'Chapter 3-10_Q11',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ที่ประกอบด้วย P และ H ที่เป็นไปตามกฎออกเตต คือสารใด',
    intentname: 'Chapter 3-10_Q12',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'เมื่อ H สองอะตอมเคลื่อนที่เข้าหากันจะเกิดอะไรต่อกันบ้าง',
    intentname: 'Chapter 3-11_Q1',
    keyword: 'พลังงานศักย์',
    max_score: 1
  },
  {
    question: 'พลังงานศักย์ที่เกิดจากการเคลื่อนที่ของ H เข้าหากัน เกิดจากอะไร',
    intentname: 'Chapter 3-11_Q2',
    keyword: 'พลังงานศักย์',
    max_score: 1
  },
  {
    question: 'ถ้าต้องการสลายพันธะ H2(g) ต้องใช้พลังงานอย่างน้อยเท่าใด',
    intentname: 'Chapter 3-11_Q3',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'ข้อใดถูกต้องมากที่สุดเกี่ยวกับความยาวพันธะ',
    intentname: 'Chapter 3-11_Q4',
    keyword: 'ความยาวพันธะ',
    max_score: 1
  },
  {
    question: 'ความยาวพันธะมีแนวโน้มเพิ่มขึ้นตามสิ่งใด',
    intentname: 'Chapter 3-11_Q5',
    keyword: 'ความยาวพันธะ',
    max_score: 1
  },
  {
    question: 'สารใดมีความยาวพันธะระหว่าง C กับ O มากที่สุด\n\nCH3OH           CH2O           CO',
    intentname: 'Chapter 3-11_Q6',
    keyword: 'ความยาวพันธะ',
    max_score: 1
  },
  {
    question:
      'สารใดมีความยาวพันธะระหว่าง H กับ O น้อยที่สุด\n\n H2O           CH3OH             HNO2',
    intentname: 'Chapter 3-11_Q7',
    keyword: 'ความยาวพันธะ',
    max_score: 1
  },
  {
    question: 'เรโซแนนซ์ คืออะไร',
    intentname: 'Chapter 3-11_Q8',
    keyword: 'เรโซแนนซ์',
    max_score: 1
  },
  {
    question: 'โครงสร้างเรโซแนนซ์ เขียนได้อย่างไร',
    intentname: 'Chapter 3-11_Q9',
    keyword: 'เรโซแนนซ์',
    max_score: 1
  },
  {
    question: 'สารใดไม่เกิดเรโซแนนซ์',
    intentname: 'Chapter 3-11_Q10',
    keyword: 'เรโซแนนซ์',
    max_score: 1
  },
  {
    question: 'น้องลองเรียงลำดับความยาวพันธะของ Cl2 Br2  I2 จากมากไปน้อย',
    intentname: 'Chapter 3-12_Q1',
    keyword: 'ความยาวพันธะ',
    max_score: 1
  },
  {
    question: 'เรียงลำดับพลังงานพันธะในโมเลกุล Cl2 Br2 I2 จากมากไปน้อย',
    intentname: 'Chapter 3-12_Q2',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใดพันธะ F−F มีพลังงานพันธะน้อยกว่าพันธะ Cl−Cl',
    intentname: 'Chapter 3-12_Q3',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'การสลายพันธะเป็นกระบวนการอะไร',
    intentname: 'Chapter 3-12_Q4',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'การคายพลังงาน เกิดจากกระบวนการใดในปฏิกิริยาเคมี',
    intentname: 'Chapter 3-12_Q5',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'ข้อใดคายพลังงาน',
    intentname: 'Chapter 3-12_Q6',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'XCl ละลายน้ำแล้วมีไอน้ำมาเกาะที่บีกเกอร์ ข้อใดถูกต้อง',
    intentname: 'Chapter 3-12_Q7',
    keyword: 'พลังงานพันธะ',
    max_score: 1
  },
  {
    question: 'เปรียบเทียบ ความยาวพันธะ C กับ O ของ CO และ CO2',
    intentname: 'Chapter 3-12_Q8',
    keyword: 'พันธะคู่,พันธะสาม',
    max_score: 1
  },
  {
    question: 'ให้เปรียบเทียบ พลังงานพันธะ C กับ O ของ CO และ CO2',
    intentname: 'Chapter 3-12_Q9',
    keyword: 'พันธะคู่,พันธะสาม',
    max_score: 1
  },
  {
    question: 'ให้เปรียบเทียบ ความยาวพันธะ C กับ C ของ C2H2 และ C2H4',
    intentname: 'Chapter 3-12_Q10',
    keyword: 'พันธะคู่,พันธะสาม',
    max_score: 1
  },
  {
    question: 'ให้เปรียบเทียบ พลังงานพันธะ C กับ C ของ C2H2 และ C2H4',
    intentname: 'Chapter 3-12_Q11',
    keyword: 'พันธะคู่,พันธะสาม',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 3-13',
    keyword: '',
    max_score: 160
  },
  {
    question: 'ข้อใดใช้อธิบายสมบัติของโมเลกุลโคเวเลนต์ได้',
    intentname: 'Chapter 3-14_Q1',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'ในกิจกรรม 3.2 ตอนที่ 1 ลูกโป่งใช้แทนอะไร',
    intentname: 'Chapter 3-14_Q2',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'รูปร่างลูกโป่งนี้เปรียบเทียบได้กับโมเลกุลโคเวเลนต์ใด',
    intentname: 'Chapter 3-14_Q3',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'รูปร่างลูกโป่งนี้เปรียบเทียบได้กับโมเลกุลโคเวเลนต์ใด',
    intentname: 'Chapter 3-14_Q4',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'รูปร่างลูกโป่งนี้เปรียบเทียบได้กับรูปทรงเรขาคณิตใด',
    intentname: 'Chapter 3-14_Q5',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'ในกิจกรรม 3.2 ตอนที่ 2 ลูกโป่งต่างสีกันใช้แทนอะไร',
    intentname: 'Chapter 3-14_Q6',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question:
      'รูปร่างลูกโป่งนี้เปรียบเทียบได้กับโมเลกุลโคเวเลนต์ที่มีจำนวนอะตอมล้อมรอบ และจำนวนอิเล็กตรอนคู่โดดเดี่ยวเท่าใด',
    intentname: 'Chapter 3-14_Q7',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์',
    max_score: 1
  },
  {
    question: 'รูปร่างลูกโป่งนี้เปรียบเทียบได้กับโมเลกุลโคเวเลนต์ใด',
    intentname: 'Chapter 3-14_Q8',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์',
    max_score: 1
  },
  {
    question: 'รูปร่างลูกโป่งนี้เปรียบเทียบได้กับโมเลกุลโคเวเลนต์ใด',
    intentname: 'Chapter 3-14_Q9',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์',
    max_score: 1
  },
  {
    question: 'CH4 มีรูปร่างโมเลกุลเหมือนลูกโป่งในข้อใด',
    intentname: 'Chapter 3-14_Q10',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์',
    max_score: 1
  },
  {
    question:
      'กิจกรรมการจัดตัวของลูกโป่งกับรูปร่างโมเลกุลโคเวเลนต์ เราคาดคะเนรูปร่างโมเลกุลจากอะไร',
    intentname: 'Chapter 3-15_Q1',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์,VSEPR',
    max_score: 1
  },
  {
    question:
      'จากหลักการของ VSEPR theory แรงผลักระหว่างอิเล็กตรอนคู่โดดเดี่ยวด้วยกัน เปรียบเทียบกับ แรงผลักระหว่างอิเล็กตรอนคู่ร่วมพันธะด้วยกัน เป็นยังไง',
    intentname: 'Chapter 3-15_Q2',
    keyword: 'VSEPR',
    max_score: 1
  },
  {
    question: 'ข้อใดคือโมเลกุลที่มีอะตอมล้อมรอบ 2 อะตอม และอิเล็กตรอนคู่โดดเดี่ยว 1 คู่',
    intentname: 'Chapter 3-15_Q3',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'AB3E2 คือโมเลกุลในข้อใด',
    intentname: 'Chapter 3-15_Q4',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'NH3 คือโมเลกุลในข้อใด',
    intentname: 'Chapter 3-15_Q5',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'โมเลกุล AB2 จะมีรูปร่างโมเลกุลเป็นแบบใด',
    intentname: 'Chapter 3-15_Q6',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'โมเลกุล CH4 จะมีรูปร่างโมเลกุลเป็นแบบใด',
    intentname: 'Chapter 3-15_Q7',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'โมเลกุลใดมีรูปร่างโมเลกุลแบบพีระมิดฐานสามเหลี่ยม',
    intentname: 'Chapter 3-15_Q8',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'โมเลกุลใดมีรูปร่างโมเลกุลแบบพีระมิดคู่ฐานสามเหลี่ยม',
    intentname: 'Chapter 3-15_Q9',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'สารในข้อใดมีรูปร่างโมเลกุลเหมือนกับ BeH2',
    intentname: 'Chapter 3-15_Q10',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'โมเลกุลในข้อใดมีรูปร่างต่างจากข้ออื่น',
    intentname: 'Chapter 3-15_Q11',
    keyword: 'รูปร่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'มุมพันธะในโมเลกุล SiH4 เปรียบเทียบกับ BH3  เป็นอย่างไร',
    intentname: 'Chapter 3-15_Q12',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์,VSEPR',
    max_score: 1
  },
  {
    question: 'มุมพันธะในโมเลกุล H3O+ เปรียบเทียบกับ H2O  เป็นอย่างไร',
    intentname: 'Chapter 3-15_Q13',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์,VSEPR',
    max_score: 1
  },
  {
    question: 'มุมพันธะในโมเลกุล NH3 เปรียบเทียบกับ H2S  เป็นอย่างไร',
    intentname: 'Chapter 3-15_Q14',
    keyword: 'รูปร่างโมเลกุล,โคเวเลนต์,VSEPR',
    max_score: 1
  },
  {
    question:
      'H2 เขียนสัญลักษณ์แบบจุดของลิวอิสได้เป็น \nกลุ่มหมอกอิเล็กตรอนคู่ร่วมพันธะของ H2 มีการกระจายตัวอย่างไร',
    intentname: 'Chapter 3-16_Q1',
    keyword: 'สภาพขั้ว',
    max_score: 1
  },
  {
    question:
      'เพราะเหตุใด สารโคเวเลนต์บางชนิดมีการกระจายของกลุ่มหมอกอิเล็กตรอนคู่ร่วมพันธะระหว่างอะตอมไม่เท่ากัน',
    intentname: 'Chapter 3-16_Q2',
    keyword: 'โคเวเลนต์',
    max_score: 1
  },
  {
    question: 'อิเล็กตรอนมีการกระจายตัวใน HCl อย่างไร',
    intentname: 'Chapter 3-16_Q3',
    keyword: 'โคเวเลนต์มีขั้ว',
    max_score: 1
  },
  {
    question: 'H2 เป็นโมเลกุลที่มีขั้วหรือไม่',
    intentname: 'Chapter 3-16_Q4',
    keyword: 'โคเวเลนต์ไม่มีขั้ว',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ที่ในโมเลกุลเป็นพันธะโคเวเลนต์มีขั้ว เป็นโมเลกุลมีขั้วหรือไม่',
    intentname: 'Chapter 3-16_Q5',
    keyword: 'โคเวเลนต์มีขั้ว',
    max_score: 1
  },
  {
    question: 'CO2 เป็นโมเลกุลที่มีขั้วหรือไม่',
    intentname: 'Chapter 3-16_Q6',
    keyword: 'โคเวเลนต์มีขั้ว',
    max_score: 1
  },
  {
    question: 'โมเลกุลที่อะตอมกลางมีอิเล็กตรอนคู่โดดเดี่ยว เป็นโมเลกุลมีขั้วหรือไม่',
    intentname: 'Chapter 3-16_Q7',
    keyword: 'โมเลกุลไม่มีขั้ว,โมเลกุลมีขั้ว',
    max_score: 1
  },
  {
    question: 'H2O เป็นโมเลกุลที่มีขั้วหรือไม่',
    intentname: 'Chapter 3-16_Q8',
    keyword: 'โมเลกุลมีขั้ว',
    max_score: 1
  },
  {
    question: 'สารใดเป็นสารไม่มีขั้ว',
    intentname: 'Chapter 3-16_Q9',
    keyword: 'โมเลกุลไม่มีขั้ว',
    max_score: 1
  },
  {
    question: 'สมบัติใดของสารที่สามารถทำนายได้จากสภาพขั้วของโมเลกุล',
    intentname: 'Chapter 3-16_Q10',
    keyword: 'สภาพขั้ว\nโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 3-17',
    keyword: '',
    max_score: 160
  },
  {
    question:
      'สารแต่ละชนิดมีจุดหลอมเหลว จุดเดือดสถานะที่อุณหภูมิห้องต่างกัน ขึ้นอยู่กับปัจจัยใดบ้างนะ',
    intentname: 'Chapter 3-18_Q1',
    keyword: 'แรงยึดเหนี่ยวระหว่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'แรงแวนเดอร์วาลส์ คืออะไร',
    intentname: 'Chapter 3-18_Q2',
    keyword: 'แรงแวนเดอร์วาลส์',
    max_score: 1
  },
  {
    question: 'เพราะเหตุใด SiH₄ จึงมีจุดเดือดต่ำกว่า HCl ทั้งที่มีขนาดโมเลกุลใหญ่กว่า',
    intentname: 'Chapter 3-18_Q3',
    keyword: 'สมบัติของสารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'จงเรียงลำดับสารที่มีจุดเดือดน้อยไปมาก F₂ Cl₂ Br₂ l₂',
    intentname: 'Chapter 3-18_Q4',
    keyword: 'สมบัติของสารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'ข้อใดกล่าวผิดเกี่ยวกับ  แรงแผ่กระจายลอนดอน',
    intentname: 'Chapter 3-18_Q5',
    keyword: 'แรงแผ่กระจายลอนดอน',
    max_score: 1
  },
  {
    question: 'แรงระหว่างขั้ว  คืออะไร',
    intentname: 'Chapter 3-18_Q6',
    keyword: 'แรงระหว่างขั้ว',
    max_score: 1
  },
  {
    question: 'พันธะไฮโดรเจน คืออะไร',
    intentname: 'Chapter 3-18_Q7',
    keyword: 'พันธะไฮโดรเจน',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ใดละลายน้ำได้น้อย',
    intentname: 'Chapter 3-18_Q8',
    keyword: 'สมบัติของสารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารละลายอิเล็กโทรไลต์ คืออะไร',
    intentname: 'Chapter 3-18_Q9',
    keyword: 'สมบัติของสารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'จงระบุแรงยึดเหนี่ยวระหว่างโมเลกุลของ CH4',
    intentname: 'Chapter 3-18_Q10',
    keyword: 'แรงแผ่นกระจายลอนดอน',
    max_score: 1
  },
  {
    question: 'จงระบุแรงยึดเหนี่ยวระหว่างโมเลกุลของ HCl',
    intentname: 'Chapter 3-18_Q11',
    keyword: 'แรงยึดเหนี่ยวระหว่างโมเลกุล',
    max_score: 1
  },
  {
    question: 'สารใดมีจุดเดือดสูงกว่ากันระหว่าง H2 และ Br2',
    intentname: 'Chapter 3-18_Q12',
    keyword: 'สมบัติของสารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารใดมีจุดเดือดสูงกว่ากันระหว่าง HF และ HI',
    intentname: 'Chapter 3-18_Q13',
    keyword: 'สมบัติของสารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารโคเวเลนต์ที่มีโมเลกุลขนาดเล็ก จะเป็นอย่างไร',
    intentname: 'Chapter 3-19_Q1',
    keyword: 'จุดเดือดจุดหลอมเหลว',
    max_score: 1
  },
  {
    question: 'ทำไม แกรไฟต์ มีจุดหลอมเหลวและจุดเดือดสูง',
    intentname: 'Chapter 3-19_Q2',
    keyword: 'สารโคเวเลนต์โครงร่างตาข่าย',
    max_score: 1
  },
  {
    question: 'สารที่มีพันธะโคเวเลนต์เชื่อมต่อกันเป็นโครงร่างตาข่าย เรียกว่า สารอะไร',
    intentname: 'Chapter 3-19_Q3',
    keyword: 'สารโคเวเลนต์โครงร่างตาข่าย',
    max_score: 1
  },
  {
    question: 'ทำไม แกรไฟต์ นำไฟฟ้าได้แต่ เพชร ไม่นำไฟฟ้า',
    intentname: 'Chapter 3-19_Q4',
    keyword: 'พันธะโลหะ',
    max_score: 1
  },
  {
    question: 'พันธะโลหะ แสดงได้ด้วย แบบจำลองใด',
    intentname: 'Chapter 3-19_Q5',
    keyword: 'แบบจำลองทะเลอิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'ทำไม โลหะมีจุดหลอมเหลวและจุดเดือดสูง',
    intentname: 'Chapter 3-19_Q6',
    keyword: 'จุดเดือดจุดหลอมเหลว',
    max_score: 1
  },
  {
    question: 'ทำไมโลหะมีผิวมันวาวและสะท้อนแสงได้',
    intentname: 'Chapter 3-19_Q7',
    keyword: 'เวเลนซ์อิเล็กตรอน',
    max_score: 1
  },
  {
    question: 'เหตใดจึงดัดโลหะให้โค้งงอ หรือดึงเป็นเส้นได้',
    intentname: 'Chapter 3-19_Q8',
    keyword: 'พันธะโลหะ',
    max_score: 1
  },
  {
    question: 'สาดใดมีจุดหลอมเหลวสูงที่สุด',
    intentname: 'Chapter 3-19_Q9',
    keyword: 'จุดเดือดจุดหลอมเหลว',
    max_score: 1
  },
  {
    question: 'ทำไมเวเลนซ์ e ของโลหะ สามารถเคลื่อนที่ได้อย่างอิสระ',
    intentname: 'Chapter 3-19_Q10',
    keyword: 'IE',
    max_score: 1
  },
  {
    question: 'สมบัติที่ต่างกันของแต่ละพันธะ ส่งผลต่อการนำไปใช้ประโยชน์หรือไม่',
    intentname: 'Chapter 3-20_Q1',
    keyword: 'การใช้ประโยชน์',
    max_score: 1
  },
  {
    question: 'สารใดมีจุดเดือดสูงที่สุด',
    intentname: 'Chapter 3-20_Q2',
    keyword: 'โลหะ',
    max_score: 1
  },
  {
    question: 'สารใดมีจุดหลอมเหลวต่ำที่สุด',
    intentname: 'Chapter 3-20_Q3',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'ที่อุณหภูมิห้อง สารใดมีโอกาศมีสถานะแก๊ส',
    intentname: 'Chapter 3-20_Q4',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารใดนำไฟฟ้าได้',
    intentname: 'Chapter 3-20_Q5',
    keyword: 'นำไฟฟ้า',
    max_score: 1
  },
  {
    question: 'สารของแข็งที่ละลายน้ำ แล้วนำไฟฟ้าได้คือสารใด',
    intentname: 'Chapter 3-20_Q6',
    keyword: 'ไอออนิก',
    max_score: 1
  },
  {
    question: 'สารใดมีความเหนียวมากที่สุด',
    intentname: 'Chapter 3-20_Q7',
    keyword: 'โลหะ',
    max_score: 1
  },
  {
    question: 'สารใดไม่เหมาะสมที่จะนำมาทำภาชนะบรรจุอาหาร',
    intentname: 'Chapter 3-20_Q8',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'หินลับมีดทำมาจากสารใด',
    intentname: 'Chapter 3-20_Q9',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารของแข็งสีขาว ไม่นำไฟฟ้า จุดหลอมเหลวต่ำ คือสารใด',
    intentname: 'Chapter 3-20_Q10',
    keyword: 'สารโคเวเลนต์',
    max_score: 1
  },
  {
    question: 'สารใดใช้ทำเป็นลิเล็กโทรไลต์ในถ่านไฟฉาย',
    intentname: 'Chapter 3-20_Q11',
    keyword: 'การใช้ประโยชน์',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 3-21',
    keyword: '',
    max_score: 160
  },
  {
    question: 'boss',
    intentname: 'Chapter 3-22',
    keyword: '',
    max_score: 165
  },
  {
    question: '1 มวลของอะตอม คิดจากมวลของอนุภาคอะไรมารวมกันบ้าง',
    intentname: 'Chapter 4-1_Q1',
    keyword: 'มวลอะตอม,อนุภาค',
    max_score: 1
  },
  {
    question: '2 ธาตุมาตรฐาน 1 อะตอม มีมวลเท่าไหร่',
    intentname: 'Chapter 4-1_Q2',
    keyword: 'มวลอะตอม',
    max_score: 1
  },
  {
    question: '3 คำที่ใช้เปรียบเทียบมวลอะตอมกับมวลอะตอมธาตุมาตรฐาน เรียกว่าอะไร',
    intentname: 'Chapter 4-1_Q3',
    keyword: 'มวลอะตอม,มวลอะตอมมาตรฐาน',
    max_score: 1
  },
  {
    question:
      '4 เมื่อกี้เราใช้ "แอปเปิ้ล " เป็นผลไม้มาตรฐาน เพื่อเปรียบเทียบมวลกับผลไม้ชนิดอื่น\nถ้าเป็นธาตุ เราใช้ธาตุอะไรเป็นธาตุมาตรฐานในการเปรียบเทียบมวล',
    intentname: 'Chapter 4-1_Q4',
    keyword: 'มวลอะตอมมาตรฐาน',
    max_score: 1
  },
  {
    question: '5 มีมวลอะตอม 63.55 x 1.66x 10^-24 กรัม\nCu มีมวลอะตอมสัมพัทธ์เท่าไหร่',
    intentname: 'Chapter 4-1_Q5',
    keyword: 'มวลอะตอม,มวลอะตอมสัมพัทธ์',
    max_score: 1
  },
  {
    question: '6 \nมีมวลอะตอม 196.97 x 1.66x 10^-23 กรัม\nAu 1 อะตอม มีมวลเท่าไหร่',
    intentname: 'Chapter 4-1_Q6',
    keyword: 'มวลอะตอม',
    max_score: 1
  },
  {
    question: '7 ทอง (Au) มีมวลอะตอมสัมพัทธ์เท่าไหร่',
    intentname: 'Chapter 4-1_Q7',
    keyword: 'มวลอะตอม,มวลอะตอมสัมพัทธ์',
    max_score: 1
  },
  {
    question: '8 อะตอมจากธาตุชนิดเดียวกันในธรรมชาติ\nจะมีมวลอะตอมเท่ากันหรือไม่',
    intentname: 'Chapter 4-1_Q8',
    keyword: 'มวลอะตอม',
    max_score: 1
  },
  {
    question: '9 \nมะม่วง1 = 8 กรัม มะม่วง2 = 10กรัม\nมะม่วงในรูปมีมวลเฉลี่ยกี่กรัม',
    intentname: 'Chapter 4-1_Q9',
    keyword: 'มวลอะตอม,มวลเฉลี่ย',
    max_score: 1
  },
  {
    question: '10 \nมะม่วงกอง1 = 90% มะม่วงกอง2 = 10%\n\nมะม่วงมีมวลเฉลี่ยกี่กรัม',
    intentname: 'Chapter 4-1_Q10',
    keyword: 'มวลอะตอม,มวลเฉลี่ย',
    max_score: 1
  },
  {
    question: '11 ไหนบอกพี่หน่อยว่าธาตุ N มีมวลอะตอมเฉลี่ยเท่าไหร่',
    intentname: 'Chapter 4-1_Q11',
    keyword: 'มวลอะตอม,มวลเฉลี่ย',
    max_score: 1
  },
  {
    question: '12 มวลอะตอมเฉลี่ย หาได้จากส่วนไหนของสัญลักษณ์เคมี',
    intentname: 'Chapter 4-1_Q12',
    keyword: 'มวลอะตอม,มวลเฉลี่ย,สัญลักษณ์เคมี',
    max_score: 1
  },
  {
    question: '1ลูกอม 1 โหลมี 12 เม็ด ถ้าลูกอม 1 โมล จะมีกี่เม็ด',
    intentname: 'Chapter 4-2_Q1',
    keyword: 'โมล',
    max_score: 1
  },
  {
    question: '2 เลข 6.02 x 10²³ มีอีกชื่อเรียกง่ายๆ\nน้องๆ รู้มั้ยว่ามันชื่อว่าเลขอะไร',
    intentname: 'Chapter 4-2_Q2',
    keyword: 'เลขอาโวกาโดร',
    max_score: 1
  },
  {
    question: '3 H₂O 1 โมล มีอนุภาคกี่โมเลกุล',
    intentname: 'Chapter 4-2_Q3',
    keyword: 'โมล,โมเลกุล',
    max_score: 1
  },
  {
    question: '4 H₂O 1 โมล มี H กี่โมล',
    intentname: 'Chapter 4-2_Q4',
    keyword: 'โมล',
    max_score: 1
  },
  {
    question: '5 H₂O 1 โมล มี H กี่อะตอม',
    intentname: 'Chapter 4-2_Q5',
    keyword: 'อะตอม,โมล',
    max_score: 1
  },
  {
    question: '6 ทองแดง 1 โมล และ เหล็ก 1 โมล มีมวลเท่ากันมั้ย',
    intentname: 'Chapter 4-2_Q6',
    keyword: 'โมล,มวล',
    max_score: 1
  },
  {
    question: '7 มวลของทองแดง 1 โมล เท่ากับมวลของทองแดงกี่อะตอม',
    intentname: 'Chapter 4-2_Q7',
    keyword: 'อะตอม,โมล',
    max_score: 1
  },
  {
    question: '8 มวลของสาร 1 โมลมีชื่อว่าอะไร',
    intentname: 'Chapter 4-2_Q8',
    keyword: 'มวลต่อโมล,มวล,โมล',
    max_score: 1
  },
  {
    question: '9 ถ้าต้องการหาค่ามวลต่อโมล\n\nจะเอามาจากส่วนไหนของสัญลักษณ์เคมีดี',
    intentname: 'Chapter 4-2_Q9',
    keyword: 'มวลต่อโมล,สัญลักษณ์เคมี',
    max_score: 1
  },
  {
    question: '10 น้ำ (H₂O) 1 โมล มีมวลกี่กรัม',
    intentname: 'Chapter 4-2_Q10',
    keyword: 'มวล,โมล',
    max_score: 1
  },
  {
    question: '11 เหล็ก 111.6 กรัม มีกี่โมล',
    intentname: 'Chapter 4-2_Q11',
    keyword: 'มวล,โมล',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 4-3',
    keyword: '',
    max_score: 160
  },
  {
    question: '1 คาร์บอน-12 จำนวน 1 อะตอม มีมวลเท่าใด',
    intentname: 'Chapter 4-4_Q1',
    keyword: 'มวลต่อโมล,มวล',
    max_score: 1
  },
  {
    question: '2 มวลของคาร์บอน-12 ปริมาณ 1 โมล มีค่าเท่าใด',
    intentname: 'Chapter 4-4_Q2',
    keyword: 'มวลต่อโมล,มวล',
    max_score: 1
  },
  {
    question: '3 Li มีมวลอะตอมเท่ากับ 6.94 จะมีค่ามวลต่อโมลเท่าใด',
    intentname: 'Chapter 4-4_Q3',
    keyword: 'มวลต่อโมล,มวลอะตอม',
    max_score: 1
  },
  {
    question: '4 O มีมวลอะตอมเท่ากับ 16.00 จะมีค่ามวลต่อโมลเท่าใด',
    intentname: 'Chapter 4-4_Q4',
    keyword: 'มวลต่อโมล,มวลอะตอม',
    max_score: 1
  },
  {
    question: '5 เหล็ก 1 โมล มีมวลเท่ากับ 55.85 กรัม เหล็ก 5.585 กรัม มีจำนวนอะตอมเท่าใด',
    intentname: 'Chapter 4-4_Q5',
    keyword: 'มวล,โมล,อะตอม',
    max_score: 1
  },
  {
    question: '6 เหล็ก 10.0 กรัม  มีจำนวนอะตอมเท่าใด',
    intentname: 'Chapter 4-4_Q6',
    keyword: 'มวล,โมล,อะตอม',
    max_score: 1
  },
  {
    question: '7 เมื่ออะตอมของธาตุรวมตัวกันเป็นโมเลกุล ผลรวมของมวลอะตอมของธาตุในสูตรเคมี เรียกว่า',
    intentname: 'Chapter 4-4_Q7',
    keyword: 'มวลอะตอม,มวลโมเลกุล',
    max_score: 1
  },
  {
    question: '8 แก๊สออกซิเจน (O2) มีมวลโมเลกุลเท่าใด',
    intentname: 'Chapter 4-4_Q8',
    keyword: 'มวลโมเลกุล',
    max_score: 1
  },
  {
    question:
      '9 สารที่ไม่อยู่ในรูปโมเลกุล เช่น สารประกอบไอออนิก โลหะ ผลรวมของมวลอะตอมของธาตุในสูตรเคมีจะเรียกว่าอะไร',
    intentname: 'Chapter 4-4_Q9',
    keyword: 'มวลอะตอม,มวลสูตร',
    max_score: 1
  },
  {
    question: '10 มวลสูตรของเกลือ (NaCl) มีค่าเท่าใด',
    intentname: 'Chapter 4-4_Q10',
    keyword: 'มวลสูตร',
    max_score: 1
  },
  {
    question: '11 มวลสูตรของเกลือ (NaCl) มีค่าตรงกับค่าใด',
    intentname: 'Chapter 4-4_Q11',
    keyword: 'มวลสูตร,มวลต่อโมล',
    max_score: 1
  },
  {
    question: '12 สารต่างชนิดกันที่มีจำนวนโมลเท่ากันจะมีมวลเท่ากันหรือไม่',
    intentname: 'Chapter 4-4_Q12',
    keyword: 'โมล,มวล',
    max_score: 1
  },
  {
    question: '13 สารต่างชนิดกันมีจำนวนโมลเท่ากันจะมี\nจำนวนอนุภาคเท่ากันหรือไม่',
    intentname: 'Chapter 4-4_Q13',
    keyword: 'โมล,อนุภาค',
    max_score: 1
  },
  {
    question: '14 สารต่างชนิดกันมีมวลเท่ากันจะมี\nจำนวนอนุภาคเท่ากันหรือไม่',
    intentname: 'Chapter 4-4_Q14',
    keyword: 'มวล,อนุภาค',
    max_score: 1
  },
  {
    question: '1 ที่ STP มีอุณหภูมิและความดันเป็นเท่าไร',
    intentname: 'Chapter 4-5_Q1',
    keyword: 'STP',
    max_score: 1
  },
  {
    question: '2 แก๊สออกซิเจน 1 โมล มีปริมาตรเท่าใด',
    intentname: 'Chapter 4-5_Q2',
    keyword: 'แก๊ส,ปริมาตร',
    max_score: 1
  },
  {
    question: '3 แก๊สมีเทน 32 กรัม คิดเป็นกี่โมล',
    intentname: 'Chapter 4-5_Q3',
    keyword: 'แก๊ส,มวลต่อโมล',
    max_score: 1
  },
  {
    question: '4 Ne 3.01 x 10^23 อนุภาค มีปริมาตรเป็นเท่าใด',
    intentname: 'Chapter 4-5_Q4',
    keyword: 'แก๊ส,ปริมาตร',
    max_score: 1
  },
  {
    question: '5 ไอน้ำ 11.2 ลิตร มีจำนวนโมเลกุลเท่ากับสารข้อใด',
    intentname: 'Chapter 4-5_Q5',
    keyword: 'แก๊ส,อนุภาค',
    max_score: 1
  },
  {
    question: '6 แก๊สไนโตรเจน 11.2 ลิตร หรือ แก๊สออกซิเจน 11.2 ลิตร มีจำนวนโมลมากกว่า',
    intentname: 'Chapter 4-5_Q6',
    keyword: 'แก๊ส,โมล',
    max_score: 1
  },
  {
    question: '7 แก๊สไนโตรเจน 11.2 ลิตร หรือ แก๊สออกซิเจน 11.2 ลิตร มีมวลมากกว่า',
    intentname: 'Chapter 4-5_Q7',
    keyword: 'แก๊ส,มวล',
    max_score: 1
  },
  {
    question: '8 แก๊สออกซิเจน 64 กรัม มีความหนาแน่นเท่าใดที่ STP',
    intentname: 'Chapter 4-5_Q8',
    keyword: 'แก๊ส,ความหนาแน่น',
    max_score: 1
  },
  {
    question: '9 แก๊สชนิดหนึ่ง มวล 2.0 กรัม มีปริมาตร 11 ลิตร มวลต่อโมลของแก๊สนี้เป็นเท่าใด',
    intentname: 'Chapter 4-5_Q9',
    keyword: 'แก๊ส,มวลต่่อโมล',
    max_score: 1
  },
  {
    question: '10 แก๊สชนิดหนึ่ง 16 กรัม มีปริมาตร 22.4 ลิตร แก๊สนี้คือแก๊สใด',
    intentname: 'Chapter 4-5_Q10',
    keyword: 'แก๊ส,ปริมาตร',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 4-6',
    keyword: '',
    max_score: 160
  },
  {
    question: '1 สูตรเคมีเป็นสัญลักษณ์ที่ใช้เขียนแทนอะไร',
    intentname: 'Chapter 4-7_Q1',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question: '2 ในสูตรเคมีจะประกอบด้วยอะไรบ้าง',
    intentname: 'Chapter 4-7_Q2',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question: '3 เมื่ออะตอมของธาตุ เกิดเป็นสารประกอบแล้ว จะมีอะไรที่คงที่',
    intentname: 'Chapter 4-7_Q3',
    keyword: 'อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    question: '4 อัตราส่วนโดยโมลของอะตอมธาตุ หาได้จากอะไร',
    intentname: 'Chapter 4-7_Q4',
    keyword: 'อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    question: '5 อัตราส่วนโดยมวลของสารประกอบจะคงที่เสมอ คือกฎอะไร',
    intentname: 'Chapter 4-7_Q5',
    keyword: 'กฎสัดส่วนคงที่,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    question:
      '6 ทำการทดลองหาอัตราส่วนโดยมวลของการเผาทองแดงและกำมะถัน จงหาอัตราส่วนโดยมวลของ ทองแดงต่อกำมะถัน',
    intentname: 'Chapter 4-7_Q6',
    keyword: 'กฎสัดส่วนคงที่,อัตราส่วนโดยมวล',
    max_score: 1
  },
  {
    question: '7 เมื่อเผาทองแดงร่วมกับกำมะถันแล้ว จะได้สารประกอบอะไร',
    intentname: 'Chapter 4-7_Q7',
    keyword: 'สูตรเคมี',
    max_score: 1
  },
  {
    question:
      '8  จากการทดลองทั้ง 5 ครั้ง สรุปได้ว่าครั้งไหนที่สามารถเตรียม คอปเปอร์(II)ซัลไฟด์ ได้',
    intentname: 'Chapter 4-7_Q8',
    keyword: 'กฎสัดส่วนคงที่,การทดลอง',
    max_score: 1
  },
  {
    question:
      '9 อัตราส่วนโดยโมลของทองแดงต่อกำมะถันที่ทำปฏิกิริยาพอดีกันเป็นสารประกอบคอปเปอร์(II)ซัลไฟด์ มีค่าเฉลี่ยเท่าใด',
    intentname: 'Chapter 4-7_Q9',
    keyword: 'กฎสัดส่วนคงที่,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    question:
      '10 ถ้าเปลี่ยนการสังเคราะห์สารประกอบคอปเปอร์(II)ซัลไฟด์ จากของแข็งมาใช้เป็นสารละลายที่มี คอปเปอร์(II)ไอออน ทำปฏิกิริยากับสารละลายที่มีซัลไฟด์ไอออน จะได้อัตราส่วนโดยมวลเท่าไร',
    intentname: 'Chapter 4-7_Q10',
    keyword: 'กฎสัดส่วนคงที่,อัตราส่วนโดยมวล',
    max_score: 1
  },
  {
    question:
      '1 อัตราส่วนโดยมวลของธาตุองค์ประกอบในสารประกอบแสดงในรูปของร้อยละโดยมวล มีความสัมพันธ์กับอะไรบ้าง',
    intentname: 'Chapter 4-8_Q1',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question: '2 ร้อยละโดยมวลของธาตุ A ในสารประกอบ มีความสัมพันธ์อย่างไร',
    intentname: 'Chapter 4-8_Q2',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question:
      '3 สารประกอบ AB 1000 กรัม มีธาตุ A อยู่100 กรัม จงหาร้อยละโดยมวลของธาตุ A ในสารประกอบ AB',
    intentname: 'Chapter 4-8_Q3',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question:
      '4 สารประกอบ AB  1000 กรัม มีธาตุ A อยู่100 กรัม จงหาร้อยละโดยมวลของธาตุ B สารประกอบ AB',
    intentname: 'Chapter 4-8_Q4',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question:
      '5 ออกไซด์ของ X   100 กรัม มีธาตุ  X  อยู่ 50 กรัม จงหาร้อยละโดยมวลของธาตุ  X  ในออกไซด์ของ  X',
    intentname: 'Chapter 4-8_Q5',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question:
      '6 ออกไซด์ของ X   100 กรัม มีธาตุ  X  อยู่ 50 กรัม จงหาร้อยละโดยมวลของออกซิเจน ในออกไซด์ของ  X',
    intentname: 'Chapter 4-8_Q6',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question: '7 จงคำนวณร้อยละโดยมวลของคาร์บอน (C) ในคาร์บอนไดออกไซด์ (CO2)  กำหนดให้ C=12 CO2=44',
    intentname: 'Chapter 4-8_Q7',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question: '8 จงคำนวณร้อยละโดยมวลไฮโดรเจน (H) ในไอน้ำ (H2O)  กำหนดให้ H=1 H2O=18',
    intentname: 'Chapter 4-8_Q8',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question:
      '9 การหาร้อยละโดยมวลของธาตุ ในสารประกอบ จะคิดจากมวลของธาตุ แล้วนำมาหารอะไร แล้วนำไปคูณ 100%',
    intentname: 'Chapter 4-8_Q9',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question: '10 อัตราส่วนโดยมวลของธาตุองค์ประกอบในสารประกอบสามารถแสดงให้อยู่ในรุปของอะไร',
    intentname: 'Chapter 4-8_Q10',
    keyword: 'ร้อยละโดยมวล',
    max_score: 1
  },
  {
    question:
      '1 จากผลการทดลอง อัตราส่วนโดยโมล ของทองแดงกับกำมะถัน\nในสารประกอบคอปเปอร์(II)ซัลไฟด์ \nสัมพันธ์กับสูตรเคมี CuS อย่างไร',
    intentname: 'Chapter 4-9_Q1',
    keyword: 'อัตราส่วนโดยโมล,สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: '2 จากกฎสัดส่วนคงที่ ใช้อะไรเพื่อหาอัตราส่วนโดยโมล',
    intentname: 'Chapter 4-9_Q2',
    keyword: 'กฎสัดส่วนคงที่,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    question:
      '3 จากกฎสัดส่วนคงที่ ใช้อัตราส่วนโดยมวลและร้อยละโดยมวล เพื่อนำมาใช้หาอัตราส่วนโดยโมล เพื่อใช้หาอะไรต่อ',
    intentname: 'Chapter 4-9_Q3',
    keyword: 'กฎสัดส่วนคงที่,อัตราส่วนโดยมวล,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    question: '4 สูตรโมเลกุล คืออะไร',
    intentname: 'Chapter 4-9_Q4',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: '5 สูตรโมเลกุลของน้ำคืออะไร',
    intentname: 'Chapter 4-9_Q5',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: '6 สูตรอย่างง่ายหรือสูตรเอมพิริคัล คืออะไร',
    intentname: 'Chapter 4-9_Q6',
    keyword: 'สูตรอย่างง่าย,สูตรเอมพิริคัล',
    max_score: 1
  },
  {
    question: '7 กลูโคส มีสูตรโมเลกุลเป็น C6H12O6 จะมีสูตรเอมพิริคัลเป็นอะไร',
    intentname: 'Chapter 4-9_Q7',
    keyword: 'สูตรโมเลกุล,สูตรเอมพิริคัล',
    max_score: 1
  },
  {
    question:
      '8 จาก กลูโคส มีสูตรโมเลกุลเป็น C6H12O6 อัตราส่วน ของจำนวนอะตอมหรือโมลของ C : H : O เท่ากับ 1 : 2 : 1 กลูโคสจึงมีสูตรเอมพิริคัลเป็น CH2O ดังนั้นจะหาความสัมพันธ์ได้คือ',
    intentname: 'Chapter 4-9_Q8',
    keyword: 'สูตรโมเลกุล,สูตรเอมพิริคัล',
    max_score: 1
  },
  {
    question: '9 สูตรเคมีจะมีแค่สูตรโมเลกุล สูตรอยางง่าย เท่านั้น',
    intentname: 'Chapter 4-9_Q9',
    keyword: 'สูตรโมเลกุล',
    max_score: 1
  },
  {
    question: '10 H2O เป็นสูตรเคมีชนิดใด',
    intentname: 'Chapter 4-9_Q10',
    keyword: 'สูตรโมเลกุล\nสูตรเอมพิริคัล',
    max_score: 1
  },
  {
    question: '11 สูตรเอมพิริคัลของ ไฮโดรเจนเปอร์ออกไซด์ คือข้อใด',
    intentname: 'Chapter 4-9_Q11',
    keyword: 'สูตรเอมพิริคัล',
    max_score: 1
  },
  {
    question: '12 สูตรอย่างง่ายของกรดแอซีติก คือข้อใด',
    intentname: 'Chapter 4-9_Q12',
    keyword: 'สูตรอย่างง่าย',
    max_score: 1
  },
  {
    question: 'miniboss',
    intentname: 'Chapter 4-10',
    keyword: '',
    max_score: 160
  },
  {
    question: '1 สารในข้อใดต่อไปนี้ไม่ใช่สารละลาย',
    intentname: 'Chapter 4-11_Q1',
    keyword: 'สารละลาย,ความเข้มข้น',
    max_score: 1
  },
  {
    question: '2 ข้อใดไม่ถูกต้อง',
    intentname: 'Chapter 4-11_Q2',
    keyword: 'ความเข้มข้น',
    max_score: 1
  },
  {
    question: '3 ข้อใดไม่ใช่ความหมายของความเข้มข้นของสาร',
    intentname: 'Chapter 4-11_Q3',
    keyword: 'ความเข้มข้น',
    max_score: 1
  },
  {
    question: '4 เกลือ 5 กรัม ในสารละลาย 50 กรัม มีความเข้มข้นเท่าใด',
    intentname: 'Chapter 4-11_Q4',
    keyword: 'ความเข้มข้น,% w/w',
    max_score: 1
  },
  {
    question: '5 น้ำเชื่อมเข้มข้นร้อยละ 5 โดยมวลต่อปริมาตรหมายถึงข้อใด',
    intentname: 'Chapter 4-11_Q5',
    keyword: 'ความเข้มข้น,ร้อยละ',
    max_score: 1
  },
  {
    question: '6 น้ำส้มสายชูร้อยละ 5 โดยปริมาตร ไม่ได้หมายถึงข้อใด',
    intentname: 'Chapter 4-11_Q6',
    keyword: 'ความเข้มข้น,ร้อยละ',
    max_score: 1
  },
  {
    question:
      '7 สาร A 3 กรัม ละลายในน้ำ 50 กรัม มีความหนาแน่น 1.10 g/mL ข้อมูลที่กำหนดให้ไม่สามารถหาความเข้มข้นของสารในหน่วยใด',
    intentname: 'Chapter 4-11_Q7',
    keyword: 'ความเข้มข้น,ร้อยละ',
    max_score: 1
  },
  {
    question: '8 สารในข้อใดมีความเข้มข้นมากที่สุด',
    intentname: 'Chapter 4-11_Q8',
    keyword: 'ความเข้มข้น,% w/w',
    max_score: 1
  },
  {
    question: '9 ต้องการเตรียมสารละลาย KOH 12 %v/v 25 มิลลิลิตร ต้องใช้ KOH และน้ำอย่างละเท่าไหร่',
    intentname: 'Chapter 4-11_Q9',
    keyword: 'ความเข้มข้น,% V/V',
    max_score: 1
  },
  {
    question: '10 ข้อใดไม่ใช่ความหมายของสารละลายเข้มข้น 1 ppm',
    intentname: 'Chapter 4-11_Q10',
    keyword: 'ความเข้มข้น,ppm',
    max_score: 1
  },
  {
    question:
      '11 เพราะเหตุใดการคำนวณในหน่วย ppm และ ppb จึงคิดจากมวลหรือปริมาตรตัวละลายต่อมวลหรือปริมาตรตัวทำละลาย',
    intentname: 'Chapter 4-11_Q11',
    keyword: 'ความเข้มข้น,ppm,ppb',
    max_score: 1
  },
  {
    question: '12 แคดเมียม 1 mg ในน้ำทิ้ง 1 L คิดเป็นความเข้มข้น 1 ppm ข้อความนี้ถูกต้องหรือไม่',
    intentname: 'Chapter 4-11_Q12',
    keyword: 'ความเข้มข้น,ppm',
    max_score: 1
  },
  {
    question:
      '13 Na2SO4 1 ug ในน้ำ 1 L กับ น้ำตาลทราย 1 ug  ในน้ำ 1 L สารละลายใดมีความเข้มข้นในหน่วย ppb มากกว่า',
    intentname: 'Chapter 4-11_Q13',
    keyword: 'ความเข้มข้น,ppb',
    max_score: 1
  },
  {
    question: '1 ความเข้มข้นในหน่วยโมลาริตีหมายถึงข้อใด',
    intentname: 'Chapter 4-12_Q1',
    keyword: 'ความเข้มข้น,โมลาริตี',
    max_score: 1
  },
  {
    question:
      '2 Ca(OH)2 1 โมลในสารละลาย 1 ลิตร กับ HCl 1 โมลในสารละลาย 1 ลิตร สารละลายใดมีความเข้นข้นในหน่วยโมลาร์มากกว่า',
    intentname: 'Chapter 4-12_Q2',
    keyword: 'ความเข้มข้น,โมลาร์',
    max_score: 1
  },
  {
    question: '3 O2 16 กรัม ในสารละลาย 1 ลิตร มีความเข้มข้นกี่โมลาร์',
    intentname: 'Chapter 4-12_Q3',
    keyword: 'ความเข้มข้น,โมลาร์',
    max_score: 1
  },
  {
    question: '4. NaOH 1 โมลาร์ 500 มิลลิตร มี NaOH กี่กรัม',
    intentname: 'Chapter 4-12_Q4',
    keyword: 'ความเข้มข้น,โมลาร์',
    max_score: 1
  },
  {
    question:
      '5 CH3OH เข้มข้นร้อยละ 1 โดยมวลต่อปริมาตร และ C6H12O6 เข้มข้นร้อยละ 1 โดยมวลต่อปริมาตร สารละลายใดมีความเข้นข้นในหน่วยโมลาร์มากกว่า',
    intentname: 'Chapter 4-12_Q5',
    keyword: 'ความเข้มข้น,โมลาร์',
    max_score: 1
  },
  {
    question: '6 ความเข้มข้นในหน่วยโมแลลิตีหมายถึงข้อใด',
    intentname: 'Chapter 4-12_Q6',
    keyword: 'ความเข้มข้น,โมแลลิตี',
    max_score: 1
  },
  {
    question: '7 น้ำเกลือ 1 โมแลล มีน้ำและเกลืออย่างละเท่าไหร่',
    intentname: 'Chapter 4-12_Q7',
    keyword: 'ความเข้มข้น,โมแลล',
    max_score: 1
  },
  {
    question:
      '8 สาร A 5 กรัม ในสารละลาย 105 กรัม มีความเข้มข้นกี่โมแลล ให้สาร A มีมวลต่อโมลเท่ากับ 50 g/mol',
    intentname: 'Chapter 4-12_Q8',
    keyword: 'ความเข้มข้น,โมแลล',
    max_score: 1
  },
  {
    question: '9 NaOH เข้มข้นร้อยละ 50 โดยมวล มีความเข้มข้นกี่โมแลล',
    intentname: 'Chapter 4-12_Q9',
    keyword: 'ความเข้มข้น,โมแลล',
    max_score: 1
  },
  {
    question:
      '10 สารละลายประกอบด้วยสาร A 1 โมล และ สาร B 2 โมล เศษส่วนโมลของ A น้อยกว่าเศษส่วนโมลของ B อยู่เท่าใด',
    intentname: 'Chapter 4-12_Q10',
    keyword: 'ความเข้มข้น,เศษส่วนโมล',
    max_score: 1
  },
  {
    question: '1 สมบัติที่เกี่ยวข้องกับสารละลาย คือข้อใด',
    intentname: 'Chapter 4-13_Q1',
    keyword: 'สารละลาย,คอลิเกทีฟ',
    max_score: 1
  },
  {
    question: '2 ข้อใดเกี่ยวข้องกับสมบัติคอลลิเกทีฟ',
    intentname: 'Chapter 4-13_Q2',
    keyword: 'สารละลาย,คอลิเกทีฟ',
    max_score: 1
  },
  {
    question: '3 สารละลายข้อใดต่อไปนี้มีจุดเดือดเท่ากับสารละลายกลูโคส 1 mol ในน้ำ 1 kg',
    intentname: 'Chapter 4-13_Q3',
    keyword: 'สารละลาย,จุดเดือด',
    max_score: 1
  },
  {
    question: '4 จุดเดือดที่เพิ่มขึ้นของสารละลายกรดแอซีติกเข้มข้น m โมแลล เท่ากับข้อใด',
    intentname: 'Chapter 4-13_Q4',
    keyword: 'สารละลาย,จุดเดือด',
    max_score: 1
  },
  {
    question: '5 ตัวละลายปริมาณ 10 กรัม ในข้อใดที่ทำให้สารละลายมีจุดเดือดสูงสุด',
    intentname: 'Chapter 4-13_Q5',
    keyword: 'สารละลาย,จุดเดือด',
    max_score: 1
  },
  {
    question: '6 สารละลายข้อใดมีจุดเยือกแข็งต่ำสุด',
    intentname: 'Chapter 4-13_Q6',
    keyword: 'สารละลาย,จุดเยือกแข็ง',
    max_score: 1
  },
  {
    question:
      '7 สารละลายกลูโคสเข้มข้น 2.00 โมแลล มีจุดเยือกแข็งต่ำเท่าไหร ถ้าน้ำมีค่า Kb เท่ากับ 0.51 °C/m และ Kf เท่ากับ 1.86 °C/m',
    intentname: 'Chapter 4-13_Q7',
    keyword: 'จุดเยือกแข็ง,Kb,Kf',
    max_score: 1
  },
  {
    question:
      '8 สารละลายซูโครสมีจุดเดือด 100.51 °C มีซูโครสเข้มข้นเท่าใด ถ้าน้ำมีค่า Kb เท่ากับ 0.51 °C/m และ Kf เท่ากับ 1.86 °C/m',
    intentname: 'Chapter 4-13_Q8',
    keyword: 'จุดเดือด,Kb,Kf',
    max_score: 1
  },
  {
    question: '9 สมบัติคอลลิเกทีฟไม่ขึ้นกับปัจจัยในข้อใด',
    intentname: 'Chapter 4-13_Q9',
    keyword: 'คอลลิเกทีฟ',
    max_score: 1
  },
  {
    question: '10 ข้อใดไม่ใช่การประยุกต์ใช้ความรู้เกี่ยวกับสมบัติคอลลิเกทีฟ',
    intentname: 'Chapter 4-13_Q10',
    keyword: 'คอลลิเกทีฟ',
    max_score: 1
  },
  {
    question: 'boss',
    intentname: 'Chapter 4-14',
    keyword: '',
    max_score: 165
  },

  {
    intentname: 'Chapter 6-1_Q1',
    question: 'การเกิดสนิมของเหล็ก เป็นปฏิกิริยาเคมี หรือไม่ เพราะเหตุใด',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q2',
    question: 'ข้อใด ไม่เป็นปฏิกิริยาเคมี',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q3',
    question: 'ข้อใด ไม่เป็นปฏิกิริยาเคมี \n\nวาดรุปใหม่',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q4',
    question:
      'ถ้าปฏิกิริยาเคมีระหว่าง สารละลายกรดและเบส ซึ่งไม่เห็นการเปลี่ยนแปลง จะทราบได้อย่างไรว่ามีการเปลี่ยนแปลงเกิดขึ้น',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q5',
    question: 'อัตราส่วนโดยโมลของ Na₃PO₄(aq) ต่อ BaCl₂(aq) สัมพันธ์กับสมการเคมีที่ดุลแล้วอย่างไร',
    keyword: 'สมการเคมี,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q6',
    question: 'สัญลักษณ์ (l) หมายถึงสถานะใดของสาร',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q7',
    question: 'ตัวเลขสีแดง 2:3:1: 6 ในสมการที่ดุลแล้วเรียกว่าอะไร',
    keyword: 'สมการเคมี,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q8',
    question: 'ข้อใดกล่าวผิด เกี่ยวกับการดุลสมการเคมี',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q9',
    question: 'สัญลักษณ์สามเหลี่ยม(เดลต้า) อยู่บนลูกศรหล่ะ จะหมายถึงปัจจัยอะไร',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-1_Q10',
    question: 'กฎทรงมวลกล่าวไว้ว่าอย่างไร',
    keyword: 'กฎทรงมวล',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q1',
    question: 'อัตราส่วนโดยโมลของ Na : Cl : NaCl จาก เท่ากับข้อใด',
    keyword: 'สมการเคมี,อัตราส่วนโดยโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q2',
    question: 'จากปฏิกิริยานี้ ถ้าต้องการ AlBr₃ 0.6 โมล จะต้องใช้ Br₂ กี่โมล',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q3',
    question: 'ความสัมพันธ์ข้อใดใช้เปลี่ยนโมลให้เป็นมวลของสาร',
    keyword: 'มวลต่อโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q4',
    question:
      'ปฏิกิริยาการเผาไหม้มีเทน (CH4) ข้อใดเป็นแนวคิดในการหามวล H2O จากการเผาไหม้ CH4 24.00 กรัม',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q5',
    question: 'การเปลี่ยนมวลของ CH4 ให้เป็นโมล ทำได้โดยใช้แฟกเตอร์เปลี่ยนหน่วยใด',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q6',
    question: 'ปฏิกิริยาการเผาไหม้มีเทน (CH4) ข้อใดเป็นการหามวล H2O จากการเผาไหม้ CH4 24.00 กรัม',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q7',
    question:
      'จากปฏิกิริยา ข้อใดเป็นแนวคิดในการหาปริมาตร C₂H₆O ที่ต้องใช้ในการผลิต H₂ 0.200 โมล เมื่อC₂H₆O มีความหนาแน่น 0.789 กรัมต่อมิลลลิตร',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q8',
    question:
      'จากปฏิกิริยา แฟกเตอร์เปลี่ยนหน่วยไม่ได้ใช้ในการหาปริมาตร C₂H₆O ที่ต้องใช้ในการผลิต H₂ 0.200 โมล เมื่อC₂H₆O มีความหนาแน่น 0.789 กรัมต่อมิลลลิตร',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q9',
    question:
      'จากปฏิกิริยา ข้อใดเป็นแนวคิดในการหาความเข้มข้น NaOH 50.0 มิลลิลิตร ที่ทำปฏิกิริยาพอดีกับ H₂SO4  0.200 โมลต่อลิตร 12.4 mL',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q10',
    question:
      'จากปฏิกิริยา แฟกเตอร์เปลี่ยนหน่วยไม่ได้ใช้ในการหาความเข้มข้น NaOH 50.0 มิลลิลิตร ที่ทำปฏิกิริยาพอดีกับ H₂SO4  0.200 โมลต่อลิตร 12.4 mL',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q11',
    question:
      'จากปฏิกิริยา ข้อใดเป็นการหาความเข้มข้น NaOH 50.0 มิลลิลิตร ที่ทำปฏิกิริยาพอดีกับ H₂SO4  0.200 โมลต่อลิตร 12.4 mL',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q12',
    question:
      'จากปฏิกิริยา ข้อใดเป็นแนวคิดในการหาความเข้มข้น Pb(NO₃)₂ 1.0 มิลลิลิตร ที่ทำปฏิกิริยาพอดีกับ KI  0.50 โมลต่อลิตร 4.0 mL',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q13',
    question:
      'จากปฏิกิริยา ข้อใดเป็นการหาความเข้มข้น Pb(NO₃)₂ 1.0 มิลลิลิตร ที่ทำปฏิกิริยาพอดีกับ KI  0.50 โมลต่อลิตร 4.0 mL',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q14',
    question:
      'จากปฏิกิริยา แฟกเตอร์เปลี่ยนหน่วยใด ไม่ได้ใช้ในการรหามวล PbI₂ ทีเกิดขึ้น เมื่อใช้ Pb(NO₃)₂ ที่ทำปฏิกิริยาพอดีกับ KI  0.50 โมลต่อลิตร 4.0 mL',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-2_Q15',
    question:
      'จากปฏิกิริยา ข้อใดเป็นแนวคิดในการหามวล PbI₂ ทีเกิดขึ้น เมื่อใช้ Pb(NO₃)₂ ที่ทำปฏิกิริยาพอดีกับ KI  0.50 โมลต่อลิตร 4.0 mL',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q1',
    question: 'standard temperature and pressure  หรือ STP คือภาวะใด',
    keyword: 'STP',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q2',
    question: 'จากปฏิกิริยา  ข้อใดเป็นแนวคิดในการปริมาณ C ที่ทำปฏิกิริยาพอดีกับ H2 13.44 ลิตร',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q3',
    question:
      'แฟกเตอร์เปลี่ยนหน่วยข้อใด ใช้ในการเปลี่ยนปริมาตร H2 13.44 ลิตร ที่ STP ให้เป็นหน่วยโมล',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q4',
    question:
      'ถ้านำแก๊สสองชนิดมาทำปฏิกิริยากัน อัตราส่วนโดยปริมาตรระหว่างแก๊สทั้งสองที่ทำปฏิกิริยาพอดีกันจะเป็นอย่างไร',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q5',
    question: 'เมื่อผสม O2 กับ NO เข้าด้วยกัน ปริมาตรของแก๊สในกระบอกตวงเปลี่ยนแปลงอย่างไร',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q6',
    question:
      'ความสัมพันธ์ระหว่างปริมาณของสารในปฏิกิริยากับปริมาตรของแก๊สที่เกี่ยวข้องในปฏิกิริยา เป็นไปตามข้อใด',
    keyword: 'ปฏิกิริยาเคมี,เกย์–ลูสแซก',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q7',
    question: 'ปริมาตรที่ใช้ในการคำนวณตามกฎของเกย์–ลูสแซก คิดปริมาตรสารในสถานะใด',
    keyword: 'เกย์–ลูสแซก',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q8',
    question: 'ความสัมพันธ์ระหว่างปริมาตรของแก๊สกับจำนวนโมเลกุล เป็นไปตามข้อใด',
    keyword: 'อาโวกาโดร',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q9',
    question:
      'ปริมาตรรวมของแก๊สที่ทำปฏิกิริยากันพอดีกับปริมาตรรวมของแก๊สที่เกิดขึ้น มึความสัมพันธ์กันอย่างไร',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q10',
    question: 'จากสมการเคมี อัตราส่วนโดยปริมาตรของ H2 ต่อ O2 เป็นเท่าไหร่',
    keyword: 'สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-4_Q11',
    question:
      'จากสมการเคมี ปริมาตรของ H2 ที่ทำปฏิกิริยาพอดีกับ O2 40 ลิตร ที่ 25 องศาเซลเซียส ความดัน 1 บรรยากาศ เท่ากับข้อใด',
    keyword: 'ปฏิกิริยาเคมี,สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q1',
    question: 'เมื่อรวมหลายๆ สมการเข้าด้วยกัน สิ่งใดที่ต้องคำนึงถึงไว้เสมอ',
    keyword: 'สมการเคมี,โมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q2',
    question: 'จากปฏิกิริยา ข้อใดเป็นแนวคิดในการหาปริมาตรของ HCN',
    keyword: 'สมการเคมี ',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q3',
    question: 'ข้อใดคือสารตั้งต้นเมื่อรวมสมการแล้ว',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q4',
    question: 'ข้อใดเป็นตัวเลขจำนวนโมลของสารตั้งต้นและสารผลิตภัณฑ์ของสมการที่รวมแล้ว',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q5',
    question: 'ข้อใดคือสารทั้งหมดเมื่อรวมสมการแล้ว',
    keyword: 'ปฏิกิริยาเคมี,สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q6',
    question: 'แฟกเตอร์เปลี่ยนหน่วยข้อใด ใช้ในการเปลี่ยน O2 15.0 ลิตร ให้เป็น HCN ในหน่วยลิตร',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q7',
    question: 'จาก 2 ปฏิกิริยา ดังกล่าว ข้อใดดุลสมการเคมีได้ถูกต้อง',
    keyword: 'ปฏิกิริยาเคมี,สมการเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q8',
    question: 'เมื่อรวมสมการเคมีที่ดุลแล้ว จำนวนโมลที่ทำให้เป็นอย่างต่ำ คือข้อใด',
    keyword: 'ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q9',
    question: 'แฟกเตอร์เปลี่ยนหน่วยข้อใด ใช้ในการเปลี่ยน CCl4 5.00 กิโลกรัม ให้เป็นหน่วยกรัม',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-5_Q10',
    question: 'แฟกเตอร์เปลี่ยนหน่วยข้อใด ใช้ในการเปลี่ยนมวล CCl4 ให้เป็นมวลต่อโมล',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q1',
    question: 'สารตั้งต้นใดเป็นสารกำหนดปริมาณ',
    keyword: 'สารกำหนดปริมาณ,ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q2',
    question: 'เมื่อสิ้นสุดปฏิกิริยา มีน้ำเกิดขึ้นกี่โมเลกุล',
    keyword: 'สารกำหนดปริมาณ,ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q3',
    question: 'เมื่อสิ้นสุดปฏิกิริยา มีสารตั้งต้นใดที่เหลืออยู่ และเหลืออยู่ปริมาณเท่าใด',
    keyword: 'สารกำหนดปริมาณ,ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q4',
    question: 'ข้อใดคือแนวคิดของการหาสารกำหนดปริมาณ',
    keyword: 'สารกำหนดปริมาณ,ปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q5',
    question: 'แฟกเตอร์เปลี่ยนหน่วยข้อใด ใช้ในการหาโมลของ O₂ เมื่อใช้ Mg 6.000 mol',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q6',
    question: 'แฟกเตอร์เปลี่ยนหน่วยข้อใด ใช้ในการหาโมลของ Mg เมื่อใช้ O₂ 2.500 mol',
    keyword: 'แฟกเตอร์เปลี่ยนหน่วย',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q7',
    question: 'ปริมาณของผลิตภัณฑ์ที่คำนวณได้จากสารกำหนดปริมาณตามสมการเคมีเรียกว่าอะไร',
    keyword: 'สารกำหนดปริมาณ',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q8',
    question: 'ผลได้ร้อยละคืออะไร',
    keyword: 'ผลได้ร้อยละ',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q9',
    question: 'แนวคิดขั้นตอนแรกข้อใดต้องถูก',
    keyword: 'ผลได้ร้อยละ',
    max_score: 1
  },
  {
    intentname: 'Chapter 6-6_Q10',
    question: 'ข้อใดคือแนวคิดในการหาผลได้ร้อยละ ',
    keyword: 'ผลได้ร้อยละ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q1',
    question: 'ปริมาตรของสารในสถานะของแข็ง ของเหลว และแก๊ส ที่จำนวนโมลเท่ากัน เป็นไปตามข้อใด',
    keyword: 'แรงยึดเหนี่ยว',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q2',
    question: 'ผลรวมของแรงทั้งหมดที่อนุภาคแก๊สกระทำต่อพื้นที่ คือข้อใด',
    keyword: 'ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q3',
    question: 'อุณหภูมิและจำนวนโมลของอากาศภายในกระบอกฉีดยา ก่อนและหลังการทดลองเป็นอย่างไร',
    keyword: 'ความดัน,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q4',
    question:
      'เมื่อกดก้านกระบอกฉีดยาจากปริมาตรของอากาศ 10.0 mL จนเหลือ 5.0 mL ความดันของอากาศภายในกระบอกฉีดยาเป็นอย่างไร',
    keyword: 'ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q5',
    question:
      'ปริมาตรและความดันของอากาศมีความสัมพันธ์กันอย่างไร เมื่ออุณหภูมิและจำนวนโมลของอากาศคงที่',
    keyword: 'ปริมาตร,ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q6',
    question: 'ข้อใดเป็นกราฟความสัมพันธ์ที่สอดคล้องกับการทดลองของบอยล์',
    keyword: 'บอยล์,ปริมาตร,ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q7',
    question:
      'ข้อใดคือความดันของแก๊สที่บรรจุในภาชนะขนาด 100.0 ลูกบาศก์เซนติเมตร ที่ความดัน 1.0 บรรยากาศ ถ้าแก๊สนี้บรรจุในภาชนะขนาด 200.0 ลูกบาศก์เซนติเมตร ณ อุณหภูมิเดิม',
    keyword: 'บอยล์,ปริมาตร,ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q8',
    question: 'จำนวนโมลและความดันของอากาศในขวดพลาสติกก่อนและหลังการทดลองเป็นอย่างไร',
    keyword: 'จำนวนโมล,ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q9',
    question:
      'ปริมาตรและอุณหภูมิของอากาศมีความสัมพันธ์กันอย่างไร เมื่อจำนวนโมลและความดันของอากาศคงที่',
    keyword: 'ปริมาตร,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q10',
    question: 'ข้อใดเป็นกราฟความสัมพันธ์ที่สอดคล้องกับการทดลองของชาร์ล',
    keyword: 'ชาร์ล,ปริมาตร,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q11',
    question: 'ข้อใดคือความสัมพันธ์ระหว่างอุณหภูมิในหน่วยองศาเซลเซียสและเคลวิน',
    keyword: 'อุณหภูมิ,องศาเซลเซียส,เคลวิน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-1_Q12',
    question:
      'N₂ในกระบอกสูบปิด 250 มิลลิลิตรอุณหภูมิ 373 เคลวิน เมื่ออุณหภูมิลดลงเป็น 273 เคลวิน โดยความดันของแก๊สไม่เปลี่ยนแปลง ปริมาตรสุดท้ายของแก๊สเป็นเท่าใด',
    keyword: 'ชาร์ล,ปริมาตร,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q1',
    question:
      'กระป๋องสเปรย์ห้ามวางใกล้เปลวไฟเพราะอาจทำให้ระเบิดได้ ความดันภายในกระป๋องสเปรย์ก่อนระเบิดเป็นอย่างไร',
    keyword: 'ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q2',
    question:
      'เมื่อวางกระป่องสเปรย์ไว้ใกล้เปลวไฟจะทำให้อุณหภูมิภายในของแก๊สสูงขึ้น ส่งผลให้เป็นอย่างไร',
    keyword: 'อุณหภูมิ,ปริมาตร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q3',
    question: 'ข้อใดเป็นกราฟความสัมพันธ์ที่สอดคล้องกับกฎของเกย์-ลูสแซก',
    keyword: 'เกย์-ลูสแซก,ความดัน,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q4',
    question:
      'ข้อใดเป็นความสัมพันธ์ตามกฎของเกย์-ลูสแซก ที่ใช้หาความดันหรืออุณหภูมิของแก๊สที่สองสภาวะ',
    keyword: 'เกย์-ลูสแซก,ความดัน,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q5',
    question:
      'กระป๋องสเปรย์ปรับอากาศ มีความดัน 103 กิโลปาสคาล ที่อุณหภูมิ 25 องศาเซลเซียส ถูกโยนใส่ในกองไฟจนมีอุณหภูมิ 928 องศาเซลเซียส ภายในกระป๋องจะมีความดันกี่กิโลปาสคาล',
    keyword: 'เกย์-ลูสแซก,ความดัน,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q6',
    question: 'ข้อใดคือความสัมพันธ์เมื่อรวมกฎของบอยล์ กฎของชาร์ล และกฎของเกย์-ลูสแซก',
    keyword: 'บอยล์,ชาร์ล,เกย์-ลูสแซก',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q7',
    question:
      'ลูกโป่งบรรจุแก๊สฮีเลียมปริมาตร 30 ลิตร ที่ความดัน 1.5 บรรยากาศ อุณหภูมิ 40 องศาเซลเซียส ลูกโป่งนี้จะมีปริมาตรเท่าใดที่ STP',
    keyword: 'กฎรวมแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q8',
    question:
      'ลูกโป่งที่มีปริมาตร 6.0 ลิตร ความดัน 1.0 บรรยากาศ และอุณหภูมิ 27 องศาเซลเซียส ลอยขึ้นบรรยากาศชั้นบนซึ่งมีความดัน 0.50 บรรยากาศ และอุณหภูมิ -23 องศาเซลเซียส ลูกโป่งจะมีปริมาตรเท่าใด\n\nการหาปริมาตรลูกโป่งนี้ แทนค่าปัจจัยใดผิด',
    keyword: 'กฎรวมแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q9',
    question: 'จำนวนโมลของแก๊สที่เกิดขึ้นในลูกโป่งแต่ละลูกเท่ากันหรือไม่',
    keyword: 'จำนวนโมล,ปริมาตร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q10',
    question: 'ปริมาตรและจำนวนโมลขอแก๊สสัมพันธ์กันอย่างไร เมื่อความดันและอุณหภูมิของแก๊สคงที่',
    keyword: 'อาโวกาโดร,จำนวนโมล,ปริมาตร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q11',
    question: 'ข้อใดเป็นกราฟความสัมพันธ์ที่สอดคล้องกับกฎของอาโวกาโดร',
    keyword: 'อาโวกาโดร,จำนวนโมล,ปริมาตร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-2_Q12',
    question:
      'ลูกโป่งบรรจุแก๊สฮีเลียม 2.0 โมล มีปริมาตร 50 ลิตร ถ้าบรรจุแก๊สฮีเลียมลงไปเรื่อย ๆ จนมีปริมาตร 150 ลิตร โดยไม่มีการเปลี่ยนแปลงอุณหภูมิและความดัน ลูกโป่งนี้จะมีแก๊สฮีเลียมบรรจุอยู่กี่โมล',
    keyword: 'อาโวกาโดร,จำนวนโมล,ปริมาตร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q1',
    question: 'กฎแก๊สอุดมคติตรงกับข้อใด',
    keyword: 'แก๊สอุดมคติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q2',
    question: 'แก๊สที่ STP จะมีแนวคิดในการคำนวณค่า R อย่างไร',
    keyword: 'แก๊ส,STP',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q3',
    question:
      'บรรจุ O2(g) 0.885 kg ไว้ในถังเหล็กกล้าซึ่งมีปริมาตร 438 L จงคำนวณ ความดันของ O2(g) ถังนี้ที่อุณหภูมิ 21 °C ความสัมพันธ์ใดไม่ถูกต้อง',
    keyword: 'แก๊สอุดมคติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q4',
    question:
      'ถัง CH4(g) ปริมาตร 3.20 × 10⁵ L บรรจุแก๊สที่ความดัน 150 atm อุณหภูมิ  45 °C ข้อใดคือแนวคิดในการหามวลของ CH4(g)',
    keyword: 'แก๊สอุดมคติ,มวล',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q5',
    question: 'O2(g) 1.0 โมล ที่อุณหภูมิ 62  °C ความดัน 3.45 atm มีปริมาตรเท่าใด',
    keyword: 'แก๊สอุดมคติ,ปริมาตร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q6',
    question:
      'แก๊สชนิดหนึ่งมีมวล 1.50 กรัม บรรจุอยู่ในภาชนะ 0.250 L ที่ความดัน 1.61 atmอุณหภูมิ 300 K แก๊สชนิดนี้มีมวลต่อโมลเท่าใด',
    keyword: 'แก๊สอุดมคติ,มวลต่อโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q7',
    question:
      'ถ้าผสม He(g) 4.00 g และAr(g) 7.99 g ในภาชนะขนาด 10.0 L ที่ 25.0 °C ความดันของแก๊สผสมเป็นกี่ atm',
    keyword: 'กฎความดันย่อยของดอลตัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q8',
    question:
      'แก๊สผสมของ H2(g) 2.02 g และHe(g) 12.00 g ที่อุณหภูมิ 25.0 °C มีความดันรวม 8.00 atm เศษส่วนโมลของ H2(g)มีค่าเท่าใด',
    keyword: 'กฎความดันย่อยของดอลตัน,เศษส่วนโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q9',
    question:
      'แก๊สผสมของ H2(g) 2.02 g และHe(g) 12.00 g ที่อุณหภูมิ 25.0 °C มีความดันรวม 8.00 atm เศษส่วนโมลของ He(g)มีค่าเท่าใด',
    keyword: 'กฎความดันย่อยของดอลตัน,เศษส่วนโมล',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q10',
    question:
      'แก๊สผสมของ H₂(g)  และHe(g) อุณหภูมิ 25.0 °C มีความดันรวม 8.00 atm เศษส่วนโมลของ He(g) มีค่า 0.250 He(g) จะมีความดันเท่าใด',
    keyword: 'กฎความดันย่อยของดอลตัน,ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-3_Q11',
    question:
      'แก๊สผสมของ H2(g)  และHe(g) อุณหภูมิ 25.0 °C มีความดันรวม 8.00 atm เศษส่วนโมลของ H2(g) มีค่า 0.750 H2(g) จะมีความดันเท่าใด',
    keyword: 'กฎความดันย่อยของดอลตัน,ความดัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q1',
    question: 'ข้อใดไม่ใช่ทฤษฎีจลน์ของแก๊ส',
    keyword: 'ทฤษฎีจลน์ของแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q2',
    question: 'ข้อใดคือทฤษฎีจลน์ของแก๊ส',
    keyword: 'ทฤษฎีจลน์ของแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q3',
    question: 'อนุภาคแก๊สเคลื่อนที่เป็นเส้นตรง  เมื่อชนกันแล้วจะเป็นอย่างไร',
    keyword: 'ทฤษฎีจลน์ของแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q4',
    question: 'แก๊สทั่วไปจะมีพฤติกรรมใกล้เคียงกับแก๊สอุดมคติได้หรือไม่ เมื่อใด',
    keyword: 'แก๊สอุดมคติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q5',
    question:
      'เมื่อลดปริมาตรภาชนะ จะทำให้ระยะห่างระหว่างอนุภาคแก๊สกับผนังภาชนะลดลง จะส่งผลทำให้เกิดอะไร',
    keyword: 'กฎของบอยล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q6',
    question: 'เมื่ออุณหภูมิเพิ่มขึ้น อนุภาคแก๊สจะเป็นอย่างไร',
    keyword: 'กฎของเกย์-ลูสแซก',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q7',
    question: 'เมื่ออุณหภูมิเพิ่มขึ้น แต่ถ้าผนังภาชนะมีความยืดหยุ่น ความดันจะเป็นอย่างไร',
    keyword: 'กฎของชาร์ล',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q8',
    question: 'ถ้าหากผนังภาชนะมีความยืดหยุ่น ความดันที่เกิดขึ้นจะส่งผลต่อปริมาตรของภาชนะอย่างไร',
    keyword: 'จากกฎของอาโวกาโดร',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q9',
    question: 'ที่อุณหภูมิเดียวกัน อนุภาคแก๊สที่มีมวลมากจะเป็นอย่างไร',
    keyword: 'การแพร่',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q10',
    question: 'ข้อใดถูกต้องเกี่ยวกับ กฎการแพร่ผ่านของเกรแฮม',
    keyword: 'กฎการแพร่ผ่านของเกรแฮม',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q11',
    question:
      'ถ้าแก๊ส A มีความหนาแน่นเป็น 2 เท่าของแก๊ส B จงคำนวณอัตราส่วนของอัตราการแพร่ของ แก๊ส A ต่อแก๊ส B ที่สภาวะเดียวกัน',
    keyword: 'กฎการแพร่ผ่านของเกรแฮม',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q12',
    question: 'รูเล็กๆบนฝาถ้วยกาแฟ มีไว้ทำไม',
    keyword: 'ประโยชน์ของแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 7-4_Q13',
    question:
      'ข้าวตอก ที่ทำจากการคั่วเมล็ดข้าวเปลือกนั้น ใช้หลักการใดที่เกี่ยวกับแก๊สและสมบัติของแก๊ส',
    keyword: 'ประโยชน์ของแก๊ส',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q1',
    question:
      'การเคลื่อนที่ของรถยนต์เมื่อแล่นไปได้ตามระยะทาง เปรียบเทียบกับปฏิกิริยาเคมีได้อย่างไร',
    keyword: 'ปฏิกิริยาเคมี,อัตราการเกิด',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q2',
    question: 'ข้อใดไม่ใช่การติดตามการดำเนินไปของปฏิกิริยาเคมี',
    keyword: 'ปฏิกิริยาเคมี,อัตราการเกิด',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q3',
    question: 'การเกิด H2(g) ในแต่ละช่วงปริมาตรใช้เวลาเท่ากันหรือไม่ อย่างไร',
    keyword: 'ปฏิกิริยาเคมี,อัตราการเกิด',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q4',
    question: 'ปฏิกิริยาเคมีต่อไปนี้  \n\nควรติดตามการเปลี่ยนแปลงปริมาณของสารใด',
    keyword: 'ปฏิกิริยาเคมี,อัตราการเกิด',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q5',
    question: 'ปฏิกิริยาเคมีต่อไปนี้  \n\nควรติดตามการเปลี่ยนแปลงปริมาณของสารใด',
    keyword: 'ปฏิกิริยาเคมี,อัตราการเกิด',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q6',
    question: 'อัตราการเปลี่ยนแปลงปริมาณสาร คืออะไร',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q7',
    question: 'เมื่อสาร A เปลี่ยนไปเป็นสาร B รูปใดผิด',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q8',
    question: 'อัตราการเปลี่ยนแปลงของสารตั้งต้น A ข้อใดผิด',
    keyword: 'อัตราการเปลี่ยนแปลง',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q9',
    question: 'แนวคิดในการคำนวณอัตราการเปลี่ยนแปลงปริมาณของ NO2 ในช่วงเวลา 0 – 100 s ข้อใดถูกต้อง',
    keyword: 'อัตราการเปลี่ยนแปลง',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-1_Q10',
    question: 'อัตราการเปลี่ยนแปลงของผลิตภัณฑ์คือข้อใด',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q1',
    question: 'อัตราการเกิดปฏิกิริยาเคมีหมายถึงอะไร',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q2',
    question: 'เราสามารถที่จะติดตามการดำเนินไปของปฏิกิริยาได้โดยใช้สารใด',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q3',
    question: 'จากการเผาไหม้ของเซลล์เชื้อเพลิงไฮโดรเจน  อัตราการเกิดปฏิกิริยาเคมีคือข้อใด',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q4',
    question:
      'ถ้าอัตราการเปลี่ยนแปลงปริมาณของ O₂= 0.23 M/s อัตราการเปลี่ยนแปลงปริมาณของ H₂ หาได้อย่างไร',
    keyword: 'อัตราการเปลี่ยนแปลง',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q5',
    question: 'จากสมการการเผาไหม้ \n\nอัตราการเปลี่ยนแปลงปริมาณของแก๊สมีเทนคือข้อใด',
    keyword: 'อัตราการเปลี่ยนแปลง',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q6',
    question: 'จากสมการ  \nอัตราการเปลี่ยนแปลงปริมาณของสาร B เป็นกี่เท่าของสาร C',
    keyword: 'อัตราการเปลี่ยนแปลง',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q7',
    question: 'อัตราการเกิดปฏิกิริยาเคมีเฉลี่ยคืออะไร',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q8',
    question: 'อัตราการเกิดปฏิกิริยาเคมี ณ ขณะหนึ่งคืออะไร',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q9',
    question: 'เราสามารถหาอัตราการเกิดปฏิกิริยาเคมี ได้จากกราฟใด',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-2_Q10',
    question: 'สารที่ไม่ได้วัดในปฏิกิริยาจะสามารถหาความเข้มข้นได้หรือไม่ อย่างไร',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q1',
    question: 'ข้อใดถูกเกี่ยวกับ ทฤษฎีการชน',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,ทฤษฎีการชน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q2',
    question: 'ทิศทางการชนกันของ NO กับ O3 ที่ชนแล้วเกิด NO₂ กับ O₂ คือข้อใด',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,ทฤษฎีการชน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q3',
    question: 'ค่าพลังงานก่อกัมมันต์ เทียบได้กับสิ่งใด',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,พลังงานก่อกัมมันต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q4',
    question: 'ข้อใดถูกต้องเกี่ยวกับ พลังงานก่อกัมมันต์',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,พลังงานก่อกัมมันต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q5',
    question: 'สารเชิงซ้อนกัมมันต์ อยู่ที่จุดใดของภาพ',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,พลังงานก่อกัมมันต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q6',
    question: 'สถานะแทรนซิชัน คือข้อใด',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,สถานะแทรนซิชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q7',
    question: 'ข้อใดถูก',
    keyword: 'อัตราการเกิดปฏิกิริยาเคมี,ทฤษฎีการชน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q8',
    question: 'ข้อใดผิด',
    keyword: 'คายพลังงานเ,ดูดพลังงาน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q9',
    question:
      'ปฏิกิริยาเคมีที่ 1 คายพลังงาน 20 kJ/mol มี Ea=52 kJ/mol ปฏิกิริยาที่ 2 ดูดพลังงาน 30 kJ/mol มี Ea= 45 kJ/mol  ปฏิกิริยาเคมีใดเกิดได้เร็วกว่ากัน เพราะเหตุใด',
    keyword: 'คายพลังงานเ,ดูดพลังงาน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-4_Q10',
    question: 'ปฏิกิริยาคายพลังงาน คือรุปใด',
    keyword: 'คายพลังงานเ,ดูดพลังงาน',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q1',
    question: 'จากการทดลองปฏิกิริยาเคมีที่เกิดขึ้น ตรงกับสมการใด',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q2',
    question: 'บีกเกอร์ใบที่ 1 ใส่ผง CaCO3 เทียบกับบีกเกอร์ใบที่ 3 ใส่เม็ด CaCO3 จะเป็นอย่างไร',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q3',
    question: 'ข้อใดถูก',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q4',
    question:
      'ข้อใดไม่ได้นำความรู้เกี่ยวกับผลของอุณหภูมิที่มีต่ออัตราการเกิดปฏิกิริยาเคมี มาใช้งาน',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q5',
    question:
      'เมื่อใส่ผง Mg 0.5 g  ลงในสารละลาย HCl ที่มี ความเข้มข้น 1.0 M V=10 mL,20 mL อัตราการเกิดปฏิกิริยาเคมีจะเป็นอย่างไร',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q6',
    question: 'อัตราการเกิดปฏิกิริยาเคมีในสารละลายใดมีค่ามากที่สุด',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q7',
    question: 'สมการการสลายตัวของ  H2O2   คือข้อใด',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q8',
    question: 'เมื่อเติม KI ลงใน H2O2 จะทำให้อัตราการสลายตัวเป็นอย่างไร',
    keyword: 'ปัจจัยอัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q9',
    question: 'ข้อใดกล่าวผิดเกี่ยวับ ตัวเร่งปฏิกิริยา',
    keyword: 'ตัวเร่งปฏิกิริยา,อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 8-5_Q10',
    question: 'ตัวหน่วงปฏิกิริยา ใช้ทำอะไร',
    keyword: 'ตัวหน่วงปฏิกิริยา,อัตราการเกิดปฏิกิริยาเคมี',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q1',
    question: 'แนวโน้มจำนวนลวดเย็บกระดาษที่ย้ายในแต่ละครั้งเป็นอย่างไร',
    keyword: 'การเปลี่ยนแปลง,ผันกลับได้',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q2',
    question: 'ข้อใดไม่ถูกต้องเกี่ยวกับสภาวะสมดุล',
    keyword: 'สมดุล,พลวัต',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q3',
    question: 'สมดุลจะเกิดกับการเปลี่ยนแปลงชนิดใด',
    keyword: 'สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q4',
    question: 'การทดลองตอนที่ 2 และ 3 สีของสารละลายแต่ละหลอดคงที่ เพราะเหตุใด',
    keyword: 'สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q5',
    question: 'ปฏิกิริยานี้เป็นปฏิกิริยาผันกลับได้หรือไม่',
    keyword: 'ปฏิกิริยาผันกลับได้',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q6',
    question: 'ปฏิกิริยานี้เป็นปฏิกิริยาผันกลับได้หรือไม่',
    keyword: 'ปฏิกิริยาผันกลับได้',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q7',
    question: 'ที่สมดุล มีสารใดอยู่บ้าง',
    keyword: 'สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q8',
    question: 'ระบบเข้าสู่สมดุลที่เวลาใด',
    keyword: 'สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q9',
    question: 'ความเข้มข้นของสารตั้งต้นและผลิตภัณฑ์ ตั้งแต่เริ่มปฏิกิริยาจนกระทั่งสมดุลเป็นอย่างไร',
    keyword: 'สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-1_Q10',
    question: 'กราฟข้อใดถูกต้อง',
    keyword: 'สมดุล,อัตราการเกิดปฏิกิริยาไปข้างหน้า,อัตราการเกิดปฏิกิริยาย้อนกลับ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q1',
    question:
      'ปฏิกิริยา\n\nทำการทดลองที่อุณหภูมิเดียวกัน โดยเปลี่ยนความเข้มข้นสารตั้งต้น ที่สมดุลพบว่ามีค่า                มีค่าใกล้เคียงกันมาก\n\nค่า               เรียกว่าอะไร',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q2',
    question:
      'ตัวเลขยกกำลังของความเข้มข้นของสารตั้งต้นและผลิตภัณฑ์ของค่าคงที่สมดุล สอดคล้องกับตัวเลขใด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q3',
    question: 'ปฏิกิริยาเคมีทั่วไป\n\nค่าคงที่สมดุลคือข้อใด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q4',
    question: 'สารในข้อใดที่ไม่นำมาคิดในการคำนวณค่าคงที่สมดุล',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q5',
    question: 'ข้อใดคือค่าคงที่สมดุลของปฏิกิริยา',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q6',
    question: 'ปฏิกิริยาที่มีค่าคงที่สมดุลในข้อใดที่สารตั้งต้นทำปฏิกิริยาไปข้างหน้าได้ดีที่สุด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q7',
    question:
      'ปฏิกิริยาเคมีที่ 1 มี K = 0.25\nปฏิกิริยาเคมีที่ 2 มี K = 125\n\nปฏิกิริยาใดมีอัตราการเกิดปฏิกิริยาเคมีสูงกว่า',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q8',
    question: 'ข้อใดถูกต้องเกี่ยวกับค่าคงที่สมดุล',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q9',
    question: 'ปฏิกิริยาเคมี\n\nมีค่า   แล้วปฏิกิริยา\n\nมีค่าคงที่สมดุลตรงกับข้อใด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q10',
    question: 'ปฏิกิริยาเคมี\n\nมีค่า   แล้วปฏิกิริยา\n\nมีค่าคงที่สมดุลตรงกับข้อใด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q11',
    question:
      'ปฏิกิริยาเคมี\n\nมีค่า   ปฏิกิริยาเคมี\n\nมีค่า แล้วปฏิกิริยา\n\nมีค่าคงที่สมดุลตรงกับข้อใด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-2_Q12',
    question:
      'ปฏิกิริยาเคมี\n\nมีค่าคงที่เท่ากับ K1   ปฏิกิริยาเคมี\n\nมีค่าคงที่เท่ากับ K2   แล้วปฏิกิริยา\n\nมีค่าคงที่สมดุลตรงกับข้อใด',
    keyword: 'ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q1',
    question: 'การเติม HCl ลงในหลอดทดลอง เป็นการเพิ่มความเข้มข้นของสารใด',
    keyword: 'สมดุล,ความเข้มข้น',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q2',
    question: 'การเติม NaOH ลงในหลอดทดลอง เป็นการรบกวนสมดุลอย่างไร',
    keyword: 'สมดุล,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q3',
    question: 'จากกราฟ สมดุลถูกรบกวนอย่างไร',
    keyword: 'สมดุล,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q4',
    question:
      'เมื่อรบกวนสมดุลด้วยการเพิ่มความเข้มข้น จะหาความเข้มข้นของสารต่างๆที่สมดุลใหม่ได้หรือไม่',
    keyword: 'สมดุล,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q5',
    question: 'สมดุลของ เมื่อลดปริมาตรของระบบลงครึ่งหนึ่ง ระบบจะปรับตัวเข้าสมดุลใหม่อย่างไร',
    keyword: 'สมดุล,ความดัน,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q6',
    question:
      'การรบกวนสมดุลโดยการลดปริมาตร สมดุลปรับตัวเข้าสู่สมดุลใหม่ ในทิศทางที่ทำให้จำนวนโมลของแก๊สเป็นอย่างไร',
    keyword: 'สมดุล,ความดัน,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q7',
    question:
      'ปริมาตรของระบบคงที่ การเพิ่มความดันด้วยการเติมแก๊สชนิดอื่นที่ไม่ทำปฏิกิริยาเคมีกับสารในระบบ ส่งผลต่อสมดุลอย่างไร',
    keyword: 'สมดุล,ความดัน,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q8',
    question:
      'ปฏิกิริยาของ เป็นปฏิกิริยาดูดพลังงาน\nเมื่อเพิ่มอุณหภูมิ ความเข้มข้นของ NO₂ จะเป็นอย่างไร',
    keyword: 'สมดุล,อุณหภูมิ,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q9',
    question:
      'สมดุลเคมีที่ปฏิกิริยาไปข้างหน้าเป็นปฏิกิริยาดูดพลังงาน การเพิ่มอุณหภูมิส่งผลต่อสมดุลอย่างไร',
    keyword: 'สมดุล,อุณหภูมิ,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q10',
    question:
      'สมดุลเคมีที่ปฏิกิริยาไปข้างหน้าเป็นปฏิกิริยาดูดพลังงาน การเพิ่มอุณหภูมิส่งผลต่อค่าคงที่สมดุลอย่างไร',
    keyword: 'สมดุล,อุณหภูมิ,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q11',
    question:
      'สมดุลของ\n\nมีค่าคงที่ ที่ 400 และ 500 เคลวิน เท่ากับ 1.4 และ 41 ตามลำดับ ปฏิกิริยานี้เป็นปฏิกิริยาประเภทใด',
    keyword: 'สมดุล,อุณหภูมิ,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q12',
    question: 'สมดุลของ การรบกวนสมดุลในข้อใดส่งผลต่อสมดุลต่างจากข้ออื่น',
    keyword: 'สมดุล,ความดัน,ความเข้มข้น,เลอชาเตอลิเอ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-4_Q13',
    question: 'การเติมตัวเร่งปฏิกิริยาลงในปฏิกิริยาที่เข้าสู่สมดุลแล้ว จะส่งผลต่อสมดุลอย่างไร',
    keyword: 'สมดุล,ตัวเร่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q1',
    question:
      'จากกราฟความสัมพันธ์ระหว่างความเข้มข้นสารกับเวลาของสมดุล  \nค่าคงที่สมดุลก่อนรบกวนสมดุลมีค่าเท่าไหร่',
    keyword: 'สมดุล,ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q2',
    question:
      'จากกราฟความสัมพันธ์ระหว่างความเข้มข้นสารกับเวลาของสมดุล  \nเมื่อระบบเข้าสู่สมดุลใหม่ ค่าคงที่สมดุลมีค่าเท่าไหร่',
    keyword: 'สมดุล,ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q3',
    question: 'จากกราฟความสัมพันธ์ระหว่างความเข้มข้นสารกับเวลาของสมดุล  \nมีการรบกวนสมดุลอย่างไร',
    keyword: 'สมดุล,ค่าคงที่สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q4',
    question:
      'จากกราฟความสัมพันธ์ระหว่างความเข้มข้นสารกับเวลาของสมดุล  \nKt=15 = 16 และ Kt=25 = 6.0  ปฏิกิริยานี้เป็นปฏิกิริยาดูดหรือคายพลังงาน',
    keyword: 'สมดุล,ค่าคงที่สมดุล,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q5',
    question: 'การผลิต NH3 เป็นดังสมการ วิธีการใดส่งผลต่อปริมาณ NH3 ในกระบวนการผลิต ต่างจากข้ออื่น',
    keyword: 'สมดุล,ความเข้มข้น',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q6',
    question: 'การผลิต NH3 เป็นดังสมการ วิธีการใดสามารถเพิ่มปริมาณ NH3 ในกระบวนการผลิตได้',
    keyword: 'สมดุล,ปริมาตร,ความดัน,อุณหภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q7',
    question: 'CO2 ทำปฏิกิริยากับน้ำในเลือดได้ดังนี้ ปฏิกิริยารวมคือข้อใด',
    keyword: 'สมดุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q8',
    question:
      'CO2 ทำปฏิกิริยากับน้ำเลือดได้ดังนี้ \n\nถ้าร่างกายขับ CO2 ออกไปมากกว่าปกติ จะทำให้ปริมาณ H3O+ อย่างไร',
    keyword: 'สมดุล,ความเข้มข้น,หายใจเกิน',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q9',
    question:
      'ไฮดรอกซิลแอพาไทต์ (Ca5(PO4)3OH) เป็นองค์ประกอบหลักของสารเคลือบฟัน เมื่อละลายน้ำแตกตัวเป็นไอออน ดังสมการเคมี ข้อใดทำให้ปฏิกิริยาเกิดไปข้างหน้าได้มากขึ้น',
    keyword: 'สมดุล,ความเข้มข้น,ฟันผุ',
    max_score: 1
  },
  {
    intentname: 'Chapter 9-5_Q10',
    question:
      'การเกิดหินงอกหินย้อย เป็นไปตามสมการ \nปัจจัยข้อใดที่ทำให้เกิดปฏิกิริยาย้อนกลับได้ CaCO3 ที่เป็นหินงอกหินย้อย',
    keyword: 'สมดุล,ความเข้มข้น,หินงอกหินย้อย',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q1',
    question: 'ข้อใดคือสารที่เป็นกรดตามทฤษฎีกรด-เบสอาร์เรเนียส',
    keyword: 'อาร์เรเนียส,กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q2',
    question: 'สารที่เป็นกรดหรือเบสตามทฤษฎีกรด-เบสอาร์เรเนียสต้องเป็นสารชนิดใด',
    keyword: 'อาร์เรเนียส,กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q3',
    question: 'ข้อใดคือสารที่เป็นเบสตามทฤษฎีกรด-เบสเบรินสเตด-ลาวรี',
    keyword: 'เบรินสเตด,ลาวรี,กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q4',
    question: 'CH₃COONa เป็นกรดหรือเบส ตามทฤษฎีกรด-เบสเบรินสเตด-ลาวรี',
    keyword: 'เบรินสเตด,ลาวรี,กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q5',
    question: 'ข้อใดคือสารที่เป็นกรดตามทฤษฎีกรด-เบสลิวอิส',
    keyword: 'ลิวอิส,กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q6',
    question: 'ปฏิกิริยาระหว่าง NH₃  กับ BF₃  สารใดเป็นเบสตามทฤษฎีกรด-เบสลิวอิส',
    keyword: 'ลิวอิส,กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q7',
    question: 'ในปฏิริยานี้ HF ทำหน้าที่เป็นกรด คู่เบสของ HF คือสารใด',
    keyword: 'คู่กรด-เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q8',
    question: 'ข้อใดเป็นกรดพอลิโปรติก',
    keyword: 'กรดมอนอโปรติก,กรดพอลิโปรติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q9',
    question: 'ข้อใดเป็นสมการแสดงการแตกตัวขั้นที่ 2 ของ H₃PO₄',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q10',
    question: 'การแตกตัวขั้นที่ 2 ของ H₃PO₄ สารคู่ใดเป็นคู่กรด-เบส',
    keyword: 'คู่กรด-เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q11',
    question: 'ข้อใดระบุคู่กรด-เบส ของสมการขั้นที่ 2 ที่ S²- รับโปรตอนจากน้ำ',
    keyword: 'คู่กรด-เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-1_Q12',
    question: 'สารในข้อใดเป็นสารแอมโฟเทอริก',
    keyword: 'คู่กรด-เบส,สารแอมโฟเทอริก',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q1',
    question: 'ข้อใดเป็นสมบัติจากการที่กรดและเบสส่วนใหญ่แตกตัวได้ในน้ำให้ผลิตภัณฑ์เป็นไอออน',
    keyword: 'นำไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q2',
    question: 'สารละลายข้อใดนำไฟฟ้าได้ดีที่สุด',
    keyword: 'นำไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q3',
    question: 'สารละลายข้อใดนำไฟฟ้าได้ดีที่สุด',
    keyword: 'นำไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q4',
    question: 'สำหรับสารละลายกรดที่มีความเข้มข้นเท่ากัน ข้อใดถูกต้อง',
    keyword: 'pH',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q5',
    question: 'ข้อใดเป็นสมการการแตกตัวของกรดแก่ HX',
    keyword: 'กรดแก่',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q6',
    question: 'ข้อใดแสดงการแตกตัวยของกรดแก่ HX',
    keyword: 'กรดแก่',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q7',
    question: 'กรดแก่ HCl 0.10 mol/L แตกตัวให้ H+ และ Cl- อย่างละเท่าไหร่',
    keyword: 'กรดแก่',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q8',
    question: 'สารละลายในข้อใดมีปริมาณไอออนต่างจากข้ออื่น',
    keyword: 'กรดแก่,เบสแก่',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q9',
    question:
      'ต้องใช้ HBr กี่โมล ในการเตรียมสารละลาย 2.0 ลิตร ที่มีความเข้มข้นของ H+ และ Br- อย่างละ 0.60 โมลต่อลิตร',
    keyword: 'กรดแก่',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q10',
    question: 'ข้อใดเป็นสมการการแตกตัวของกรดอ่อน HA',
    keyword: 'กรดอ่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q11',
    question:
      'สารละลายกรดอ่อน HA เข้มข้น 1.00 mol/L แตกตัวได้ร้อยละ 5 มีความเข้มข้นของสารต่างๆที่สมดุลเป็นอย่างไร',
    keyword: 'กรดอ่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q12',
    question:
      'NH3 0.20 โมลต่อลิตร แตกตัวให้ไฮดรอกไซด์ไอออน (OH-) 1.9 × 10-3  โมลต่อลิตร NH3 มีร้อยละการแตกตัวเท่าไหร่',
    keyword: 'เบสอ่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q13',
    question: 'ค่า Ka และ Kb ไม่ขึ้นกับข้อใด',
    keyword: 'Ka,Kb,กรดอ่อน,เบสอ่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q14',
    question: 'H₂SO₄ 1 โมลต่อลิตร ที่สมดุลมีความเข้มข้นของ H₃O+ เท่าใด',
    keyword: 'Ka',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q15',
    question: 'CH₃COOH 0.10 โมลต่อลิตร และ CH₃COOH 1.0 โมลต่อลิตร มีร้อยละการแตกตัวเป็นอย่างไร',
    keyword: 'กรด,เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-2_Q16',
    question: 'ข้อใดเป็นความสัมพันธ์ระหว่าง  Kw Ka และ Kb',
    keyword: 'กรด,เบส,น้ำ,Kw,Ka,Kb',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q1',
    question: 'NaCl NH4Cl CH3COONa ละลายน้ำแล้วให้ไอออนใดบ้าง',
    keyword: 'การแตกตัว,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q2',
    question: 'ไอออนใดทำให้สมบัติกรด-เบสของ NaCl กับ NH₄Cl แตกต่างกัน',
    keyword: 'การแตกตัว,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q3',
    question: 'ทำไม NH₄NO₃ เป็นกรด',
    keyword: 'การแตกตัว,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q4',
    question: 'เมื่อ NaHCO₃ ละลายน้ำ ข้อใดผิด',
    keyword: 'การแตกตัว,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q5',
    question: 'ข้อใดถูก เกี่ยวกับค่า Ka หรือ Kb ของไอออนที่เกิดปฏิกิริยาไฮโดรลิซิส',
    keyword: 'Ka,Kb,ไฮโดรลิซิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q6',
    question: 'ถ้า pH มาก ความเข้มข้นของ H3O+ จะเป็นอย่างไร',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q7',
    question: 'ข้อใดถูก',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q8',
    question: 'CH₃COOH 0.50 mol/L  มีความเข้มข้นของ H₃O+ = 3.0 × 10-3 mol/L  มีค่า pH เท่าใด',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q9',
    question: 'สารละลายของยาลดกรดในกระเพาะอาหาร pH 10.00 มีค่า pOH เท่าใด',
    keyword: 'pH,pOH',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q10',
    question: 'HNO2 และ HNO3 สารใดมี H3O+ มากกว่ากัน',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-4_Q11',
    question: 'HNO2 และ HNO3 สารใดมี  pH มากกว่ากัน เพราะเหตุใด',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q1',
    question: 'สารละลาย B มี pH อยู่ในช่วงใด',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q2',
    question: 'ถ้าหยดเมทิลเรดลงในสารละลาย A และ B สารละลายแต่ละชนิดจะมีสีอะไร',
    keyword: 'อินดิเคเตอร์,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q3',
    question: 'สาร A มีค่า pH อยู่ในช่วงใด',
    keyword: 'อินดิเคเตอร์,pH',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q4',
    question: 'สาร C มีค่า pH อยู่ในช่วงใด',
    keyword: 'pH,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q5',
    question: 'ข้อใดคือสมการปฏิกิริยาสะเทินระหว่าง\nHBr และ LiOH',
    keyword: 'ปฏิกิริยาสะเทิน,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q6',
    question: 'ให้ระบุความเป็นกรด-เบส ของสารละลายหลังการสะเทินของ',
    keyword: 'ปฏิกิริยาสะเทิน,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q7',
    question: 'ข้อใดคือสมการปฏิกิริยาสะเทินระหว่าง\nHNO₃ และ NH₃',
    keyword: 'ปฏิกิริยาสะเทิน,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q8',
    question: 'ให้ระบุความเป็นกรด-เบส ของสารละลายหลังการสะเทินของ',
    keyword: 'ปฏิกิริยาสะเทิน,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q9',
    question: 'สารละลายมาตรฐาน คืออะไรจร้ะ',
    keyword: 'ไทเทรต,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q10',
    question: 'จงเขียนสมการของ HCl และ NaOH ที่ทำปฏิกิริยาพอดีกัน',
    keyword: 'ไทเทรต,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-5_Q11',
    question: 'จงคำนวณความเข้มข้นของ HCl',
    keyword: 'ไทเทรต,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q1',
    question: 'จงเขียนสมการของ CH₃COOH  และ NaOH ที่ทำปฏิกิริยาพอดีกัน',
    keyword: 'ไทเทรต,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q2',
    question: 'จงคำนวณความเข้มข้นของ CH₃COOH',
    keyword: 'ไทเทรต,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q3',
    question: 'ใช้อะไรบอกถึงการเปลี่ยน pH ระหว่างการไทเทรต',
    keyword: 'ไทเทรต,pH',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q4',
    question: 'น้องบอกพี่หน่อยว่า จุดยุติ คืออะไรคะ',
    keyword: 'กรด เบส,จุดยุติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q5',
    question: 'การเปลี่ยนสีที่จุดยุติของเมทิลออเรนจ์ คือข้อใด',
    keyword: 'อินดิเคเตอร์,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q6',
    question: 'อินดิเคเตอร์ใด บอกจุดยุติได้ใกล้เคียงกับจุดสมลูล',
    keyword: 'อินดิเคเตอร์,จุดสมมูล',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q7',
    question: 'อินดิเคเตอร์ใดที่เหมาะสมในการไทเทรตNH₃ กับ HCl',
    keyword: 'อินดิเคเตอร์,ไทเทรต',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q8',
    question: 'การเปลี่ยนสีที่จุดยุติของเมทิลเรด คือข้อใด',
    keyword: 'อินดิเคเตอร์,จุดยุติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q9',
    question: 'เมื่อเติม NaOH ในหลอดที่ 2 ที่มีน้ำกลั่นอยู่ จะไดสีอะไร',
    keyword: 'อินดิเคเตอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q10',
    question: 'สมการของบัฟเฟอร์ CH3COOH/CH3COONa คือข้อใด',
    keyword: 'บัฟเฟอร์,กรด เบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q11',
    question: 'เราจะแก้ดินเปรี้ยว โดยการใส่สารใดลงไป',
    keyword: 'กรด เบส,ดินเปรี้ยว',
    max_score: 1
  },
  {
    intentname: 'Chapter 10-6_Q12',
    question: 'ถ้าเติมเบสเล็กน้อยลงในน้ำทะเล จะมีสมการใด',
    keyword: 'กรด เบส,pH',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q1_ธรรมดา',
    question: 'ข้อใดคือความหมายของปฏิกิริยารีดอกซ์คะ?',
    keyword: 'ปฏิกิริยารีดอกซ์,การถ่ายโอนอิเล็กตรอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q2_ธรรมดา',
    question: 'เลขออกซิเดชันของ C ในแกรไฟต์ มีค่าเท่าใดคะ',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q3_ธรรมดา',
    question: 'เลขออกซิเดชันของ O ใน O₂ มีค่าเท่าใดคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q4_ธรรมดา',
    question: 'เลขออกซิเดชันของ Ba²⁺ มีค่าเท่าใดคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q5_ธรรมดา',
    question: 'เลขออกซิเดชันของ Sb³⁻ มีค่าเท่าใดคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q6_ธรรมดา',
    question: 'ข้อใดกล่าวถูกต้อง เกี่ยวกับเลขออกซิเดชันคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q7_ธรรมดา',
    question: 'เลขออกซิเดชันของ SO₄²⁻ มีค่าเท่าใดคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q8_ธรรมดา',
    question: 'เลขออกซิเดชันของ NH₄⁺ มีค่าเท่าใดคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q9_ธรรมดา',
    question: 'หาเลขออกซิเดชันของธาตุทั้งหมดในซัลเฟอร์ไดออกไซด์ (SO₂) คะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q10_ธรรมดา',
    question: 'หาเลขออกซิเดชันของธาตุทั้งหมดในฟอสเฟตไอออน (PO₄³⁻) คะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q11_ธรรมดา',
    question: 'เลขออกซิเดชันของโครเมียม (Cr) ในโครเมียม(II)ออกไซด์ (CrO) มีค่าเป็นเท่าใดคะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q12_ธรรมดา',
    question: 'เลขออกซิเดชันของโครเมียม (Cr) ในโครเมตไอออน (CrO₄²⁻) มีค่าเป็นเท่าใด คะ?',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q1_ธรรมดา',
    question: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับเลขออกซิเดชัน',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q2_ธรรมดา',
    question: 'ปฏิกิริยาใดต่อไปนี้ไม่เป็นปฏิกิริยารีดอกซ์',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q3_ธรรมดา',
    question: 'เมื่อจุ่มแผ่น Zn ลงใน CuSO4 เกิดอะไรขึ้น',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q4_ธรรมดา',
    question: 'เมื่อทำให้ของแข็งสีน้ำตาลแดงหลุดออก แผ่นโลหะ Zn จะเป็นอย่างไร ',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q5_ธรรมดา',
    question: 'ปฏิกิริยาที่เกิดขึ้นในกิจกรรมนี้ เรียกว่าอะไร',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q6_ธรรมดา',
    question: 'ข้อใดคือผลิตภัณฑ์ที่ได้จากการถ่ายโอนอิเล็กตรอนของโลหะ Zn ให้กับ Cu2+',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q7_ธรรมดา',
    question: 'เมื่อจุ่มแผ่นโลหะ Zn ในCuSO4 นานขึ้น จะสังเกตเห็นสิ่งใด',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q8_ธรรมดา',
    question:
      'เพราะเหตุใด เมื่อจุ่มแผ่นโลหะ Zn ใน CuSO4 เป็นเวลานานจึงทำให้ สารละลายสีฟ้า มีสีจางลง',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q9_ธรรมดา',
    question: ' ทำไมเมื่อจุ่มแผ่นโลหะ Zn ในสารละลาย CuSO4 นี้จึงจัดเป็นเป็นปฏิกิริยารีดอกซ์ ',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q10_ธรรมดา',
    question: 'ระบุตัวรีดิวซ์และตัวออกซิไดส์ ของสารนี้',
    keyword: 'รีดิวซ์,ตัวออกซิไดส์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q11_ธรรมดา',
    question: 'จงหาครึ่งปฏิกิริยาออกซิเดชัน ของปฏิกิริยารีดอกซ์นี้',
    keyword: 'ปฏิกิริยารีดอกซ์,ปฏิกิริยาออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q12_ธรรมดา',
    question: 'จงหาครึ่งปฏิกิริยารีดักชัน ของปฏิกิริยารีดอกซ์นี้',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q13_ธรรมดา',
    question: ' โลหะใดเมื่อจุ่มลงในสารละลายกรดแล้วเกิดปฏิกิริยาให้แก๊ส ไฮโดรเจน (H₂) ได้',
    keyword: 'ตัวออกซิไดส์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q1_ธรรมดา',
    question: 'ขั้นที่ 1 น้องๆต้องทำอะไรก่อนนะ',
    keyword: 'ดุลสมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q2_ธรรมดา',
    question: 'ข้อใดคือเลขออกซิเดชันที่เปลี่ยนแปลง',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q3_ธรรมดา',
    question: 'ข้ันที่ 2  น้องต้องทำอะไรต่อนะ',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q4_ธรรมดา',
    question: 'ข้อใดถุกต้องเกี่ยวกับการดุลจำนวนอะตอมของธาตุ',
    keyword: 'ดุลจำนวนอะตอม',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q5_ธรรมดา',
    question: 'เลขสัมประสิทธ์หน้า HCl คือข้อใด',
    keyword: 'เลขสัมประสิทธ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q6_ธรรมดา',
    question: 'ข้อใดถูกต้องเมื่อดุลจำนวนอะตอมของธาตุ ',
    keyword: 'ดุลจำนวนอะตอม',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q7_ธรรมดา',
    question: 'เมื่อดุลสมการแล้ว จะ N จะมีเลขสัมประสิทธ์ เป็นเท่าใด',
    keyword: 'เลขสัมประสิทธ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q8_ธรรมดา',
    question: 'เมื่อดุลสมการแล้ว จะ H จะมีเลขสัมประสิทธ์ เป็นเท่าใด',
    keyword: 'เลขสัมประสิทธ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q9_ธรรมดา',
    question: 'ข้อใดถูกต้อง',
    keyword: 'ปฏิกิริยาในภาวะเบส',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q10_ธรรมดา',
    question: 'เลขออกซิเดชันมีการเปลี่ยนแปลงอย่างไรบ้าง',
    keyword: 'ดุลสมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q11_ธรรมดา',
    question: 'เมื่อดุลเลขออกซิเดชันแล้วเลขสัมประสิทธิ์ในข้อใดไม่ถูกต้อง ',
    keyword: 'ดุลเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q12_ธรรมดา',
    question: 'ข้อใดถูกต้อง',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q13_ธรรมดา',
    question: 'ข้อใดคือสมการรีดอกซ์ที่ดุลแล้ว',
    keyword: 'สมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q14_ธรรมดา',
    question: 'ผลรวมของประจุไฟฟ้ามีค่าเป็นเท่าใด',
    keyword: 'ประจุไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q1_ธรรมดา',
    question: 'ข้อใดผิด',
    keyword: 'ดุลสมการรีดอกซ์,เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q2_ธรรมดา',
    question: 'ครึ่งปฏิกิริยาออกซิเดชันคือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์,ครึ่งปฏิกิริยาออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q3_ธรรมดา',
    question: 'การดุลครึ่งปฏิกิริยาออกซิเดชัน ของข้อใดไม่ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์,ครึ่งปฏิกิริยาออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q4_ธรรมดา',
    question: 'การดุลครึ่งปฏิกิริยารีดักชันและครึ่งปฏิกิริยาออกซิเดชันมีสิ่งใดที่เหมือนกัน',
    keyword: 'ครึ่งปฏิกิริยารีดักชัน,ครึ่งปฏิกิริยาออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q5_ธรรมดา',
    question:
      'ทำให้จำนวน e- ของครึ่งปฏิกิริยาออกซิเดชันให้เท่ากับครึ่งปฏิกิริยารีดักชัน โดยคูณด้วยเลขใด',
    keyword: 'ดุลสมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q6_ธรรมดา',
    question: 'ครึ่งปฏิกิริยาออกซิเดชันที่ทำจำนวน e- ให้เท่ากับครึ่งปฏิกิริยารีดักชันแล้วคือข้อใด',
    keyword: 'ครึ่งปฏิกิริยารีดักชัน,ดุลสมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q7_ธรรมดา',
    question:
      'จากครึ่งปฏิกิริยารีดักชัน เมื่อทำให้จำนวน e  เท่ากับครึ่งปฏิกิริยาออกซิเดชันแล้ว ข้อใดไม่ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์,ครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q8_ธรรมดา',
    question: 'สมการรวมคือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q9_ธรรมดา',
    question: 'สมการรีดอกซ์ที่ดุลแล้วคือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q10_ธรรมดา',
    question: 'ผลรวมจำนวนอะตอมหรือประจุไฟฟ้าของแต่ละฝั่งในข้อใดไม่ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์,เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q1_ธรรมดา',
    question: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับสะพานเกลือ',
    keyword: 'สะพานเกลือ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q2_ธรรมดา',
    question:
      'โลหะใดทำหน้าที่เป็นขั้วไฟฟ้าที่ไม่เกิดปฏิกิริยาเคมีและโลหะใดทำหน้าที่เป็นขั้วไฟฟ้าที่เกิดปฏิกิริยาเคมี',
    keyword: 'ขั้วไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q3_ธรรมดา',
    question:
      'ไอออนใดเป็นอิเล็กโทรไลต์ที่ไม่เกิดปฏิกิริยาเคมี และไอออนใดเป็นอิเล็กโทรไลต์ที่เกิด ปฏิกิริยาเคมีด้วย',
    keyword: 'อิเล็กโทรไลต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q4_ธรรมดา',
    question: 'เมื่อเวลาผ่านไป ขั้วโลหะใดกร่อนและขั้วโลหะใดหนาขึ้น',
    keyword: 'ขั้วไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q5_ธรรมดา',
    question: 'สมการรีดอกซ์ที่เกิดขึ้นคือข้อใด',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q6_ธรรมดา',
    question:
      'เมื่อต่อเซลล์เคมีไฟฟ้าครบวงจร โดยใช้สะพานเกลือที่มีสารละลาย KNO₃ เข้มข้น ไอออนแต่ละชนิดในสะพานเกลือมีทิศทางการเคลื่อนที่อย่างไร',
    keyword: 'สะพานเกลือ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q7_ธรรมดา',
    question: 'เมื่อต่อเซลล์เคมีไฟฟ้าครบวงจร ไอออนใดจะทำหน้าที่รักษาสมดุลของประจุไฟฟ้าในสารละลาย',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q8_ธรรมดา',
    question: 'เพราะเหตุใดเมื่อต่อเซลล์เคมีไฟฟ้าครบวงจรเป็นเวลานาน กระแสไฟฟ้าจึงลดลง',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q9_ธรรมดา',
    question: 'ข้อใดไม่ถูกต้อง',
    keyword: 'เซลล์กัลวานิก,เซลล์อิเล็กโทรลิติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q10_ธรรมดา',
    question: 'จากรูป ข้อใดไม่ถูกต้อง',
    keyword: 'เซลล์กัลวานิก,เซลล์อิเล็กโทรลิติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q11_ธรรมดา',
    question:
      'จากรูป หากสลับให้ขั้วบวกของแหล่งกำเนิดไฟฟ้าต่อเข้ากับโลหะสังกะสีและขั้วลบต่อเข้ากับโลหะทองแดง จะเกิดอะไรขึ้น',
    keyword: 'เซลล์อิเล็กโทรลิติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q1_ธรรมดา',
    question: 'แผนภาพเซลล์คืออะไร',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q2_ธรรมดา',
    question: 'แผนภาพเซลล์เขียนอย่างไร',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q3_ธรรมดา',
    question: 'ข้อใดกล่าวผิดเกี่ยวกับแผนภาพเซลล์',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q4_ธรรมดา',
    question: 'จากรูปเขียนแสดงแผนภาพเซลล์ได้อย่างไร',
    keyword: 'แผนภาพเซลล์,ปฏิกิริยารีดักชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q5_ธรรมดา',
    question: 'แผนภาพครึ่งเซลล์ที่เกิดปฏิกิริยารีดักชัน คือข้อใด',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q6_ธรรมดา',
    question: 'ในกรณีที่สารในครึ่งเซลล์ผสมเป็นเนื้อเดียวกัน น้องเจอเจอสัญลักษณ์ใด',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q7_ธรรมดา',
    question: 'ข้อใดถูกต้อง',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q8_ธรรมดา',
    question: 'แผนภาพเซลล์ใดผิต',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q9_ธรรมดา',
    question: 'แผนภาพเซลล์คือข้อใด',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q10_ธรรมดา',
    question: 'จากรูปเขียนแผนภาพเซลล์อิเล็กโทรลิติกได้อย่างไร',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q11_ธรรมดา',
    question: 'จากปฏิกิริยาเคมีนี้ แผนภาพเซลล์กัลวานิกคือข้อใด',
    keyword: 'แผนภาพเซลล์,ปฏิกิริยารีดักชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q12_ธรรมดา',
    question: 'แผนภาพครึ่งเซลล์ที่เกิดปฏิกิริยารีดักชัน คือข้อใด',
    keyword: 'แผนภาพเซลล์,แคโทด',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q13_ธรรมดา',
    question:
      'จากแผนภาพเซลล์   Zn(s)|Zn2+(aq, 1 M)||H+(aq, 1 M)|H₂(g, 1 atm)|Pt(s)ข้อใดคือสมการแสดงปฏิกิริยาที่แคโทดแอโนด ',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q14_ธรรมดา',
    question: 'ข้อใดคือปฏิกิริยารวมของเซลล์ จากZn(s)|Zn2+(aq, 1 M)||H+(aq, 1 M)|H₂(g, 1 atm)|Pt(s)',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q1_ธรรมดา',
    question: 'ที่สภาวะมาตรฐาน ค่าศักย์ไฟฟ้าของเซลล์ Zn(s)|Zn2+(aq)||Cu2+(aq)|Cu(s) มีค่าเท่าใด',
    keyword: 'ศักย์ไฟฟ้าของเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q2_ธรรมดา',
    question: 'ข้อใดไม่ถูกต้อง',
    keyword: 'ออกซิเดชัน,รีดักชัน,แคโนด',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q3_ธรรมดา',
    question: 'เมื่อต่อครึ่งเซลล์ทั้งสอง ให้ครบวงจรแล้วได้เซลล์กัลวานิกในข้อใด',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q4_ธรรมดา',
    question: 'เข็มของมิเตอร์จะเป็นอย่างไร',
    keyword: 'โวลต์มิเตอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q5_ธรรมดา',
    question: 'ศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชัน (E⁰) คืออะไร',
    keyword: 'ศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q6_ธรรมดา',
    question:
      'ต้องการให้ศักย์ไฟฟ้าที่อ่านได้จากการต่อครึ่งเซลล์สังกะสีมาตรฐาน กับ SHE มีค่าเป็นบวก ควรต่อกับโวลต์มิเตอร์อย่างไร',
    keyword: 'ศักย์ไฟฟ้า,โวลต์มิเตอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q7_ธรรมดา',
    question: 'ศักย์ไฟฟ้าของเซลล์ที่วัดได้เป็นลบ มาจากสาเหตุใด',
    keyword: 'ศักย์ไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q8_ธรรมดา',
    question:
      'ให้เรียงลำดับความสามารถในการเป็นตัวออกซิไดส์จาก มากไปน้อยของ Na+, Mg²+, Zn²+, Pb²+, H+, Cu²+ และ Ag+ ',
    keyword: 'ตัวออกซิไดส์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q9_ธรรมดา',
    question: 'ให้เรียงลำดับความสามารถในการเป็นตัวรีดิวซ์จากมากไปน้อยของ Sn, Na, Au, Mg และ Zn',
    keyword: 'ตัวรีดิวซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q10_ธรรมดา',
    question: 'Al³+(aq)|Al(s) กับ Cu²+(aq)|Cu(s) เป็นเซลล์กัลวานิก ข้อใดถูกต้อง',
    keyword: 'ค่า E⁰',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q11_ธรรมดา',
    question: 'Al³+(aq)|Al(s) กับ Cu²+(aq)|Cu(s) เป็นเซลล์กัลวานิก จะมีค่า E⁰cell เท่าใด',
    keyword: 'ค่า E⁰',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q1_ธรรมดา',
    question: 'แบตเตอรี่เป็นอุปกรณ์ที่เปลี่ยนปฏิกิริยาเคมีไปเป็นพลังงานใด  ',
    keyword: 'แบตเตอรี่.เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q2_ธรรมดา',
    question: 'แบตเตอรี่แบ่งเป็นกี่ประเภท',
    keyword: 'แบตเตอรี่,เซลล์ปฐมภูมิ,เซลล์ทุติยภูมิ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q3_ธรรมดา',
    question: 'ข้อใดเป็นปฏิกิริยาที่แคโทดของถ่านไฟฉาย',
    keyword: 'แบตเตอรี่,ถ่านไฟฉาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q4_ธรรมดา',
    question: 'ข้อใดไม่ใช่สิ่งที่เกิดขึ้นเมื่อใช้ถ่านไฟฉายไปนาน ๆ',
    keyword: 'แบตเตอรี่.ถ่านไฟฉาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q5_ธรรมดา',
    question:
      'ข้อใดไม่ใช่สาเหตุที่ทำให้แบตเตอรี่ซิงค์-คาร์บอน หรือถ่านไฟฉาย มีอายุการเก็บและการใช้งานค่อนข้างสั้น',
    keyword: 'แบตเตอรี่.ถ่านไฟฉาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q6_ธรรมดา',
    question: 'แบตเตอรี่ที่ใช้เบสของโลหะแอลคาไลน์เป็นอิเล็กโทรไลต์ คือแบตเตอรี่ข้อใด',
    keyword: 'แบตเตอรี่แอลคาไลน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q7_ธรรมดา',
    question: 'ข้อใดเป็นปฏิกิริยาที่เกิดขึ้นภายในแบตเตอรี่แอลคาไลน์',
    keyword: 'แบตเตอรี่แอลคาไลน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q8_ธรรมดา',
    question:
      'แบตเตอรี่ที่มีส่วนประกอบคล้ายแบตเตอรี่แอลคาไลน์ คือ Zn เป็นแอโนด แต่ใช้ Ag2O เป็นแคโทดแทน MnO2 คือแบตเตอรี่ข้อใด',
    keyword: 'แบตเตอรี่ซิลเวอร์ออกไซต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q9_ธรรมดา',
    question:
      'ข้อใดเป็นปฏิกิริยาที่เกิดขึ้นเมื่อแบตเตอรี่ตะกั่วจ่ายไฟ เมื่อมี Pb เป็นแอโนด และ Pb ที่เคลือบด้วย PbO2 เป็นแคโทด ',
    keyword: 'แบตเตอรี่ตะกั่ว',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q10_ธรรมดา',
    question: 'แบตเตอรี่ตะกั่วที่ใช้ในรถยนต์มักประกอบด้วยเซลล์กัลวานิกกี่เซลล์',
    keyword: 'แบตเตอรี่ตะกั่ว',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q11_ธรรมดา',
    question: 'การชาร์จของแบตเตอรี่ตะกั่ว ใช้หลักการของเซลล์ชนิดใด',
    keyword: 'แบตเตอรี่ตะกั่ว',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q12_ธรรมดา',
    question: 'เพราะเหตุใด แบตเตอรี่ตะกั่วจึงมีอายุการใช้งานเพียงระยะเวลาหนึ่ง',
    keyword: 'แบตเตอรี่ตะกั่ว',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-8_Q13_ธรรมดา',
    question:
      'ปฏิกิริยาที่แอโนดของแบตเตอรี่ลิเทียมไอออนขณะชาร์จเป็นอย่างไร หากปฏิกิริยาขณะจ่ายไฟเป็นดังนี้',
    keyword: 'แบตเตอรี่ลิเทียมไอออน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q1_ธรรมดา',
    question: 'ข้อใดคือเซลล์เชื้อเพลิง',
    keyword: 'เซลล์เชื้อเพลิง',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q2_ธรรมดา',
    question: 'ในเซลล์เชื้อเพลิง สารที่เป็นเชื้อเพลิงจะเกิดปฏิกิริยาที่ขั้วไฟฟ้าใด',
    keyword: 'เซลล์เชื้อเพลิง',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q3_ธรรมดา',
    question: 'ข้อใดไม่ใช่สารตั้งต้นในเซลล์เชื้อเพลิงแบบแอลคาไลน์',
    keyword: 'เซลล์เชื้อเพลิงแบบแอลคาไลน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q4_ธรรมดา',
    question: 'ข้อใดคือผลิตภัณฑ์ที่เกิดขึ้นในเซลล์เชื้อเพลิงแบบแอลคาไลน์',
    keyword: 'เซลล์เชื้อเพลิงแบบแอลคาไลน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q5_ธรรมดา',
    question: 'เพราะเหตุใด เซลล์เชื้อเพลิงแบบแอลคาไลน์จึงถือว่าเป็นมิตรต่อสิ่งแวดล้อม',
    keyword: 'เซลล์เชื้อเพลิงแบบแอลคาไลน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q6_ธรรมดา',
    question: 'ข้อใดไม่ใช่สารตั้งต้นในเซลล์นี้',
    keyword: 'เซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q7_ธรรมดา',
    question: 'ข้อใดคือผลิตภัณฑ์ที่เกิดขึ้นในเซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน',
    keyword: 'เซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q8_ธรรมดา',
    question: 'ข้อใดไม่ใช่ปฏิกิริยาที่เกิดขึ้นในเซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน',
    keyword: 'เซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q9_ธรรมดา',
    question: 'เพราะเหตุใด เซลล์เชื้อเพลิงมีประสิทธิภาพมากกว่าการเผาไหม้ปกติ',
    keyword: 'เซลล์เชื้อเพลิง',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q10_ธรรมดา',
    question:
      'ข้อใดคือสิ่งที่เหมือนกันของเซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอนและเซลล์เชื้อเพลิงแบบแอลคาไลน์',
    keyword: 'เซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน,เซลล์เชื้อเพลิงแบบแอลคาไลน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-9_Q11_ธรรมดา',
    question: 'ข้อใดไม่ใช่ข้อดีของเซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนไอออน',
    keyword: 'เซลล์เชื้อเพลิงแบบเยื่อแลกเปลี่ยนโปรตอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q1_ธรรมดา',
    question: 'การเกิดสนิมเป็นปฏิกิริยาอะไร',
    keyword: 'การเกิดสนิม,การผุกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q2_ธรรมดา',
    question: 'ในการเกิดสนิม สารตั้งต้นใดเกิดปฏิกิริยาออกซิเดชัน',
    keyword: 'การเกิดสนิม,การผุกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q3_ธรรมดา',
    question: 'ในการเกิดสนิม สารตั้งต้นใดเกิดปฏิกิริยารีดักชัน',
    keyword: 'การเกิดสนิม,การผุกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q4_ธรรมดา',
    question: 'ข้อใดคือสิ่งที่เกิดขึ้นเมื่อเหล็กสัมผัสกับแก๊สออกซิเจนและน้ำ ',
    keyword: 'การเกิดสนิม',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q5_ธรรมดา',
    question: 'ข้อใดคือสูตรทั่วไปของสนิมเหล็ก',
    keyword: 'การเกิดสนิม,การผุกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q6_ธรรมดา',
    question: 'ข้อใดเป็นปัจจัยเสริมที่ทำให้เกิดสนิมเหล็ก',
    keyword: 'การเกิดสนิม,การผุกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q7_ธรรมดา',
    question: 'ข้อใดไม่ใช่ปฏิกิริยาที่เกิดขึ้น ในการเกิดสนิมในภาวะที่มี CO2',
    keyword: 'การเกิดสนิม,การผุกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q8_ธรรมดา',
    question: 'ข้อใดไม่ใช่วิธีป้องกันการกัดกร่อนของโลหะ',
    keyword: 'การป้องกันการกัดกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q9_ธรรมดา',
    question: 'การป้องกันการกัดกร่อนของโลหะ ควรทำให้โลหะอยู่ในภาวะใด',
    keyword: 'การป้องกันการกัดกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q10_ธรรมดา',
    question:
      'การป้องกันการกัดกร่อนของโลหะ โดยการชุบโลหะหรือผสมด้วยโลหะอื่นเพื่อทำให้เป็นสารประกอบชนิดใด',
    keyword: 'การป้องกันการกัดกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-10_Q11_ธรรมดา',
    question:
      'ข้อใดคือปฏิกิริยาที่เกิดขึ้นเมื่อป้องกันการเกิดสนิมของท่อเหล็กที่ฝังไว้ใต้ดินโดยใช้โลหะแมกนีเซียม ดังรูป',
    keyword: 'การป้องกันการกัดกร่อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q1_ธรรมดา',
    question: 'การชุบโลหะ ใช้หลักการของเซลล์กัลวานิกหรือเซลล์อิเล็กโทรลิติก',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q2_ธรรมดา',
    question: 'จากการทดลอง แผ่นสังกะสีเกิดการเปลี่ยนแปลงอย่างไร',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q3_ธรรมดา',
    question: 'จากการทดลอง ตะปูเหล็กเกิดการเปลี่ยนแปลงอย่างไร',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q4_ธรรมดา',
    question: 'ขั้วไฟฟ้าที่เป็นแคโทดคือข้อใด',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q5_ธรรมดา',
    question: 'ข้อใดเป็นปฏิกิริยาเคมีที่แคโทดและแอโนด',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q6_ธรรมดา',
    question: 'การชุบตะปูเหล็กด้วยสังกะสี สารใดต่อกับขั้วบวกของแบตเตอรี่',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q7_ธรรมดา',
    question: 'การชุบตะปูเหล็กด้วยสังกะสี สามารถใช้สารข้อใดเป็นสารละลายอิเล็กโทรไลต์',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q8_ธรรมดา',
    question: 'ในการชุบโลหะ ความเข้มข้นของสารละลายอิเล็กโทรไลต์มีการเปลี่ยนแปลงอย่างไร',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q9_ธรรมดา',
    question: 'ในการชุบโลหะควรใช้กระแสไฟฟ้าแบบใดเพื่อให้ปฏิกิริยาดำเนินไปทางเดียว',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-11_Q10_ธรรมดา',
    question: 'การชุบกลอนประตูเหล็กด้วยโครเมียมต้องจัดเซลล์ไฟฟ้าตามข้อใด',
    keyword: 'การชุบโลหะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q1_ธรรมดา',
    question: 'ข้อใดคือการแยกสลายด้วยไฟฟ้า',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q2_ธรรมดา',
    question: 'ข้อใดไม่ใช่ผลิตภัณฑ์ที่ได้จากการแยกสลายโซเดียมคลอไรด์หลอมเหลว',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q3_ธรรมดา',
    question: 'การแยกสลายโซเดียมคลอไรด์หลอมเหลว เกิดปฏิกิริยาใดที่เกิดที่แคโทด',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q4_ธรรมดา',
    question: 'การแยกสลายโซเดียมคลอไรด์หลอมเหลว เกิดโลหะโซเดียมที่ขั้วไฟฟ้าใด',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q5_ธรรมดา',
    question:
      'E0 ที่เกี่ยวข้องกับการแยกสลายโซเดียมคลอไรด์หลอมเหลว คือ ค่า E0cell ของปฏิกิริยานี้เท่ากับเท่าใด',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q6_ธรรมดา',
    question: 'ข้อใดเป็นการสังเกตการเปลี่ยนแปลงที่ได้จาก',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q7_ธรรมดา',
    question: 'จากการทดลอง ผลิตภัณฑ์ใดเกิดขึ้นที่ขั้วบวก',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q8_ธรรมดา',
    question: 'จากการทดลอง ข้อใดไม่ใช่ผลิตภัณฑ์ทีเกิดขึ้นที่ขั้วลบ',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q9_ธรรมดา',
    question: 'จากการทดลอง ปฏิกิริยาใดเป็นปฏิกิริยาที่เป็นไปได้ที่ขั้วบวก',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-12_Q10_ธรรมดา',
    question:
      'E0 ที่เกี่ยวข้องกับการแยกสลาย KI(aq) คือ ต้องให้พลังงานที่มีอีเอ็มเอฟมากกว่าเท่าใดเพื่อให้เกิดปฏิกิริยา',
    keyword: 'การแยกสลายด้วยไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q1_ธรรมดา',
    question:
      'การทำโลหะให้บริสุทธิ์ด้วยหลักการของการแยกสลายด้วยไฟฟ้า ต้องจัดเซลล์ให้เป็นเซลล์แบบใด',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q2_ธรรมดา',
    question:
      'การทำทองแดงให้บริสุทธิ์จัดเซลล์ ดังรูป โลหะทองแดงที่ไม่บริสุทธิ์ต้องต่อเข้ากับขั้วไฟฟ้าใดของแบตเตอรี่',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q3_ธรรมดา',
    question: 'การทำทองแดงให้บริสุทธิ์ สามารถใช้สารข้อใดเป็นสารละลายอิเล็กโทรไลต์',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q4_ธรรมดา',
    question: 'การทำทองแดงให้บริสุทธิ์จัดเซลล์ ดังรูป ขั้วไฟฟ้าใดทำหน้าที่เป็นแคโทด',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q5_ธรรมดา',
    question:
      'การทำทองแดงให้บริสุทธิ์จัดเซลล์ ดังรูป ถ้าทองแดงที่ไม่บริสุทธิ์มี Fe และ Zn เจือปน ที่สภาวะมาตรฐาน ข้อใดไม่ใช่ปฏิกิริยาที่เกิดที่แอโนด',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q6_ธรรมดา',
    question:
      'การทำทองแดงให้บริสุทธิ์จัดเซลล์ ดังรูป ถ้าทองแดงที่ไม่บริสุทธิ์มี Fe และ Zn เจือปน ที่สภาวะมาตรฐาน ข้อใดคือปฏิกิริยาที่เกิดที่แคโทด',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q7_ธรรมดา',
    question: 'เพราะเหตุใด ที่แคโทดจึงเกิดแต่ปฏิกิริยารีดักชันของ Cu2+',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q8_ธรรมดา',
    question: 'ข้อใดคือแหล่งกำเนิด Fe2+ และ Zn2+ ในสารละลาย',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q9_ธรรมดา',
    question:
      'การทำทองแดงให้บริสุทธิ์จัดเซลล์ ดังรูป ปฏิกิริยารีดักชันของ Cu2+ เกิดขึ้นที่ขั้วบวกหรือขั้วลบ',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-13_Q10_ธรรมดา',
    question:
      'จากค่า E0 ทีเกี่ยวข้อง อีเอ็มเอฟที่ให้ในข้อใดที่ทำให้ได้ทองแดงบริสุทธิ์ ที่สภาวะมาตรฐาน',
    keyword: 'การทำโลหะให้บริสุทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q1_ธรรมดา',
    question:
      'สารที่ดูดกลืนพลังงานแสงแล้วเกิดปฏิกิริยารีดอกซ์ได้ สามารถนำมาใช้เป็นองค์ประกอบในเซลล์เคมีไฟฟ้าชนิดใด',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q2_ธรรมดา',
    question: 'ข้อใดไม่ใช่สารรับแสงที่นิยมใช้ใน solar cell',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q3_ธรรมดา',
    question: 'ข้อใดไม่ใช่ประโยชน์ของการพัฒนา solar cell ที่ใช้สารรับแสงประเภทต่าง ๆ',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q4_ธรรมดา',
    question: 'ข้อใดคือไม่ใช่ผลจากการเพิ่มรูพรุนของขั้วไฟฟ้า',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q5_ธรรมดา',
    question: 'ข้อใดกล่าวถึงอิเล็กโทรไลต์ได้ถูกต้อง',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q6_ธรรมดา',
    question: 'ข้อใดกล่าวถึงขั้วไฟฟ้าของลิเทียมไอออนแบตเตอรี่ได้ถูกต้อง',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q7_ธรรมดา',
    question: 'ข้อใดกล่าวถึงแกรฟีนไม่ถูกต้อง',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q8_ธรรมดา',
    question: 'ผลิตภัณฑ์ในข้อใดคือประโชน์จากการเคลือบขั้วไฟฟ้าด้วยเอนไซม์หรือสารเคมีบางชนิด',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q9_ธรรมดา',
    question: 'ข้อใดกล่าวถึงอิเล็กโทรไลต์ที่เป็นของแข็งไม่ถูกต้อง ',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-14_Q10_ธรรมดา',
    question: 'เพราะเหตุใด การใช้อิเล็กโทรไลต์ที่เป็นของแข็งจึงมีความปลอดภัยมากขึ้น',
    keyword: 'เทคโนโลยี',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q1_อ่อน',
    question: 'เลขออกซิเดชันของ F ใน F2 มีค่าเท่าใด',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q2_อ่อน',
    question: 'เลขออกซิเดชันของ Mn2+ มีค่าเท่าใด',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q3_อ่อน',
    question: 'เลขออกซิเดชันของ H- มีค่าเท่าใด',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q4_อ่อน',
    question: 'ธาตุใดมีเลขออกซิเดชันเป็น +3 เสมอ',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q5_อ่อน',
    question: 'เลขออกซิเดชันของไฮโดรเจน ในสารประกอบใดที่มีค่าไม่เท่ากัน ',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q6_อ่อน',
    question: 'เลขออกซิเดชันของออกซิเจนในสารประกอบใดที่มีค่าเท่ากับ 2',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q7_อ่อน',
    question: 'ผลรวมของเลขออกซิเดชันของสารหรือไอออนในข้อใดมีค่ามากที่สุด',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q8_อ่อน',
    question: 'ธาตุหมู่ VIIA ในข้อใดมีเลขออกซิเดชัน เท่ากับ -1 เสมอ',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q9_อ่อน',
    question: 'เลขออกซิเดชันของคลอรีนในสารประกอบใดมีค่ามากที่สุด',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-1_Q10_อ่อน',
    question: 'เลขออกซิเดชันของคาร์บอน ในสารประกอบใดมีค่าน้อยที่สุด ',
    keyword: 'เลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q1_อ่อน',
    question: 'ข้อใดใช้พิจารณาว่าปฏิกิริยาเคมีใดเป็นปฏิกิริยารีดอกซ์หรือไม่ ',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q2_อ่อน',
    question:
      'ปฏิกิริยาเคมีนี้ เป็นปฏิกิริยารีดอกซ์หรือไม่ เพราะเหตุใด CaCO3(s) + 2HCl(aq) --->  CaCl2(aq) + H2O(l) + CO2(g)',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q3_อ่อน',
    question:
      'ปฏิกิริยาเคมีนี้ เป็นปฏิกิริยารีดอกซ์หรือไม่ เพราะเหตุใด 2H2O(l)  ---->    H2(g)   +    O2(g)',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q4_อ่อน',
    question: 'ข้อใดคือคือครึ่งปฏิกิริยารีดักชัน',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q5_อ่อน',
    question:
      'จากปฏิกิริยาเคมีต่อไปนี้ ข้อใดเป็นตัวรีดิวซ์ 2Al(s) + 3Zn2+(aq)   ---->   2Al3+(aq)   +    3Zn(s)',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q6_อ่อน',
    question:
      'จากปฏิกิริยาเคมีต่อไปนี้ ข้อใดคือครึ่งปฏิกิริยาออกซิเดชัน 2Al(s) + 3Zn2+(aq)   ---->   2Al3+(aq)   +    3Zn(s)',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q7_อ่อน',
    question: 'ปฏิกิริยาเคมีใดเป็นปฏิกิริยารีดอกซ์',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q8_อ่อน',
    question: 'ปฏิกิริยาเคมีใดไม่ใช่ปฏิกิริยารีดอกซ์',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q9_อ่อน',
    question:
      'ปฏิกิริยาเคมีนี้ มีธาตุที่เลขออกซิเดชันเปลี่ยนแปลงหลังเกิดปฏิกิริยากี่ธาตุ CO32−(aq)   +  2H+(aq)  --->    CO2(aq)   +   H2O(l)',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-2_Q10_อ่อน',
    question:
      'จากปฏิกิริยาเคมีที่กำหนด สารใดเป็นตัวออกซิไดส์ Na(s)   +  H2O(l)  --->    H2(g)   +   NaO(aq)',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q1_อ่อน',
    question: 'ขั้นตอนแรกของการดุลสมการรีดอกซ์ด้วยวิธีเลขออกซิเดชันคือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q2_อ่อน',
    question: 'จากสมการ เลขออกซิเดชันของสารมีการเปลี่ยนแปลงอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q3_อ่อน',
    question: 'ข้ันที่ 2  น้องต้องทำอะไรต่อนะ',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q4_อ่อน',
    question: 'ตัวเลขสัมประสิทธิ์หน้า Al และ Zn2+ ที่ทำให้เกิดการดุลเลขออกซิเดชันคือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q5_อ่อน',
    question: 'จากสมการเลขออกซิเดชันของแมงกานีสมีการเปลี่ยนแปลงอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q6_อ่อน',
    question: 'เลขสัมประสิทธ์หน้า Zn คือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q7_อ่อน',
    question: 'เลขสัมประสิทธ์หน้า MnO4- คือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q8_อ่อน',
    question: 'การดุล O ทำได้อย่างไร',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q9_อ่อน',
    question: 'ข้อใดถูกต้องเมื่อดุล O',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q10_อ่อน',
    question: 'ขั้นตอนต่อไปคือข้อใด',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q11_อ่อน',
    question: 'ข้อใดถูกต้องเมื่อดุล',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q12_อ่อน',
    question: 'ข้อใดถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q13_อ่อน',
    question: 'ข้อใดคือสมการรีดอกซ์ทีดุลแล้ว',
    keyword: 'ดุลสมการรีดอกซ์,วิธีเลขออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q1_อ่อน',
    question: 'การดุลสมการรีดอกซ์โดยวิธีครึ่งปฏิกิริยาต้องทำสิ่งใดก่อน',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q2_อ่อน',
    question: 'ข้อใดไม่ใช่ครึ่งปฏิกิริยาของสมการรีดอกซ์นี',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q3_อ่อน',
    question: 'ข้อใดดุลจำนวนอะตอม I ได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q4_อ่อน',
    question: 'ข้อใดดุลจำนวนประจุไฟฟ้าของสมการนี้ได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q5_อ่อน',
    question: 'ครึ่งปฏิกิริยารีดักชันนี้ ควรดุลจำนวนอะตอมของธาตุใดก่อน',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q6_อ่อน',
    question: 'การดุลจำนวนอะตอม O จะใช้โมเลกุลใด',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q7_อ่อน',
    question: 'ข้อใดดุลจำนวนอะตอม H ได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q8_อ่อน',
    question: 'ต้องดุลประจุไฟฟ้าโดยใช้จำนวน e- เท่าใด',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q9_อ่อน',
    question:
      'จะทำให้จำนวน e- ของสองครึงปฏิกิริยานี้เท่ากันได้ยังไง ครึ่งปฏิกิริยาออกซิเดชัน ครึ่งปฏิกิริยารีดักชัน',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q10_อ่อน',
    question:
      'ในการรวมสองครึ่งปฏิกิริยา ถ้ามีอิเล็กตรอน โมเลกุล หรือไอออนที่เหมือนกันอยู่ฝั่งตรงข้ามกันต้องทำอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q11_อ่อน',
    question: 'ข้อใดคือ ครึ่งปฏิกิริยาออกซิเดชันของปฏิกิริยานี้',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q12_อ่อน',
    question: 'ดุลจำนวนอะตอม C ได้อย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q13_อ่อน',
    question: 'ข้อใดดุลจำนวนอะตอม O ของสมการนี้ได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q14_อ่อน',
    question: 'ข้อใดดุลจำนวนอะตอม H ของสมการนี้ได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q15_อ่อน',
    question: 'ข้อใดดุลประจุไฟฟ้าของสมการนี้ได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q16_อ่อน',
    question: 'ดุลจำนวนอะตอม O ของสมการนี้ได้อย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q17_อ่อน',
    question: 'ดุลจำนวนอะตอม H ของสมการนี้ ต้องเติม H+ ฝั่ง MnO4- เท่าใด',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q18_อ่อน',
    question: 'ดุลจำนวนประจุไฟฟ้าของสมการนี้ ต้องใช้ e- เท่าใด',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q19_อ่อน',
    question: 'ทำจำนวน e- ของสองสมการนี้ให้เท่ากันได้อย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q20_อ่อน',
    question: 'ข้อใดคือสมการที่ได้จากการรวมสองครึ่งปฏิกิริยานี้',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q21_อ่อน',
    question: 'ข้อใดคือสมการที่เป็นผลมาจากการเติม OH- ของสมการนี้ ',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q22_อ่อน',
    question: 'เมื่อตรวจสอบจำนวน H2O ทั้งสองฝั่งของสมการนี้แล้ว ต้องทำอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q1_อ่อน',
    question: 'องค์ประกอบในข้อใดที่มีเฉพาะในเซลล์เคมีไฟฟ้าที่ 1 ',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q2_อ่อน',
    question: 'องค์ประกอบในข้อใดที่เซลล์เคมีไฟฟ้าที่ 1 และ 2 เหมือนกัน',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q3_อ่อน',
    question: 'สารใดสามารถนำมาทำสะพานเกลือ เพื่อเชื่อมครึ่งเซลล์ดังรูปได้',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q4_อ่อน',
    question: 'จากเซลล์เคมีไฟฟ้าดังรูป อิเล็กตรอนมีการเคลื่อนที่อย่างไร',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q5_อ่อน',
    question: 'โลหะใดที่เมื่อเวลาผ่านไปแล้วจะกร่อน',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q6_อ่อน',
    question: 'โลหะใดทำหน้าที่เป็นขั้วไฟฟ้าที่เกิดปฏิกิริยาเคมีด้วย',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q7_อ่อน',
    question: 'ไอออนใดเป็นอิเล็กโทรไลต์ที่เกิดปฏิกิริยาเคมีด้วย ',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q8_อ่อน',
    question: 'ปฏิกิริยารีดอกซ์ของเซลล์เคมีไฟฟ้านี้คือข้อใด',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q9_อ่อน',
    question: 'องค์ประกอบใดที่ไม่มีในเซลล์เคมีไฟฟ้านี้',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-5_Q10_อ่อน',
    question: 'ปฏิกิริยารีดอกซ์ของเซลล์เคมีไฟฟ้านี้คือข้อใด',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q1_อ่อน',
    question: 'ปฏิกิริยาเคมีใดที่พบในเซลล์เคมีไฟฟ้า',
    keyword: 'เซลล์เคมีไฟฟ้า',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q2_อ่อน',
    question: 'จากแผนภาพเซลล์ X(s)ïX+(aq)ïïY+(aq)ïY(s) ข้อใดเกิดปฏิกิริยาออกซิเดชัน',
    keyword: 'แผนภาพเซลล์,ปฏิกิริยาออกซิเดชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q3_อ่อน',
    question:
      'จากรูปเซลล์กัลวานิกต่อไปนี้ เขียนแผนภาพครึ่งเซลล์ที่เกิดปฏิกิริยาออกซิเดชันได้อย่างไร',
    keyword: 'แผนภาพเซลล์,เซลล์กัลวานิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q4_อ่อน',
    question:
      'จาก ปฏิกิริยาออกซิเดชัน  Al(s)ïAl3+(aq) ปฏิกิริยารีดักชัน  Au3+(aq)ïAu(s) สามารถเขียนแผนภาพเซลล์ได้อย่างไร ',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q5_อ่อน',
    question: 'จากรูป สามารถเขียนแผนภาพเซลล์ได้อย่างไร',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q6_อ่อน',
    question:
      'จากแผนภาพเซลล์ Pt(s)ïX2+(aq), X3+(aq)ïïY3+(aq)ïY(s) โลหะ Pt เป็นขั้วไฟฟ้าที่เกิดปฏิกิริยารีดอกซ์หรือไม่ เพราะเหตุใด',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q7_อ่อน',
    question:
      'จากแผนภาพเซลล์Pt(s)ïH2(g, 1 atm)ïH+(aq, 1M)ïïFe3+(aq, 1 M), Fe2+(aq, 1M)Pt(s) ข้อใดถูกต้อง',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q8_อ่อน',
    question:
      'จากแผนภาพเซลล์ Pt(s)ïA+(aq), A2+(aq)ïïB3+(aq), B+(aq)ïPt(s) สารใดเป็นตัวรีดิวซ์และตัวออกซิไดส์ตามลำดับ',
    keyword: 'ตัวรีดิวซ์,ตัวออกซิไดส์,แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q9_อ่อน',
    question: 'จงเขียนแผนภาพครึ่งเซลล์ที่เกิดปฏิกิริยาออกซิเดชันในเซลล์อิเล็กโทรลิติกต่อไปนี้',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q10_อ่อน',
    question: 'จากรูปจงเขียนแผนภาพเซลล์',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q11_อ่อน',
    question:
      'จากแผนภาพเซลล์อิเล็กโทรลิติกต่อไปนี Pt(s)H2(g, 1 atm)ïH+(aq, 1 M)ïï Mg2+(aq)ïMg(s)สารใดเกิดขึ้นที่แคโทด',
    keyword: 'แผนภาพเซลล์อิเล็กโทรลิติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q12_อ่อน',
    question:
      'จากแผนภาพเซลล์กัลวานิกของ Pt(s)ïSn2+(aq), Sn4+(aq)ïïCr3+(aq), Cr2+(aq)ïPt(s) เขียนสมการออกซิเดชันได้อย่างไร',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q13_อ่อน',
    question:
      'จงเขียนแผนภาพเซลล์จากปฏิกิริยานี้ ปฏิกิริยาออกซิเดชัน X(s)® X3+(aq) + 3e- ปฏิกิริยารีดักชัน Y+(aq) + e- ® Y(s)',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q14_อ่อน',
    question:
      'จากสมการแสดงปฏิกิริยาที่ แอโนด Zn(s)   Zn2+(aq) + 2e- แคโทด 2H+(aq) + 2e-   H2(g) จงเขียนแผนภาพเซลล์',
    keyword: 'แผนภาพเซลล์,แอโนดแคโทด',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q15_อ่อน',
    question:
      'ในเซลล์อิเล็กโทรลิติกเกิดปฏิกิริยาออกซิเดชัน Cu+(aq) ® Cu2+(aq) + e- ปฏิกิริยารีดักชัน Fe2+(aq) + 2e- ® Fe(s) จงเขียนแผนภาพเซลล์',
    keyword: 'แผนภาพเซลล์,เซลล์อิเล็กโทรลิติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q16_อ่อน',
    question: 'จงเขียนแผนภาพเซลล์กัลวานิกจาก 3Ag(s) + Au3+(aq)  ®3Ag+(aq)  +  Au(s)',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q17_อ่อน',
    question: 'จาก Mg(s) + 2Fe3+(aq) ®  Mg2+(aq) + 2Fe2+(aq) ข้อใดถูกต้อง',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q18_อ่อน',
    question: 'จากแผนภาพเซลล์ต่อไปนี้ข้อใดผิด Y(s)ïY3+(aq)ïïZ2+(aq), Z+(aq)ïPt(s)',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q19_อ่อน',
    question: 'จาก Pt(s)ïH2(g)ïH+(aq)ïïCo2+(aq)ïCo(s) ข้อใดถูกต้อง',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q20_อ่อน',
    question: 'ข้อใดถูกต้องเกี่ยวกับแผนภาพเซลล์',
    keyword: 'แผนภาพเซลล์,เซลล์อิเล็กโทรลิติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q1_อ่อน',
    question: 'ขั้วไฟฟ้าที่เกี่ยวข้องกับเซลล์เคมีไฟฟ้าคือขั้วใด',
    keyword: 'เซลล์เคมีไฟฟ้า,แอโนด,แคโทด',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q2_อ่อน',
    question: 'การเบนเข็มมิเตอร์ของโวลต์มิเตอร์บอกให้ทราบถึงอะไร',
    keyword: 'โวลต์มิเตอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q3_อ่อน',
    question:
      'ข้อใดแสดงทิศทางการเคลื่อนที่ของอิเล็กตรอนและกระแสไฟฟ้าใน Zn(s)ïZn2+(aq)ïïCu2+(aq)ïCu(s) ได้ถูกต้อง',
    keyword: 'เซลล์เคมีไฟฟ้า,แอโนด,แคโทด',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q4_อ่อน',
    question: 'จากแผนภาพเซลล์กัลวานิกFe(s)ïFe2+(aq)ïïAg+(aq)ïAg(s) ข้อใดผิด',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q5_อ่อน',
    question:
      'นำครึ่งเซลล์ X(s)ïX2+(aq) มาต่อกับ  Y(s)ïY+(aq) ต่อด้วยสะพานเกลือและโวลต์มิเตอร์ อ่านค่าความต่างศักย์ได้ 1.20 โวลต์ และเข็มเบนไปทางขั้วโลหะ X ข้อสรุปใดถูกต้อง',
    keyword: 'แผนภาพเซลล์,ศักย์ไฟฟ้าของเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q6_อ่อน',
    question: 'ค่าศักย์ไฟฟ้าของเซลล์ที่วัดได้เป็นบวกหมายความว่าอย่างไร',
    keyword: 'ศักย์ไฟฟ้าของเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q7_อ่อน',
    question: 'จากรูป ข้อใดผิด',
    keyword: 'ศักย์ไฟฟ้าของเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q8_อ่อน',
    question: 'ข้อใดถูกต้อง',
    keyword: 'E0,ศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชั',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q9_อ่อน',
    question:
      'จงเรียงลำดับความสามารถในการเป็นตัวออกซิไดส์จากข้อมูลนี้ X+(aq) + e- ®  X(s)        E0 = -1.10 V Y3+(aq) + e- ® Y2+(aq)   E0 =  0.77 V Z2+(aq)  + 2e- ®  Z(s)     E0 = -1.23 V',
    keyword: 'ตัวออกซิไดส์,ค่าศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชั',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q10_อ่อน',
    question:
      'เมื่อต่อครึ่งเซลล์ A2+(aq)ïA(s) กับ B+(aq)ïB(s) และวัดค่าความต่างศักย์ได้เท่ากับ 0.79 V โดยค่าศักย์ไฟฟ้ามาตรฐานของแต่ละครึ่งเซลล์เป็นดังนี้ A2+(aq) + 2e- ® A(s)      E0 = -0.21 V    B+(aq) + e- ®  B(s)        E0 =  0.58 V',
    keyword: 'E0,ศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชั',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q11_อ่อน',
    question:
      'พิจารณาข้อมูลต่อไปนี้ ข้อใดถูกต้อง A+(aq) + e- ® A(s)  E0 = +1.56 V    B3+(aq) + 2e- ® B+(aq)  E0 = +0.88 V    C2+(aq) + 2e- ® C(s)  E0= -0.30 V    D2+(aq) + e- ® D+(aq)  E0 = -1.14 V',
    keyword: 'E0,ศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชั',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q1_เก่ง',
    question: 'ข้อใดผิดเกี่ยวกับการดุลสมการ',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q2_เก่ง',
    question: 'จากสมการ ข้อใดผิดเมื่อมีการเปลี่ยนแปลงเลขออกซิเดชัน',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q3_เก่ง',
    question: 'ข้อใดถุกต้องเกี่ยวกับการดุลจำนวนอะตอมของธาตุ',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q4_เก่ง',
    question: 'เมื่อดุลจำนวนอะตอมของธาตุแล้ว เลขสัมประสิทธ์ของสารตั้งต้นทั้งหมดมีค่าเท่าใด',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q5_เก่ง',
    question: 'เมื่อสมการดุลแล้ว เลขสัมประสิทธ์ของผลิตภัณฑ์ทั้งหมดมีค่าเท่าใด',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q6_เก่ง',
    question: 'เมื่อดุลสมการแล้ว จะ N และ H จะมีเลขสัมประสิทธ์ เป็นเท่าใด ตามลำดับ',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q7_เก่ง',
    question: 'ข้อใดถูกต้องเมื่อดุลสมการีดอกซ์ในภาวะเบส',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q8_เก่ง',
    question: 'จากสมการ ครึ่งปฏิกิริยารีดักชันที่ถูกต้องคือข้อใด',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q9_เก่ง',
    question: 'จากสมการ ครึ่งปฏิกิริยารีดักชันที่ดุลแล้วคือข้อใด',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-3_Q10_เก่ง',
    question: 'ข้อใดคือสมการรีดอกซ์ที่ดุลแล้ว',
    keyword: 'เลขสัมประสิทธิ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q1_เก่ง',
    question: 'การดุลสมการรีดอกซ์โดยวิธีครึ่งปฏิกิริยาแตกต่างจากการดุลโดยวิธีเลขออกซิเดชันอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q2_เก่ง',
    question: 'ข้อใดแบ่งสองครึ่งปฏิกิริยาของสมการรีดอกซ์นีได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q3_เก่ง',
    question: 'ข้อใดคือสมการที่ดุลแล้วของครึ่งปฏิกิรยาออกซิเดชันนี้',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q4_เก่ง',
    question: 'ลำดับการดุลจำนวนอะตอมสำหรับครึ่งปฏิกิริยารีดักชันนี้เป็นอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q5_เก่ง',
    question:
      'การรวมสองครึ่งปฏิกิริยานี้ต้องดำเนินการตามข้อใด ครึ่งปฏิกิริยาออกซิเดชัน ครึ่งปฏิกิริยารีดักชัน',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q6_เก่ง',
    question: 'ข้อใดแบ่งสองครึ่งปฏิกิริยาของสมการรีดอกซ์นีได้ถูกต้อง',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q7_เก่ง',
    question: 'ดุลจำนวนอะตอม C ได้อย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q8_เก่ง',
    question: 'ต้องดุลจำนวนอะตอม O โดยเติม H2O เท่าใด',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q9_เก่ง',
    question: 'ต้องเติม H+ และ e- จำนวนเท่าใด',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q10_เก่ง',
    question: 'ต้องคูณตัวเลขใดในแต่ละครึ่งปฏิกิริยา เพื่อให้จำนวน e- ดุล',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q11_เก่ง',
    question: 'ต้องเติม OH- จำนวนเท่าใด ',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-4_Q12_เก่ง',
    question: 'สมการที่ดุลแล้วเป็นอย่างไร',
    keyword: 'ดุลสมการรีดอกซ์โดยครึ่งปฏิกิริยา',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q1_เก่ง',
    question: 'ข้อใดถูกต้องเมื่อมีการถ่ายโอนอิเล็กตรอนในเซลล์กัลวานิก',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q2_เก่ง',
    question: 'จากรูปเขียนแสดงแผนภาพเซลล์ได้อย่างไร (วาดรุปใหม่ ให้เข้ากับtheme)',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q3_เก่ง',
    question:
      'แผนภาพครึ่งเซลล์ที่เกิด ปฏิกิริยารีดักชัน และปฏิกิริยาออกซิเดชัน คือข้อใด (วาดรุปใหม่ ให้เข้ากับtheme)',
    keyword: 'แผนภาพครึ่งเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q4_เก่ง',
    question: 'กำหนดA(s) / A+ (aq) // B2+ (aq) / B (s) ปฏิกิริยารีดอกซ์ที่เกิดขึ้นคือข้อใด',
    keyword: 'ปฏิกิริยารีดอกซ์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q5_เก่ง',
    question: 'จากแผนภาพเซลล์ Sn(s)/Sn2+(aq) // Cu2+(aq)/Cu(s) ข้อใดถูกต้อง',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q6_เก่ง',
    question: 'ปฏิกิริยาที่เกิดขึ้นในเซลล์กัลวานิกคือ แผนภาพของเซลล์กัลวานิกคือข้อใด',
    keyword: 'แผนภาพเซลล์,เซลล์กัลวานิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q7_เก่ง',
    question:
      'ปฏิกิริยาที่เกิดขึ้นในเซลล์กัลวานิกคือสมการของปฏิกิริยาออกซิเดชันและรีดักชันคือข้อใด',
    keyword: 'เซลล์กัลวานิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q8_เก่ง',
    question: 'ปฏิกิริยาที่เกิดขึ้นในเซลล์กัลวานิกคือข้อใดไม่กล่าวถูกต้องเกี่ยวกับขั้วบวกและขั้วลบ',
    keyword: 'เซลล์กัลวานิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q9_เก่ง',
    question: 'จากรูป ข้อใดคือแผนภาพเซลล์ไฟฟ้า',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-6_Q10_เก่ง',
    question: 'จากรูป ข้อใดคือแผนภาพเซลล์ไฟฟ้า',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q1_เก่ง',
    question:
      'จากการทดลอง ที่สภาวะมาตรฐาน ค่าศักย์ไฟฟ้าของเซลล์ Zn(s)|Zn2+(aq)||Cu2+(aq)|Cu(s) มีค่ากี่โวลต์',
    keyword: 'ศักย์ไฟฟ้าของเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q2_เก่ง',
    question: 'จากการทดลอง ข้อใดผิด',
    keyword: 'แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q3_เก่ง',
    question: 'ข้อใดถูกต้องเมื่อเข็มของมิเตอร์เบนเข้าหาขั้วโลหะ Cu ',
    keyword: 'โวลต์มิเตอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q4_เก่ง',
    question: 'E⁰ คืออะไร',
    keyword: 'ศักย์ไฟฟ้ามาตรฐานของครึ่งเซลล์รีดักชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q5_เก่ง',
    question: 'Cr(s)Cr3+(aq)||Sn4+(aq), Sn2+(aq)|Pt(s) แผนภาพเซลล์ ข้อใดถูกต้อง',
    keyword: 'ปฏิกิริยารีดอกซ์,แผนภาพเซลล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q6_เก่ง',
    question: 'Cr(s)Cr3+(aq)||Sn4+(aq), Sn2+(aq)|Pt(s) จงหาค่า กำหนด',
    keyword: 'ค่าศักย์ไฟฟ้ามาตรฐานของเซลล์,ค่า E⁰',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q7_เก่ง',
    question: 'จงหาค่า ของ Mg(s)Mg2+(aq)||Fe3+(aq), Fe2+(aq)|Pt(s)',
    keyword: 'ค่าศักย์ไฟฟ้ามาตรฐานของเซลล์,ค่า E⁰',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q8_เก่ง',
    question: 'ข้อใดผิดเมื่อต่อ Al³+(aq)|Al(s) กับ Cu²+(aq)|Cu(s) ให้เป็นเซลล์กัลวานิก',
    keyword: 'ค่า E⁰,แผนภาพเซลล์,เซลล์กัลวานิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q9_เก่ง',
    question: 'Al³+(aq)|Al(s) กับ Cu²+(aq)|Cu(s) เป็นเซลล์กัลวานิก จะมีค่า E⁰cell เท่าใด',
    keyword: 'ค่า E⁰,แผนภาพเซลล์,เซลล์กัลวานิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 11-7_Q10_เก่ง',
    question: 'จงหาค่าของ',
    keyword: 'ค่าศักย์ไฟฟ้ามาตรฐานของเซลล์,ค่า E⁰',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q1_ธรรมดา',
    question: 'คาร์บอน (C) สามารถเกิดพันธะได้กี่พันธะ',
    keyword: 'คาร์บอน,พันธะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q2_ธรรมดา',
    question: 'คาร์บอนจะเกิดพันธะใดในสารประกอบอินทรีย์',
    keyword: 'คาร์บอน,พันธะโคเวเลนต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q3_ธรรมดา',
    question: 'สัญลักษณ์แบบจุดของลิวอิสไม่แสดงสิ่งใด',
    keyword: 'ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q4_ธรรมดา',
    question: 'สัญลักษณ์แบบจุดของลิวอิสของอะตอม C ตรงกับข้อใด',
    keyword: 'คาร์บอน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q5_ธรรมดา',
    question: 'สารประกอบที่เกิดจาก C 1 อะตอมกับ H 4 อะตอม เขียนสัญลักษณ์แบบจุดของลิวอิสได้ดังรูปใด',
    keyword: 'คาร์บอน,ไฮโดรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q6_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบโซ่กิง',
    keyword: 'สูตรโครงสร้างแบบโซ่กิ่ง',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q7_ธรรมดา',
    question: 'สูตรโครงสร้างลิวอิสของ C2H2 คือข้อใด',
    keyword: 'สูตรโครงสร้างลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q8_ธรรมดา',
    question: 'สารประกอบที่เกิดจาก C 1 อะตอมกับ O 2 อะตอม เขียนสัญลักษณ์แบบจุดของลิวอิสได้ดังรูปใด',
    keyword: 'คาร์บอน,ออกซิเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q9_ธรรมดา',
    question: 'โครงสร้างลิวอิสของสารประกอบ CO2 ตรงกับข้อใด',
    keyword: 'คาร์บอน,ออกซิเจน,โครงสร้างลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q10_ธรรมดา',
    question:
      'สารประกอบที่เกิดจาก C 1 อะตอม N 1 อะตอม และ H 1 อะตอม เขียนสัญลักษณ์แบบจุดของลิวอิสได้ดังรูปใด',
    keyword: 'คาร์บอน,ไนโตรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q1_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างลิวอิสของ',
    keyword: 'สูตรโครงสร้างลิวอิส,สูตรโครงสร้างแบบย่อ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q2_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบย่อของ',
    keyword: 'สูตรโครงสร้างลิวอิส,สูตรโครงสร้างแบบย่อ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q3_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบเส้นของ',
    keyword: 'สูตรโครงสร้างแบบเส้นพันธะ,สูตรโครงสร้างแบบย่อ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q4_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบเส้นของ',
    keyword: 'สูตรโครงสร้างแบบเส้นพันธะ,สูตรโครงสร้างแบบย่อ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q5_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบย่อและสูตรโมเลกุลของ',
    keyword: 'สูตรโครงสร้างแบบย่อ,สูตรโมเลกุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q6_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างลิวอิสของ  ',
    keyword: 'สูตรโครงสร้างลิวอิส,สูตรโมเลกุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q7_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างลิวอิสของ  ',
    keyword: 'สูตรโครงสร้างลิวอิส,สูตรโมเลกุล',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q8_ธรรมดา',
    question: 'สูตรโมเลกุลในข้อใดที่มีพันธะคู่ในโมเลกุล',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q9_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบย่อของ',
    keyword: 'สูตรโครงสร้างแบบย่อ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q10_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างแบบย่อของ',
    keyword: 'สูตรโครงสร้างแบบย่อ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q1_ธรรมดา',
    question: 'ข้อใดกล่าวได้ถูกต้องเกี่ยวกับ หมู่ฟังก์ชัน   ',
    keyword: 'หมู่ฟังก์ชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q2_ธรรมดา',
    question: 'สารประกอบนี้ คือสารประเภทใด',
    keyword: 'แอลเคน,ไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q3_ธรรมดา',
    question: 'ข้อใดคือสารแอลคีน',
    keyword: 'แอลคีน,ไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q4_ธรรมดา',
    question: 'ข้อใดคือแอโรแมติกไฮโดรคาร์บอน',
    keyword: 'แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q5_ธรรมดา',
    question: 'ข้อใดเป็นสารประกอบไฮโดรคาร์บอนอิ่มตัว',
    keyword: 'ไฮโดรคาร์บอนอิ่มตัว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q6_ธรรมดา',
    question: 'ข้อใดคือโครงสร้างเรโซแนนซ์ผสมของแอโรแมติกไฮโดรคาร์บอน',
    keyword: 'เรโซแนนซ์,แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q7_ธรรมดา',
    question: 'ข้อใดกล่าวได้ถูกต้อง ',
    keyword: 'เรโซแนนซ์,แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q8_ธรรมดา',
    question: 'ข้อใดมีสารที่ไม่ใช่อะลิฟาติกไฮโดรคาร์บอน',
    keyword: 'อะลิฟาติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q9_ธรรมดา',
    question: 'สารประกอบกรดคาร์บอกซิลิกมีหมู่ฟังก์ชันใด',
    keyword: 'กรดคาร์บอกซิลิก,ออกซิเจน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q10_ธรรมดา',
    question: 'หมู่ฟังก์ชันใดมีไนโตรเจนเป็นองค์ประกอบ',
    keyword: 'เอมีน,ไนโตรเจน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q1_ธรรมดา',
    question: 'ข้อใดคือความหมายของโซ่หลัก',
    keyword: 'สายโซ่หลัก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q2_ธรรมดา',
    question: 'ข้อใดคือชื่อสายโซ่หลัก ของสูตรโครงสร้างนี้',
    keyword: 'สายโซ่หลัก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q3_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'สายโซ่หลัก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q4_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ 1,4-dimethylcyclohexane',
    keyword: 'ไซโคลแอลเคน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q5_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'แอลคีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q6_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'แอลไคน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q7_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ methylbenzene',
    keyword: 'แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q8_ธรรมดา',
    question: 'ข้อใดใช่สูตรโครงสร้างของ 1-ethyl-2-methylbenzene',
    keyword: 'แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q9_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'เอสเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q10_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ (1-methylpropyl)benzene',
    keyword: 'แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q11_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ 2-methylpentan-1-ol',
    keyword: 'แอลกอฮอล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q12_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ 2-methoxy-2-methypropane',
    keyword: 'อีเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q13_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'แอลดีไฮด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q14_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ 3-methylpentanal',
    keyword: 'แอลดีไฮด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q15_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ 3-methylpentanal',
    keyword: 'คีโทน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q16_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ 3-methylbutanoic acid',
    keyword: 'กรดคาร์บอกซิลิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q17_ธรรมดา',
    question: 'สารในข้อใดเป็นสาร อีเทอร์',
    keyword: 'อีเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q18_ธรรมดา',
    question: 'สารในข้อใดเป็นสาร แอลดีไฮด์',
    keyword: 'แอลดีไฮด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q19_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างของ butyl ethanoate',
    keyword: 'เอสเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q20_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'เอสเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q21_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'เอมีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q22_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ butan-1-amine',
    keyword: 'เอมีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q23_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'เอมีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q24_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ heptan-2-amine',
    keyword: 'เอมีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q25_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ propanamide',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q26_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q27_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q28_ธรรมดา',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างนี้',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q29_ธรรมดา',
    question: 'ข้อใดใช่สูตรโครงสร้างของ octanamide',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q30_ธรรมดา',
    question: 'ข้อใดไม่ใช่เอไมด์',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q1_ธรรมดา',
    question: 'ข้อใดคือความหมายของไอโซเมอริซึม',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q2_ธรรมดา',
    question: 'ข้อใดกล่าวถึงไอโซเมอร์ได้ถูกต้อง',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q3_ธรรมดา',
    question:
      'ข้อใดไม่ใช่ไอโซเมอร์ที่เกิดจากลำดับการต่อกันของอะตอมหรือลำดับการต่อกันของชนิดพันธะต่างกัน',
    keyword: 'ไอโซเมอร์,ไอโซเมอร์โครงร่าง,ไอโซเมอร์โครงสร้าง',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q4_ธรรมดา',
    question: 'จากกิจกรรม โครงสร้างที่ได้จากการต่อแบบจำลอง มีสูตรโมเลกุลเป็นอย่างไร',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q5_ธรรมดา',
    question: 'สารที่มีสูตรโมเลกุล C5H12 มีโครงสร้างที่เป็นไปได้กี่โครงสร้าง',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q6_ธรรมดา',
    question: 'ข้อใดไม่ทำให้เกิดไอโซเมอร์',
    keyword: 'ไอโซเมอร์,ไอโซเมอร์ฟังก์ชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q7_ธรรมดา',
    question: 'สารข้อใดไม่มีไอโซเมอร์',
    keyword: 'ไอโซเมอร์ ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q8_ธรรมดา',
    question: 'ไอโซเมอร์ฟังก์ชันจัดเป็นไอโซเมอร์โครงสร้างหรือไม่',
    keyword: 'ไอโซเมอร์,ไอโซเมอร์ฟังก์ชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q9_ธรรมดา',
    question: 'สารข้อใดไม่ใช่ไอโซเมอร์กับ',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q10_ธรรมดา',
    question: 'สารข้อใดเป็นไอโซเมอร์กับ',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q11_ธรรมดา',
    question: 'สารข้อใดเป็นไอโซเมอร์กัน',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q12_ธรรมดา',
    question: 'สารข้อใดไม่เป็นไอโซเมอร์กัน',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q13_ธรรมดา',
    question: 'ถ้าสารมีจำนวนคาร์บอนเท่ากัน สารข้อใดเป็นไอโซเมอร์ฟังก์ชันกับแอลกอฮอล์',
    keyword: 'ไอโซเมอร์ฟังก์ชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q14_ธรรมดา',
    question: 'ถ้าสารมีจำนวนคาร์บอนเท่ากัน สารข้อใดเป็นไอโซเมอร์ฟังก์ชันกับแอลดีไฮด์',
    keyword: 'ไอโซเมอร์ฟังก์ชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q15_ธรรมดา',
    question: 'สารข้อใดเป็นไอโซเมอร์ฟังก์ชันกับสารนี้',
    keyword: '',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q1_ธรรมดา',
    question: 'สมบัติของสารประกอบอินทรีย์ขึ้นกับข้อใด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q2_ธรรมดา',
    question:
      'การละลายจะเกิดขึ้นได้เมื่อความสัมพันธ์ของแรงยึดเหนี่ยวระหว่างอนุภาคของตัวละลายกับตัวทำละลาย และ แรงยึดเหนี่ยวระหว่างอนุภาคของตัวละลายหรือตัวทำละลาย เป็นอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,การละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q3_ธรรมดา',
    question: 'สารประกอบไฮโดรคาร์บอนไม่ละลายในตัวทำละลายแบบใด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,การละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q4_ธรรมดา',
    question:
      'จุดเดือดและจุดหลอมเหลวของสารประกอบไฮโดรคาร์บอนเป็นอย่างไร เมื่อเทียบกับสารประกอบอินทรีย์ประเภทอื่นที่มีมวลโมเลกุลใกล้เคียงกัน ',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q5_ธรรมดา',
    question:
      'เพราะเหตุใดสารประกอบไฮโดรคาร์บอนมีจุดเดือดและจุดหลอมเหลวน้อยกว่าสารประกอบอินทรีย์ประเภทอื่นที่มีมวลโมเลกุลใกล้เคียงกัน',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q6_ธรรมดา',
    question:
      'ตัวอย่างจุดเดือดและจุดหลอมเหลวของแอลเคน เป็นดังตาราง จุดเดือดมีความสัมพันธ์กับจำนวนอะตอมของคาร์บอนอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q7_ธรรมดา',
    question:
      'ตัวอย่างจุดเดือดและจุดหลอมเหลวของแอลเคน เป็นดังตาราง จุดเดือดของแอลเคนโซ่ตรงเป็นอย่างไรเมื่อเทียบกับไซโคลแอลเคนที่มีจำนวนอะตอมของคาร์บอนเท่ากัน',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q8_ธรรมดา',
    question:
      'ตัวอย่างจุดเดือดและจุดหลอมเหลวของแอลเคน เป็นดังตาราง จุดเดือดมีความสัมพันธ์กับจำนวนอะตอมของคาร์บอนอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q9_ธรรมดา',
    question:
      'แอลเคนโครงสร้างแบบโซ่กิ่งมีจุดเดือดเป็นอย่างไรเมื่อเทียบกับแอลเคนแบบโซ่ตรงที่มีจำนวนอะตอมของคาร์บอนเท่ากัน',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q10_ธรรมดา',
    question: 'สารใดมีจุดเดือดสูงที่สุด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q11_ธรรมดา',
    question: 'สารใดมีจุดเดือดต่ำที่สุด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q1_ธรรมดา',
    question: 'ข้อใดไม่ถูกต้องเกี่ยวกับปฏิกิริยาการเผาไหม้',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q2_ธรรมดา',
    question: 'ปฏิกิริยาการเผาไหม้อย่างสมบูรณ์ได้ผลิตภัณฑ์เป็นอะไร',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q3_ธรรมดา',
    question:
      'เลขสัมประสิทธิ์ของ CO2 และ H2O ในปฏิกิริยาการเผาไหม้อย่างสมบูรณ์ของ C8H18 จำนวน 2 โมล คือเท่าใดตามลำดับ',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q4_ธรรมดา',
    question: 'เชื้อเพลิงชนิดใดให้เขม่ามากกว่า',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q5_ธรรมดา',
    question:
      'เมื่อเติมสารประกอบไฮโดรคาร์บอนบางชนิดลงในสารละลายโบรมีน ได้ผลดังตาราง สารใดที่ฟอกจากสีสารละลายโบรมีนได้เฉพาะในที่สว่าง',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q6_ธรรมดา',
    question: 'เมื่อนำโพรเพนมาทำปฏิกิริยากับโบรมีนในที่สว่างอาจได้ผลิตภัณฑ์ในข้อใด ',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q7_ธรรมดา',
    question:
      'เมื่อเติมสารประกอบไฮโดรคาร์บอนบางชนิดลงในสารละลายโบรมีน ได้ผลดังตาราง สารใดที่ฟอกจากสีสารละลายโบรมีนได้ทั้งในที่สว่างและที่มืด',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q8_ธรรมดา',
    question:
      'เมื่อเติมสารประกอบไฮโดรคาร์บอนบางชนิดลงในสารละลายโบรมีน ได้ผลดังตาราง สารใดที่ไม่ฟอกจากสีสารละลายโบรมีนทั้งในที่มืดและที่สว่าง',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q9_ธรรมดา',
    question:
      'ข้อใดไม่ใช่การเปลี่ยนแปลงที่เกิดขึ้น เมื่อสารประกอบไฮโดรคาร์บอนเกิดปฏิกิริยาฟอกจางสี KMnO4',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q10_ธรรมดา',
    question: 'สารใดที่ฟอกจากสีสารละลาย โพแทสเซียมเปอร์แมงกาเนตได้',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q11_ธรรมดา',
    question: 'ตะกอบสีน้ำตาลที่เกิดจากการฟอกจางสี KMnO4 ของแอลดคีนคือสารใด',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q1_ธรรมดา',
    question: 'สเตอรอยด์ตรงกับข้อใด',
    keyword: 'สเตอรอยด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q2_ธรรมดา',
    question: 'ฮอร์โมนเพศชาย หรือเทสโทสเทอโรน มีสูตรโครงสร้างตรงข้อใด',
    keyword: 'สเตอรอยด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q3_ธรรมดา',
    question: 'ในทางการแพทย์มีการนำสารประกอบประเภทสเตอรอยด์ไปใช้ประโยชน์ด้านใดบ้าง ',
    keyword: 'สเตอรอยด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q4_ธรรมดา',
    question: 'กรดซาลิซิลิกเป็นสารตั้งต้นในการสังเคราะยาบรรเทาอาการปวดมีสูตรโครงสร้างตรงข้อใด',
    keyword: 'กรดซาลิซิลิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q5_ธรรมดา',
    question: 'การสังเคราะห์แอสไพริน เป็นการทำปฏิกิริยาใด',
    keyword: 'ปฏิกิริยาเอสเทอริฟิเคชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q6_ธรรมดา',
    question:
      'เมื่อกรดซาลิซิลิกทำปฏิกิริยาเอสเทอริฟิเคชันกับเมทานอลแทนกรดแอซีติก จะได้ผลิตภัณฑ์ข้อใด',
    keyword: 'ปฏิกิริยาเอสเทอริฟิเคชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q7_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของกลูโคส',
    keyword: 'กลูโคส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q8_ธรรมดา',
    question: 'ไบโอดีเซล เกิดจากสารตั้งต้นใดมาทำปฏิกิริยากัน',
    keyword: 'ปฏิกิริยาทรานส์เอสเทอริฟชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q9_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของ ไบโอดีเซล',
    keyword: 'เอสเทอร์,ไบโอดีเซล',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-8_Q10_ธรรมดา',
    question: 'ข้อใดผิด',
    keyword: 'ตัวทำละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q1_อ่อน',
    question: 'คาร์บอน (C) เป็นธาตุในหมู่ IVA (หมู่ 14) มีเวเลนซ์อิเล็กตรอนเท่าไหร่',
    keyword: 'คาร์บอน,เวเลนซ์อิเล็กตรอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q2_อ่อน',
    question: 'คาร์บอน (C) สามารถเกิดพันธะได้กี่พันธะ',
    keyword: 'คาร์บอน,พันธะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q3_อ่อน',
    question: 'คาร์บอนจะเกิดพันธะใดในสารประกอบอินทรีย์',
    keyword: 'คาร์บอน,เวเลนซ์อิเล็กตรอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q4_อ่อน',
    question: 'สัญลักษณ์แบบจุดของลิวอิสไม่แสดงสิ่งใด',
    keyword: 'ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q5_อ่อน',
    question: 'สัญลักษณ์แบบจุดของลิวอิสของอะตอม C ตรงกับข้อใด',
    keyword: 'คาร์บอน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q6_อ่อน',
    question: 'สารประกอบที่เกิดจาก C 1 อะตอมกับ H 4 อะตอม เขียนสัญลักษณ์แบบจุดของลิวอิสได้ดังรูปใด',
    keyword: 'คาร์บอน,ไฮโดรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q7_อ่อน',
    question: 'โครงสร้างลิวอิสของสารประกอบ CH4 ตรงกับข้อใด',
    keyword: 'คาร์บอน,ไฮโดรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q8_อ่อน',
    question: 'สารประกอบที่เกิดจาก C 1 อะตอมกับ O 2 อะตอม เขียนสัญลักษณ์แบบจุดของลิวอิสได้ดังรูปใด',
    keyword: 'คาร์บอน,ไฮโดรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q9_อ่อน',
    question: 'โครงสร้างลิวอิสของสารประกอบ CO2 ตรงกับข้อใด',
    keyword: 'คาร์บอน,ออกซิเจน,โครงสร้างลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q10_อ่อน',
    question:
      'สารประกอบที่เกิดจาก C 1 อะตอม N 1 อะตอม และ H 1 อะตอม เขียนสัญลักษณ์แบบจุดของลิวอิสได้ดังรูปใด',
    keyword: 'คาร์บอน,ไฮโดรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-1_Q11_อ่อน',
    question: 'โครงสร้างลิวอิสของสารประกอบ HCN ตรงกับข้อใด',
    keyword: 'คาร์บอน,ไฮโดรเจน,ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q1_อ่อน',
    question: 'เส้นขีด (-) ในโครงสร้างลิวอิส แทนสิ่งใด',
    keyword: 'ลิวอิส',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q2_อ่อน',
    question: 'สัญลักษณ์แบบจุดของลิวอิสของสารประกอบ C4H10 แสดงดังข้อใด',
    keyword: 'ลิวอิส,คาร์บอน,ไฮโดรเจน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q3_อ่อน',
    question: 'โครงสร้างลิวอิสของสารประกอบ C4H10 แสดงดังข้อใด',
    keyword: 'ลิวอิส,คาร์บอน,ไฮโดรเจน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q4_อ่อน',
    question: 'สูตรโครงสร้างแบบย่อของสารประกอบ C4H10 แสดงดังข้อใด',
    keyword: 'สูตรโครงสร้างแบบย่อ,คาร์บอน,ไฮโดรเจน,พันธะ,สารประกอบ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q5_อ่อน',
    question: 'สูตรโครงสร้างแบบเส้นพันธะของสารประกอบ C4H10 แสดงดังข้อใด',
    keyword: 'สูตรโครงสร้างเส้นพันธะ,คาร์บอน,ไฮโดรเจน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q6_อ่อน',
    question: 'สารประกอบหนึ่ง มีสูตรโครงสร้างแบบย่อเป็น H2C=CH2 ตรงกับโครงสร้างลิวอิสดังข้อใด',
    keyword: 'โครงสร้างลิวอิส,คาร์บอน,ไฮโดรเจน,พันธะ,สารประกอบ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q7_อ่อน',
    question:
      'สูตรโครงสร้างแบบย่อของสารประกอบหนึ่งเป็น H2C=CH2 มีสูตรโครงสร้างแบบเส้นพันธะตรงกับข้อใด',
    keyword: 'สูตรโครงสร้างเส้นพันธะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q8_อ่อน',
    question: 'สูตรโครงสร้างแบบเส้นพันธะจะไม่แสดงสิ่งใด',
    keyword: 'สูตรโครงสร้างเส้นพันธะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q9_อ่อน',
    question:
      'สูตรโครงสร้างแบบเส้นพันธะของสารประกอบที่มีสูตรโครงสร้างแบบย่อเป็น CH3OH แสดงดังข้อใด',
    keyword: 'สูตรโครงสร้างเส้นพันธะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-2_Q10_อ่อน',
    question:
      'สูตรโครงสร้างแบบเส้นพันธะของสารประกอบที่มีสูตรโครงสร้างแบบย่อเป็น CH3CO2H แสดงดังข้อใด',
    keyword: 'สูตรโครงสร้างเส้นพันธะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q1_อ่อน',
    question: 'หมู่ฟังก์ชันของสารประกอบอินทรีย์คืออะไร',
    keyword: 'หมู่ฟังก์ชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q2_อ่อน',
    question: 'สารประกอบอินทรีย์ที่มีเฉพาะธาตุคาร์บอนและไฮโดรเจนเป็นองค์ประกอบ เรียกว่าอะไร',
    keyword: 'หมู่ฟังก์ชัน,สารประกอบไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q3_อ่อน',
    question: 'สารประกอบไฮโดรคาร์บอนที่มีพันธะคู่อย่างน้อย 1 พันธะ เรียกว่าอะไร',
    keyword: 'แอลเคน,แอลคีน,แอลไคน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q4_อ่อน',
    question: 'ข้อใดคือสารประกอบไฮโดรคาร์บอน ชนิดแอลไคน์',
    keyword: 'สารประกอบไฮโดรคาร์บอน,แอลไคน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q5_อ่อน',
    question: 'สูตรทั่วไปของสารประกอบอินทรีย์มักใช้สัญลักษณ์ R หรือหมู่แอลคิลหมายถึงข้อใด',
    keyword: 'แอลคิล,ไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q6_อ่อน',
    question: "สูตรทั่วไปของอีเทอร์คือ ROR' หาก R' เป็น H สารประกอบนี้จะเปลี่ยนเป็นสารประเภทใด",
    keyword: 'แอลกอฮอล์,อีเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q7_อ่อน',
    question: "สูตรทั่วไปของเอสเทอร์คือ RCOOR' หาก R' เป็น H สารประกอบนี้จะเปลี่ยนเป็นสารประเภทใด",
    keyword: 'เอสเทอร์,การคาร์บอกซิลิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q8_อ่อน',
    question:
      "สูตรทั่วไปของแอลดีไฮด์คือ RCOH หากเปลี่ยน H เป็น R' สารประกอบนี้จะเปลี่ยนเป็นสารประเภทใด",
    keyword: 'แอลกอฮอล์,อีเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q9_อ่อน',
    question:
      'สูตรทั่วไปของเอไมด์คือ RCONH2 หากเปลี่ยน NH2 เป็น OH สารประกอบนี้จะเปลี่ยนเป็นสารประเภทใด',
    keyword: 'เอสเทอร์,การคาร์บอกซิลิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-3_Q10_อ่อน',
    question: 'ข้อใดคือหมู่ฟังก์ชันของสารประกอบประเภทเอสเทอร์',
    keyword: 'หมู่ฟังก์ชัน,เอสเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q1_อ่อน',
    question: 'ข้อใดคือความหมายของโซ่หลัก',
    keyword: 'สายโซ่หลัก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q2_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ heptane',
    keyword: 'แอลเคน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q3_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ 4,4-dimethylpent-2-ene',
    keyword: 'แอลเคน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q4_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'ไซโคลแอลคีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q5_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'แอลไคน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q6_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ benzene',
    keyword: 'แอโรแมติกไฮโดรคาร์บอน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q7_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'แอลกอฮอล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q8_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ 2-methylpropan-1-ol',
    keyword: 'แอลกอฮอล์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q9_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'อีเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q10_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'อีเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q11_อ่อน',
    question: 'สารข้อใดมีคำลงท้ายชื่อเป็น -al',
    keyword: 'แอลดีไฮน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q12_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'แอลดีไฮน์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q13_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'คีโทน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q14_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ 4-methylpentan-2-one',
    keyword: 'คีโทน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q15_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ butanoic acid',
    keyword: 'กรดคาร์บอกซิลิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q16_อ่อน',
    question: 'ข้อใดคือชื่อสูตรโครงสร้างนี้',
    keyword: 'กรดคาร์บอกซิลิก',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q17_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ methyl propanoate',
    keyword: 'เอสเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q18_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'เอสเทอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q19_อ่อน',
    question: 'ข้อใดคือชื่อของสูตรโครงสร้างต่อไปนี้',
    keyword: 'เอมีน',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q20_อ่อน',
    question: 'ข้อใดคือมีคำลงท้ายชื่อของสารที่มีหมู่ฟังก์ชันเป็น -CONH2',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-4_Q21_อ่อน',
    question: 'ข้อใดคือสูตรโครงสร้างของ propanamide',
    keyword: 'เอไมด์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q1_อ่อน',
    question: 'ข้อใดคือความหมายของไอโซเมอริซึม',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q2_อ่อน',
    question: 'ข้อใดคือความหมายของไอโซเมอร์',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q3_อ่อน',
    question: 'ข้อความในข้อใดไม่ถูกต้อง',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q4_อ่อน',
    question: 'ข้อใดที่ไม่ทำให้เกิดไอโซเมอร์โครงสร้าง',
    keyword: 'ไอโซเมอร์,ไอโซเมอร์โครงร่าง,ไอโซเมอร์โครงสร้าง',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q5_อ่อน',
    question: 'สารข้อใดไม่มีไอโซเมอร์',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q6_อ่อน',
    question: 'สารข้อใดเป็นไอโซเมอร์กับสารนี้',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q7_อ่อน',
    question: 'สารข้อใดไม่เป็นไอโซเมอร์กับสารนี้',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q8_อ่อน',
    question: 'สารข้อใดไม่เป็นไอโซเมอร์กับสารนี้',
    keyword: 'ไอโซเมอร์,ไอโซเมอร์โครงร่าง,ไอโซเมอร์โครงสร้าง',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q9_อ่อน',
    question: 'สารคู่ใดเป็นไอโซเมอร์โครงสร้าง',
    keyword: 'ไอโซเมอร์,ไอโซเมอร์โครงร่าง,ไอโซเมอร์โครงสร้าง',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-5_Q10_อ่อน',
    question: 'สารข้อใดไม่ใช่ไอโซเมอร์กับ',
    keyword: 'ไอโซเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q1_อ่อน',
    question:
      'การละลายจะเกิดขึ้นไม่ได้เมื่อความสัมพันธ์ของแรงยึดเหนี่ยวระหว่างอนุภาคของตัวละลายกับตัวทำละลาย และ แรงยึดเหนี่ยวระหว่างอนุภาคของตัวละลายหรือตัวทำละลาย เป็นอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,การละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q2_อ่อน',
    question: 'น้ำมันละลายได้ในตัวทำละลายใด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,การละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q3_อ่อน',
    question:
      'จุดเดือดและจุดหลอมเหลวของสารประกอบไฮโดรคาร์บอนเป็นอย่างไร เมื่อเทียบกับสารประกอบอินทรีย์ประเภทอื่นที่มีมวลโมเลกุลใกล้เคียงกัน ',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q4_อ่อน',
    question:
      'ตัวอย่างจุดเดือดและจุดหลอมเหลวของแอลเคน เป็นดังตาราง จุดเดือดมีความสัมพันธ์กับจำนวนอะตอมของคาร์บอนอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q5_อ่อน',
    question:
      'ตัวอย่างจุดเดือดและจุดหลอมเหลวของแอลเคน เป็นดังตาราง จุดเดือดมีความสัมพันธ์กับจำนวนอะตอมของคาร์บอนอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q6_อ่อน',
    question: 'แอลเคนแบบโซ่ตรงหรือโซ่กิ่งมีจุดเดือดต่ำกว่า เมื่อมีจำนวนอะตอมคาร์บอนเท่ากัน',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,สารประกอบไฮโดรคาร์บอน,จุดเดือด,จุดหลอมเหลว',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q7_อ่อน',
    question:
      'สารประกอบอินทรีย์ที่มี O เป็นองค์ประกอบ จะส่งผลต่อความมีขั้วของโมเลกุลอย่างไรเมื่อเทียบกับสารประกอบไฮโดรคาร์บอน',
    keyword: 'สมบัติ,สารประกอบอินทรีย์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q8_อ่อน',
    question: 'จากการทดลอง ดูความสามารถในการละลายได้ในน้ำของแอลกอฮอล์จากอะไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,การละลายในน้ำ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q9_อ่อน',
    question: 'propan-1-ol  butan-1-ol และ pentan-1-ol สารใดละลายน้ำได้ดีที่สุด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,การละลายในน้ำ',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q10_อ่อน',
    question: 'propan-2-one มีจุดเดือดสูงกว่าหรือต่ำกว่า propan-2-ol ',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,จุดเดือด',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q11_อ่อน',
    question: 'สารประกอบอินทรีย์ที่มี N เป็นองค์ประกอบ เป็นสารมีขั้วหรือไม่มีขั้ยว',
    keyword: 'สมบัติ,สารประกอบอินทรีย์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q12_อ่อน',
    question: 'แนวโน้มความสัมพันธ์ระหว่างจุดเดือดกับจำนวนอะตอมคาร์บอนของเอมีนและเอไมด์ เป็นอย่างไร',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,จุดเดือด',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q13_อ่อน',
    question: 'สารในข้อใดมีจุดเดือดสูงที่สุด',
    keyword: 'สมบัติ,สารประกอบอินทรีย์,จุดเดือด',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-6_Q14_อ่อน',
    question:
      'สารในข้อใดมีแรงยึดเหนี่ยวระหว่างโมเลกุลทั้งแรงแผ่กระจายลอนดอน แรงระหว่างขั้ว และพันธะไฮโดรเจน',
    keyword: 'สมบัติ,สารประกอบอินทรีย์',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q1_อ่อน',
    question: 'ข้อใดกล่าวถึงปฏิกิริยาการเผาไหม้ไม่ได้ถูกต้อง',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q2_อ่อน',
    question: 'สารข้อใดที่ไม่ใช่ผลิตภัณฑ์จากปฏิกิริยาการเผาไหม้อย่างสมบูรณ์',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q3_อ่อน',
    question: 'การเผาไหม้อย่างสมบูรณ์ของ C2H6 จำนวน 2 โมล ต้องใช้ O2 กี่โมล',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q4_อ่อน',
    question: 'เชื้อเพลิงชนิดใดให้เขม่ามากกว่า',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q5_อ่อน',
    question: 'สารชนิดใดให้เขม่ามากที่สุด',
    keyword: 'สารประกอบอินทรีย์,ปฏิกิริยาการเผาไหม้',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q6_อ่อน',
    question:
      'เมื่อเติมสารประกอบไฮโดรคาร์บอนบางชนิดลงในสารละลายโบรมีน ได้ผลดังตาราง Hexane ฟอกจางสีโบรมีนในภาวะใดได้บ้าง',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q7_อ่อน',
    question:
      'เมื่อเติมสารประกอบไฮโดรคาร์บอนบางชนิดลงในสารละลายโบรมีน ได้ผลดังตาราง สารใดที่ฟอกจากสีสารละลายโบรมีนได้ต่างจากข้ออื่น',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q8_อ่อน',
    question: 'เมื่อนำโพรเพนมาทำปฏิกิริยากับโบรมีนในที่สว่างอาจได้ผลิตภัณฑ์ในข้อใด ',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q9_อ่อน',
    question:
      'เมื่อเติมสารประกอบไฮโดรคาร์บอนบางชนิดลงในสารละลายโบรมีน ได้ผลดังตาราง สารใดที่ไม่ฟอกจากสีสารละลายโบรมีนทั้งในที่มืดและที่สว่าง',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q10_อ่อน',
    question:
      'ข้อใดไม่ใช่การเปลี่ยนแปลงที่เกิดขึ้น เมื่อสารประกอบไฮโดรคาร์บอนเกิดปฏิกิริยาฟอกจางสี KMnO4',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q11_อ่อน',
    question: 'สารใดที่ฟอกจากสีสารละลาย โพแทสเซียมเปอร์แมงกาเนตได้',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 12-7_Q12_อ่อน',
    question: 'ตะกอบสีน้ำตาลที่เกิดจากการฟอกจางสี KMnO4 ของแอลคีนคือสารใด',
    keyword: 'สารประกอบอินทรีย์,การฟอกจางสี',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q1_ธรรมดา',
    question: 'ข้อใดคือความหมายของพอลิเมอร์',
    keyword: 'พอลิเมอร์,พันธะโคเวเลนต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q2_ธรรมดา',
    question: 'ข้อใดคือความหมายของมอนอเมอร์',
    keyword: 'พอลิเมอร์,พันธะโคเวเลนต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q3_ธรรมดา',
    question: 'ข้าวคือพอลิเมอร์ใช่หรือไม่ เพราะหตูใด',
    keyword: 'พอลิเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q4_ธรรมดา',
    question: 'ข้อใดคือสูตรโครงสร้างของพลาสติก',
    keyword: 'พอลิเมอร์,พันธะโคเวเลนต์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q5_ธรรมดา',
    question: 'สารใดไม่ละลายในน้ำ',
    keyword: 'พอลิเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q6_ธรรมดา',
    question: 'ข้อใดคือมอนอเมอร์',
    keyword: 'สารมอนอเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q7_ธรรมดา',
    question: 'ข้อใดไม่ใช่สารพอลิเมอร์',
    keyword: 'พอลิเมอร์,PVC',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q8_ธรรมดา',
    question: 'พอลิเมอร์ที่มีขนาดโมเลกุลใหญ่กว่ามอนอเมอร์ ซึ่งส่งผลให้สมบัติอะไรแตกต่างกันบ้าง',
    keyword: 'พอลิเมอร์,ตัวทำละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q9_ธรรมดา',
    question: 'ข้อใดไม่ถูกต้อง',
    keyword: 'พอลิเมอร์,ตัวทำละลาย',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-1_Q10_ธรรมดา',
    question: 'ขนมสายไหม ละลายน้ำได้ดีกว่า สำลี เพราะเหตุใด',
    keyword: 'พอลิเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q1_ธรรมดา',
    question: 'ข้อใดถูกต้อง',
    keyword: 'พอลิเมอร์,มอนอเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q2_ธรรมดา',
    question: 'ปฏิกิริยาการเกิดพอลิเมอร์แบ่งเป็นกี่แบบ',
    keyword: 'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q3_ธรรมดา',
    question:
      'ข้อใดคือปฏิกิริยาการเกิดพอลิเมอร์ที่เปลี่ยนพันธะคู่ของมอนอเมอร์เป็นพันธะเดี่ยวที่เชื่อมระหว่างมอนอเมอร์',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q4_ธรรมดา',
    question:
      'องค์ประกอบของอะตอมในมอนอเมอร์และพอลิเมอร์ที่เกิดจากปฏิกิริยาการเกิดพอลิเมอร์แบบเติม เป็นอย่างไร',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q5_ธรรมดา',
    question: 'มอนอเมอร์ใดไม่สามารถเกิดปฏิกิริยาการเกิดพอลิเมอร์แบบเติมได้',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q6_ธรรมดา',
    question: 'มอนอเมอร์ใดสามารถเกิดปฏิกิริยาการเกิดพอลิเมอร์แบบเติมได้',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q7_ธรรมดา',
    question: 'ข้อใดคือพอลิเมอร์ที่ได้จากมอนอเมอร์',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q8_ธรรมดา',
    question: 'พอลิเมอร์นี้สามารถเกิดจากปฏิกิริยาการเกิดพอลิเมอร์แบบเติมได้หรือไม่',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q9_ธรรมดา',
    question: 'พอลิเมอร์นี้เกิดจากมอนอเมอร์ใด',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-2_Q10_ธรรมดา',
    question: 'พอลิเมอร์นี้เกิดจากปฏิกิริยาการเกิดพอลิเมอร์แบบเติมใช่หรือไม่',
    keyword:
      'พอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์,การเกิดพอลิเมอร์,ปฏิกิริยาการเกิดพอลิเมอร์แบบเติม',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q1_ธรรมดา',
    question: 'โครงสร้างของพอลิเมอร์มีผลสมบัติของพอลิเมอร์หรือไม่',
    keyword: 'พอลิเมอร์,โครงสร้าง,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q2_ธรรมดา',
    question: 'โครงสร้างของพอลิเมอร์แบ่งได้เป็นกี่แบบ',
    keyword: 'พอลิเมอร์,โครงสร้าง,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q3_ธรรมดา',
    question: 'ข้อใดคือพอลิเมอร์ที่เกิดจากมอนอเมอร์สร้างพันธะโคเวเลนต์ต่อกันเป็นโซ่ยาว',
    keyword: 'พอลิเมอร์,โครงสร้าง,แบบเส้น,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q4_ธรรมดา',
    question: 'ข้อใดคือพอลิเมอร์ที่มีพอลิเมอร์สายสั้นแตกแขนงเป็นกิ่งออกจากโซ่หลัก',
    keyword: 'พอลิเมอร์,โครงสร้าง,แบบเส้น,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q5_ธรรมดา',
    question:
      'ข้อใดคือพอลิเมอร์ที่มีการเชื่อมขวาง (crosslink) ระหว่างสายโซ่พอลิเมอร์ต่อเนื่องกันเป็นร่างแห ',
    keyword: 'พอลิเมอร์,โครงสร้าง,แบบเส้น,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q6_ธรรมดา',
    question: 'จากคลิป ชิ้นพอลิเมอร์ใดมีการอ่อนตัวหรือหลอมเหลวเมื่อได้รับความร้อน',
    keyword: 'พอลิเมอร์,โครงสร้าง,เทอร์มอพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q7_ธรรมดา',
    question: 'จากคลิป เมื่อลดอุณหภูมิลงหลอดพลาสติกมีการเปลี่ยนแปลงอย่างไร',
    keyword: 'พอลิเมอร์,โครงสร้าง,เทอร์มอพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q8_ธรรมดา',
    question:
      'ข้อใดคือพอลิเมอร์ที่อ่อนตัวหรือหลอมเหลวเมื่อได้รับความร้อน และแข็งตัวเมื่ออุณหภูมิลดลง',
    keyword: 'พอลิเมอร์,โครงสร้าง,เทอร์มอพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q9_ธรรมดา',
    question:
      'พอลิเมอร์ในข้อใดมีจุดหลอมเหลวต่ำที่สุด ถ้ามีมวลโมเลกุลใกล้เคียงกัน สังเคราะห์จากมอนอเมอร์ชนิดเดียวกัน',
    keyword: 'พอลิเมอร์,โครงสร้าง,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q10_ธรรมดา',
    question:
      'พอลิเมอร์ในข้อใดมีความหนาแน่นมากที่สุด ถ้ามีมวลโมเลกุลใกล้เคียงกัน สังเคราะห์จากมอนอเมอร์ชนิดเดียวกัน',
    keyword: 'พอลิเมอร์,โครงสร้าง,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q11_ธรรมดา',
    question:
      'พอลิเมอร์ในข้อใดมีความแข็งมากที่สุด ถ้ามีมวลโมเลกุลใกล้เคียงกัน สังเคราะห์จากมอนอเมอร์ชนิดเดียวกัน',
    keyword: 'พอลิเมอร์,โครงสร้าง,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-3_Q12_ธรรมดา',
    question:
      'พอลิเมอร์ในข้อใดมีความสามารถในการขึ้นรูปใหม่ต่างจากข้ออื่น ถ้ามีมวลโมเลกุลใกล้เคียงกัน สังเคราะห์จากมอนอเมอร์ชนิดเดียวกัน',
    keyword: 'พอลิเมอร์,โครงสร้าง,สมบัติ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q1_ธรรมดา',
    question: 'ข้อใดไม่ตรงกับความหมายของ สารเสริมสภาพพลาสติก ',
    keyword: 'พลาสติไซเซอร์,สารเสริมสภาพพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q2_ธรรมดา',
    question: 'ผลิตภัณฑ์ในข้อใดใส่สารพลาสติไซเซอร์',
    keyword: 'พลาสติไซเซอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q3_ธรรมดา',
    question: 'ข้อใดไม่ใช่ พลาสติไซเซอร์ ที่นิใช้ในอุตสาหกรรม',
    keyword: 'พลาสติไซเซอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q4_ธรรมดา',
    question: 'ข้อใดถูกต้อง',
    keyword: 'พลาสติไซเซอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q5_ธรรมดา',
    question: 'ข้อใดคือการทำให้ ยางพารา มีคุณสมบัติคงตัวและคืนรูปได้ดี',
    keyword: 'วัลคาไนเซชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q6_ธรรมดา',
    question: 'ข้อใดไม่ถูกต้อง',
    keyword: 'วัลคาไนเซชัน',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q7_ธรรมดา',
    question:
      'เซลลูโลส ไม่สามารถหลอมได้ แต่เซลลูโลสแอซีเตต สามารถหลอมขึ้นรูปเป็นแผ่นได้ เนื่องจากสาเหตุใด',
    keyword: 'การปรับเปลี่ยนโครงสร้างพอลิเมอร์,เซลลูโลส',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q8_ธรรมดา',
    question: 'ปฏิกิริยาใด เกี่ยวข้องกับการเปลี่ยน ไคติน ไปเป็น ไคโตซาน',
    keyword: 'การปรับเปลี่ยนโครงสร้างพอลิเมอร์,ไคติน ไคโตซาน',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q9_ธรรมดา',
    question: 'เมื่อปรับเปลี่ยนโครงสร้างของพอลิเมอร์แล้ว สารในข้อใด ละลายน้ำได้ดี',
    keyword: 'การปรับเปลี่ยนโครงสร้างพอลิเมอร์,PVA',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-4_Q10_ธรรมดา',
    question: 'PVA ได้จากปฏิกิริยาไฮโดรลิซิสของพอลิไวนิแอซีเตต ในสภาวะใด',
    keyword: 'การปรับเปลี่ยนโครงสร้างพอลิเมอร์,PVA',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q1_ธรรมดา',
    question: 'ข้อใดคือพอลิเมอร์ ที่ย่อยสลายตามธรรมชาติได้เอง',
    keyword: 'พอลิเมอร์',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q2_ธรรมดา',
    question: 'การเผาขยะพอลิเมอร์ ก่อให้เกิดสาเหตุใด',
    keyword: 'ปัญหาจากขยะพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q3_ธรรมดา',
    question: 'การเผาพลาสติกหรือยาง อาจก่อให้เกิดสารพิษใด',
    keyword: 'ปัญหาจากขยะพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q4_ธรรมดา',
    question: 'ข้อใดไม่ใช่แนวทางการลดปัญหาจากขยะพลาสติก',
    keyword: 'ปัญหาจากขยะพลาสติก',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q5_ธรรมดา',
    question: 'ข้อใดไม่ใช่สาเหตุจากการนำพลาสติกมาหลอมใช้ใหม่',
    keyword: 'ภาวะโลกร้อน',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q6_ธรรมดา',
    question: 'ข้อใดถูกต้อง',
    keyword: 'การลดการใช้,การใช้ซ้ำ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q7_ธรรมดา',
    question: 'ข้อใดคือการแก้ปัญหาถูกต้อง',
    keyword: 'คัดแยกขยะ',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q8_ธรรมดา',
    question: 'ข้อใดคือการรีไซเคิล',
    keyword: 'รีไซเคิล,recycle',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q9_ธรรมดา',
    question: 'ข้อใดไม่ถูกต้อง',
    keyword: 'PVC,recycle',
    max_score: 1
  },
  {
    intentname: 'Chapter 13-5_Q10_ธรรมดา',
    question: 'ข้อใดคือพอลิเมอร์ที่ย่อยสลายทางชีวภาพได้',
    keyword: 'พอลิเมอร์ที่ย่อยสลายทางชีวภาพ',
    max_score: 1
  }
]



// WEBPACK FOOTER //
// ./src/assets/js/atomicData.js